"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key2, value) => key2 in obj ? __defProp(obj, key2, { enumerable: true, configurable: true, writable: true, value }) : obj[key2] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from2, except, desc) => {
  if (from2 && typeof from2 === "object" || typeof from2 === "function") {
    for (let key2 of __getOwnPropNames(from2))
      if (!__hasOwnProp.call(to, key2) && key2 !== except)
        __defProp(to, key2, { get: () => from2[key2], enumerable: !(desc = __getOwnPropDesc(from2, key2)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// node_modules/lodash/isArray.js
var require_isArray = __commonJS({
  "node_modules/lodash/isArray.js"(exports, module2) {
    var isArray = Array.isArray;
    module2.exports = isArray;
  }
});

// node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "node_modules/lodash/_freeGlobal.js"(exports, module2) {
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module2.exports = freeGlobal;
  }
});

// node_modules/lodash/_root.js
var require_root = __commonJS({
  "node_modules/lodash/_root.js"(exports, module2) {
    var freeGlobal = require_freeGlobal();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    module2.exports = root;
  }
});

// node_modules/lodash/_Symbol.js
var require_Symbol = __commonJS({
  "node_modules/lodash/_Symbol.js"(exports, module2) {
    var root = require_root();
    var Symbol2 = root.Symbol;
    module2.exports = Symbol2;
  }
});

// node_modules/lodash/_getRawTag.js
var require_getRawTag = __commonJS({
  "node_modules/lodash/_getRawTag.js"(exports, module2) {
    var Symbol2 = require_Symbol();
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    var nativeObjectToString = objectProto.toString;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function getRawTag(value) {
      var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    module2.exports = getRawTag;
  }
});

// node_modules/lodash/_objectToString.js
var require_objectToString = __commonJS({
  "node_modules/lodash/_objectToString.js"(exports, module2) {
    var objectProto = Object.prototype;
    var nativeObjectToString = objectProto.toString;
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    module2.exports = objectToString;
  }
});

// node_modules/lodash/_baseGetTag.js
var require_baseGetTag = __commonJS({
  "node_modules/lodash/_baseGetTag.js"(exports, module2) {
    var Symbol2 = require_Symbol();
    var getRawTag = require_getRawTag();
    var objectToString = require_objectToString();
    var nullTag = "[object Null]";
    var undefinedTag = "[object Undefined]";
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    module2.exports = baseGetTag;
  }
});

// node_modules/lodash/isObjectLike.js
var require_isObjectLike = __commonJS({
  "node_modules/lodash/isObjectLike.js"(exports, module2) {
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    module2.exports = isObjectLike;
  }
});

// node_modules/lodash/isSymbol.js
var require_isSymbol = __commonJS({
  "node_modules/lodash/isSymbol.js"(exports, module2) {
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var symbolTag = "[object Symbol]";
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }
    module2.exports = isSymbol;
  }
});

// node_modules/lodash/_isKey.js
var require_isKey = __commonJS({
  "node_modules/lodash/_isKey.js"(exports, module2) {
    var isArray = require_isArray();
    var isSymbol = require_isSymbol();
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
    var reIsPlainProp = /^\w*$/;
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
    }
    module2.exports = isKey;
  }
});

// node_modules/lodash/isObject.js
var require_isObject = __commonJS({
  "node_modules/lodash/isObject.js"(exports, module2) {
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    module2.exports = isObject;
  }
});

// node_modules/lodash/isFunction.js
var require_isFunction = __commonJS({
  "node_modules/lodash/isFunction.js"(exports, module2) {
    var baseGetTag = require_baseGetTag();
    var isObject = require_isObject();
    var asyncTag = "[object AsyncFunction]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var proxyTag = "[object Proxy]";
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    module2.exports = isFunction;
  }
});

// node_modules/lodash/_coreJsData.js
var require_coreJsData = __commonJS({
  "node_modules/lodash/_coreJsData.js"(exports, module2) {
    var root = require_root();
    var coreJsData = root["__core-js_shared__"];
    module2.exports = coreJsData;
  }
});

// node_modules/lodash/_isMasked.js
var require_isMasked = __commonJS({
  "node_modules/lodash/_isMasked.js"(exports, module2) {
    var coreJsData = require_coreJsData();
    var maskSrcKey = function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    module2.exports = isMasked;
  }
});

// node_modules/lodash/_toSource.js
var require_toSource = __commonJS({
  "node_modules/lodash/_toSource.js"(exports, module2) {
    var funcProto = Function.prototype;
    var funcToString = funcProto.toString;
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    module2.exports = toSource;
  }
});

// node_modules/lodash/_baseIsNative.js
var require_baseIsNative = __commonJS({
  "node_modules/lodash/_baseIsNative.js"(exports, module2) {
    var isFunction = require_isFunction();
    var isMasked = require_isMasked();
    var isObject = require_isObject();
    var toSource = require_toSource();
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var funcToString = funcProto.toString;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    module2.exports = baseIsNative;
  }
});

// node_modules/lodash/_getValue.js
var require_getValue = __commonJS({
  "node_modules/lodash/_getValue.js"(exports, module2) {
    function getValue(object, key2) {
      return object == null ? void 0 : object[key2];
    }
    module2.exports = getValue;
  }
});

// node_modules/lodash/_getNative.js
var require_getNative = __commonJS({
  "node_modules/lodash/_getNative.js"(exports, module2) {
    var baseIsNative = require_baseIsNative();
    var getValue = require_getValue();
    function getNative(object, key2) {
      var value = getValue(object, key2);
      return baseIsNative(value) ? value : void 0;
    }
    module2.exports = getNative;
  }
});

// node_modules/lodash/_nativeCreate.js
var require_nativeCreate = __commonJS({
  "node_modules/lodash/_nativeCreate.js"(exports, module2) {
    var getNative = require_getNative();
    var nativeCreate = getNative(Object, "create");
    module2.exports = nativeCreate;
  }
});

// node_modules/lodash/_hashClear.js
var require_hashClear = __commonJS({
  "node_modules/lodash/_hashClear.js"(exports, module2) {
    var nativeCreate = require_nativeCreate();
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    module2.exports = hashClear;
  }
});

// node_modules/lodash/_hashDelete.js
var require_hashDelete = __commonJS({
  "node_modules/lodash/_hashDelete.js"(exports, module2) {
    function hashDelete(key2) {
      var result = this.has(key2) && delete this.__data__[key2];
      this.size -= result ? 1 : 0;
      return result;
    }
    module2.exports = hashDelete;
  }
});

// node_modules/lodash/_hashGet.js
var require_hashGet = __commonJS({
  "node_modules/lodash/_hashGet.js"(exports, module2) {
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    function hashGet(key2) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key2];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty2.call(data, key2) ? data[key2] : void 0;
    }
    module2.exports = hashGet;
  }
});

// node_modules/lodash/_hashHas.js
var require_hashHas = __commonJS({
  "node_modules/lodash/_hashHas.js"(exports, module2) {
    var nativeCreate = require_nativeCreate();
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    function hashHas(key2) {
      var data = this.__data__;
      return nativeCreate ? data[key2] !== void 0 : hasOwnProperty2.call(data, key2);
    }
    module2.exports = hashHas;
  }
});

// node_modules/lodash/_hashSet.js
var require_hashSet = __commonJS({
  "node_modules/lodash/_hashSet.js"(exports, module2) {
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    function hashSet(key2, value) {
      var data = this.__data__;
      this.size += this.has(key2) ? 0 : 1;
      data[key2] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    module2.exports = hashSet;
  }
});

// node_modules/lodash/_Hash.js
var require_Hash = __commonJS({
  "node_modules/lodash/_Hash.js"(exports, module2) {
    var hashClear = require_hashClear();
    var hashDelete = require_hashDelete();
    var hashGet = require_hashGet();
    var hashHas = require_hashHas();
    var hashSet = require_hashSet();
    function Hash(entries) {
      var index = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length2) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    module2.exports = Hash;
  }
});

// node_modules/lodash/_listCacheClear.js
var require_listCacheClear = __commonJS({
  "node_modules/lodash/_listCacheClear.js"(exports, module2) {
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    module2.exports = listCacheClear;
  }
});

// node_modules/lodash/eq.js
var require_eq = __commonJS({
  "node_modules/lodash/eq.js"(exports, module2) {
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    module2.exports = eq;
  }
});

// node_modules/lodash/_assocIndexOf.js
var require_assocIndexOf = __commonJS({
  "node_modules/lodash/_assocIndexOf.js"(exports, module2) {
    var eq = require_eq();
    function assocIndexOf(array, key2) {
      var length2 = array.length;
      while (length2--) {
        if (eq(array[length2][0], key2)) {
          return length2;
        }
      }
      return -1;
    }
    module2.exports = assocIndexOf;
  }
});

// node_modules/lodash/_listCacheDelete.js
var require_listCacheDelete = __commonJS({
  "node_modules/lodash/_listCacheDelete.js"(exports, module2) {
    var assocIndexOf = require_assocIndexOf();
    var arrayProto = Array.prototype;
    var splice = arrayProto.splice;
    function listCacheDelete(key2) {
      var data = this.__data__, index = assocIndexOf(data, key2);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }
    module2.exports = listCacheDelete;
  }
});

// node_modules/lodash/_listCacheGet.js
var require_listCacheGet = __commonJS({
  "node_modules/lodash/_listCacheGet.js"(exports, module2) {
    var assocIndexOf = require_assocIndexOf();
    function listCacheGet(key2) {
      var data = this.__data__, index = assocIndexOf(data, key2);
      return index < 0 ? void 0 : data[index][1];
    }
    module2.exports = listCacheGet;
  }
});

// node_modules/lodash/_listCacheHas.js
var require_listCacheHas = __commonJS({
  "node_modules/lodash/_listCacheHas.js"(exports, module2) {
    var assocIndexOf = require_assocIndexOf();
    function listCacheHas(key2) {
      return assocIndexOf(this.__data__, key2) > -1;
    }
    module2.exports = listCacheHas;
  }
});

// node_modules/lodash/_listCacheSet.js
var require_listCacheSet = __commonJS({
  "node_modules/lodash/_listCacheSet.js"(exports, module2) {
    var assocIndexOf = require_assocIndexOf();
    function listCacheSet(key2, value) {
      var data = this.__data__, index = assocIndexOf(data, key2);
      if (index < 0) {
        ++this.size;
        data.push([key2, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    module2.exports = listCacheSet;
  }
});

// node_modules/lodash/_ListCache.js
var require_ListCache = __commonJS({
  "node_modules/lodash/_ListCache.js"(exports, module2) {
    var listCacheClear = require_listCacheClear();
    var listCacheDelete = require_listCacheDelete();
    var listCacheGet = require_listCacheGet();
    var listCacheHas = require_listCacheHas();
    var listCacheSet = require_listCacheSet();
    function ListCache(entries) {
      var index = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length2) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    module2.exports = ListCache;
  }
});

// node_modules/lodash/_Map.js
var require_Map = __commonJS({
  "node_modules/lodash/_Map.js"(exports, module2) {
    var getNative = require_getNative();
    var root = require_root();
    var Map = getNative(root, "Map");
    module2.exports = Map;
  }
});

// node_modules/lodash/_mapCacheClear.js
var require_mapCacheClear = __commonJS({
  "node_modules/lodash/_mapCacheClear.js"(exports, module2) {
    var Hash = require_Hash();
    var ListCache = require_ListCache();
    var Map = require_Map();
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map || ListCache)(),
        "string": new Hash()
      };
    }
    module2.exports = mapCacheClear;
  }
});

// node_modules/lodash/_isKeyable.js
var require_isKeyable = __commonJS({
  "node_modules/lodash/_isKeyable.js"(exports, module2) {
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    module2.exports = isKeyable;
  }
});

// node_modules/lodash/_getMapData.js
var require_getMapData = __commonJS({
  "node_modules/lodash/_getMapData.js"(exports, module2) {
    var isKeyable = require_isKeyable();
    function getMapData(map, key2) {
      var data = map.__data__;
      return isKeyable(key2) ? data[typeof key2 == "string" ? "string" : "hash"] : data.map;
    }
    module2.exports = getMapData;
  }
});

// node_modules/lodash/_mapCacheDelete.js
var require_mapCacheDelete = __commonJS({
  "node_modules/lodash/_mapCacheDelete.js"(exports, module2) {
    var getMapData = require_getMapData();
    function mapCacheDelete(key2) {
      var result = getMapData(this, key2)["delete"](key2);
      this.size -= result ? 1 : 0;
      return result;
    }
    module2.exports = mapCacheDelete;
  }
});

// node_modules/lodash/_mapCacheGet.js
var require_mapCacheGet = __commonJS({
  "node_modules/lodash/_mapCacheGet.js"(exports, module2) {
    var getMapData = require_getMapData();
    function mapCacheGet(key2) {
      return getMapData(this, key2).get(key2);
    }
    module2.exports = mapCacheGet;
  }
});

// node_modules/lodash/_mapCacheHas.js
var require_mapCacheHas = __commonJS({
  "node_modules/lodash/_mapCacheHas.js"(exports, module2) {
    var getMapData = require_getMapData();
    function mapCacheHas(key2) {
      return getMapData(this, key2).has(key2);
    }
    module2.exports = mapCacheHas;
  }
});

// node_modules/lodash/_mapCacheSet.js
var require_mapCacheSet = __commonJS({
  "node_modules/lodash/_mapCacheSet.js"(exports, module2) {
    var getMapData = require_getMapData();
    function mapCacheSet(key2, value) {
      var data = getMapData(this, key2), size = data.size;
      data.set(key2, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }
    module2.exports = mapCacheSet;
  }
});

// node_modules/lodash/_MapCache.js
var require_MapCache = __commonJS({
  "node_modules/lodash/_MapCache.js"(exports, module2) {
    var mapCacheClear = require_mapCacheClear();
    var mapCacheDelete = require_mapCacheDelete();
    var mapCacheGet = require_mapCacheGet();
    var mapCacheHas = require_mapCacheHas();
    var mapCacheSet = require_mapCacheSet();
    function MapCache(entries) {
      var index = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length2) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    module2.exports = MapCache;
  }
});

// node_modules/lodash/memoize.js
var require_memoize = __commonJS({
  "node_modules/lodash/memoize.js"(exports, module2) {
    var MapCache = require_MapCache();
    var FUNC_ERROR_TEXT = "Expected a function";
    function memoize5(func, resolver) {
      if (typeof func != "function" || resolver != null && typeof resolver != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments, key2 = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key2)) {
          return cache.get(key2);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key2, result) || cache;
        return result;
      };
      memoized.cache = new (memoize5.Cache || MapCache)();
      return memoized;
    }
    memoize5.Cache = MapCache;
    module2.exports = memoize5;
  }
});

// node_modules/lodash/_memoizeCapped.js
var require_memoizeCapped = __commonJS({
  "node_modules/lodash/_memoizeCapped.js"(exports, module2) {
    var memoize5 = require_memoize();
    var MAX_MEMOIZE_SIZE = 500;
    function memoizeCapped(func) {
      var result = memoize5(func, function(key2) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key2;
      });
      var cache = result.cache;
      return result;
    }
    module2.exports = memoizeCapped;
  }
});

// node_modules/lodash/_stringToPath.js
var require_stringToPath = __commonJS({
  "node_modules/lodash/_stringToPath.js"(exports, module2) {
    var memoizeCapped = require_memoizeCapped();
    var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reEscapeChar = /\\(\\)?/g;
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46) {
        result.push("");
      }
      string.replace(rePropName, function(match2, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match2);
      });
      return result;
    });
    module2.exports = stringToPath;
  }
});

// node_modules/lodash/_arrayMap.js
var require_arrayMap = __commonJS({
  "node_modules/lodash/_arrayMap.js"(exports, module2) {
    function arrayMap(array, iteratee) {
      var index = -1, length2 = array == null ? 0 : array.length, result = Array(length2);
      while (++index < length2) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }
    module2.exports = arrayMap;
  }
});

// node_modules/lodash/_baseToString.js
var require_baseToString = __commonJS({
  "node_modules/lodash/_baseToString.js"(exports, module2) {
    var Symbol2 = require_Symbol();
    var arrayMap = require_arrayMap();
    var isArray = require_isArray();
    var isSymbol = require_isSymbol();
    var INFINITY = 1 / 0;
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
    var symbolToString = symbolProto ? symbolProto.toString : void 0;
    function baseToString(value) {
      if (typeof value == "string") {
        return value;
      }
      if (isArray(value)) {
        return arrayMap(value, baseToString) + "";
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : "";
      }
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    module2.exports = baseToString;
  }
});

// node_modules/lodash/toString.js
var require_toString = __commonJS({
  "node_modules/lodash/toString.js"(exports, module2) {
    var baseToString = require_baseToString();
    function toString(value) {
      return value == null ? "" : baseToString(value);
    }
    module2.exports = toString;
  }
});

// node_modules/lodash/_castPath.js
var require_castPath = __commonJS({
  "node_modules/lodash/_castPath.js"(exports, module2) {
    var isArray = require_isArray();
    var isKey = require_isKey();
    var stringToPath = require_stringToPath();
    var toString = require_toString();
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }
    module2.exports = castPath;
  }
});

// node_modules/lodash/_toKey.js
var require_toKey = __commonJS({
  "node_modules/lodash/_toKey.js"(exports, module2) {
    var isSymbol = require_isSymbol();
    var INFINITY = 1 / 0;
    function toKey(value) {
      if (typeof value == "string" || isSymbol(value)) {
        return value;
      }
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    module2.exports = toKey;
  }
});

// node_modules/lodash/_baseGet.js
var require_baseGet = __commonJS({
  "node_modules/lodash/_baseGet.js"(exports, module2) {
    var castPath = require_castPath();
    var toKey = require_toKey();
    function baseGet(object, path) {
      path = castPath(path, object);
      var index = 0, length2 = path.length;
      while (object != null && index < length2) {
        object = object[toKey(path[index++])];
      }
      return index && index == length2 ? object : void 0;
    }
    module2.exports = baseGet;
  }
});

// node_modules/lodash/_defineProperty.js
var require_defineProperty = __commonJS({
  "node_modules/lodash/_defineProperty.js"(exports, module2) {
    var getNative = require_getNative();
    var defineProperty = function() {
      try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
      } catch (e) {
      }
    }();
    module2.exports = defineProperty;
  }
});

// node_modules/lodash/_baseAssignValue.js
var require_baseAssignValue = __commonJS({
  "node_modules/lodash/_baseAssignValue.js"(exports, module2) {
    var defineProperty = require_defineProperty();
    function baseAssignValue(object, key2, value) {
      if (key2 == "__proto__" && defineProperty) {
        defineProperty(object, key2, {
          "configurable": true,
          "enumerable": true,
          "value": value,
          "writable": true
        });
      } else {
        object[key2] = value;
      }
    }
    module2.exports = baseAssignValue;
  }
});

// node_modules/lodash/_assignValue.js
var require_assignValue = __commonJS({
  "node_modules/lodash/_assignValue.js"(exports, module2) {
    var baseAssignValue = require_baseAssignValue();
    var eq = require_eq();
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    function assignValue(object, key2, value) {
      var objValue = object[key2];
      if (!(hasOwnProperty2.call(object, key2) && eq(objValue, value)) || value === void 0 && !(key2 in object)) {
        baseAssignValue(object, key2, value);
      }
    }
    module2.exports = assignValue;
  }
});

// node_modules/lodash/_isIndex.js
var require_isIndex = __commonJS({
  "node_modules/lodash/_isIndex.js"(exports, module2) {
    var MAX_SAFE_INTEGER = 9007199254740991;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    function isIndex(value, length2) {
      var type = typeof value;
      length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
      return !!length2 && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
    }
    module2.exports = isIndex;
  }
});

// node_modules/lodash/_baseSet.js
var require_baseSet = __commonJS({
  "node_modules/lodash/_baseSet.js"(exports, module2) {
    var assignValue = require_assignValue();
    var castPath = require_castPath();
    var isIndex = require_isIndex();
    var isObject = require_isObject();
    var toKey = require_toKey();
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);
      var index = -1, length2 = path.length, lastIndex = length2 - 1, nested = object;
      while (nested != null && ++index < length2) {
        var key2 = toKey(path[index]), newValue = value;
        if (key2 === "__proto__" || key2 === "constructor" || key2 === "prototype") {
          return object;
        }
        if (index != lastIndex) {
          var objValue = nested[key2];
          newValue = customizer ? customizer(objValue, key2, nested) : void 0;
          if (newValue === void 0) {
            newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
          }
        }
        assignValue(nested, key2, newValue);
        nested = nested[key2];
      }
      return object;
    }
    module2.exports = baseSet;
  }
});

// node_modules/lodash/_basePickBy.js
var require_basePickBy = __commonJS({
  "node_modules/lodash/_basePickBy.js"(exports, module2) {
    var baseGet = require_baseGet();
    var baseSet = require_baseSet();
    var castPath = require_castPath();
    function basePickBy(object, paths, predicate) {
      var index = -1, length2 = paths.length, result = {};
      while (++index < length2) {
        var path = paths[index], value = baseGet(object, path);
        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }
    module2.exports = basePickBy;
  }
});

// node_modules/lodash/_baseHasIn.js
var require_baseHasIn = __commonJS({
  "node_modules/lodash/_baseHasIn.js"(exports, module2) {
    function baseHasIn(object, key2) {
      return object != null && key2 in Object(object);
    }
    module2.exports = baseHasIn;
  }
});

// node_modules/lodash/_baseIsArguments.js
var require_baseIsArguments = __commonJS({
  "node_modules/lodash/_baseIsArguments.js"(exports, module2) {
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var argsTag = "[object Arguments]";
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    module2.exports = baseIsArguments;
  }
});

// node_modules/lodash/isArguments.js
var require_isArguments = __commonJS({
  "node_modules/lodash/isArguments.js"(exports, module2) {
    var baseIsArguments = require_baseIsArguments();
    var isObjectLike = require_isObjectLike();
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var isArguments = baseIsArguments(function() {
      return arguments;
    }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    module2.exports = isArguments;
  }
});

// node_modules/lodash/isLength.js
var require_isLength = __commonJS({
  "node_modules/lodash/isLength.js"(exports, module2) {
    var MAX_SAFE_INTEGER = 9007199254740991;
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    module2.exports = isLength;
  }
});

// node_modules/lodash/_hasPath.js
var require_hasPath = __commonJS({
  "node_modules/lodash/_hasPath.js"(exports, module2) {
    var castPath = require_castPath();
    var isArguments = require_isArguments();
    var isArray = require_isArray();
    var isIndex = require_isIndex();
    var isLength = require_isLength();
    var toKey = require_toKey();
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);
      var index = -1, length2 = path.length, result = false;
      while (++index < length2) {
        var key2 = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key2))) {
          break;
        }
        object = object[key2];
      }
      if (result || ++index != length2) {
        return result;
      }
      length2 = object == null ? 0 : object.length;
      return !!length2 && isLength(length2) && isIndex(key2, length2) && (isArray(object) || isArguments(object));
    }
    module2.exports = hasPath;
  }
});

// node_modules/lodash/hasIn.js
var require_hasIn = __commonJS({
  "node_modules/lodash/hasIn.js"(exports, module2) {
    var baseHasIn = require_baseHasIn();
    var hasPath = require_hasPath();
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }
    module2.exports = hasIn;
  }
});

// node_modules/lodash/_basePick.js
var require_basePick = __commonJS({
  "node_modules/lodash/_basePick.js"(exports, module2) {
    var basePickBy = require_basePickBy();
    var hasIn = require_hasIn();
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }
    module2.exports = basePick;
  }
});

// node_modules/lodash/_arrayPush.js
var require_arrayPush = __commonJS({
  "node_modules/lodash/_arrayPush.js"(exports, module2) {
    function arrayPush(array, values) {
      var index = -1, length2 = values.length, offset = array.length;
      while (++index < length2) {
        array[offset + index] = values[index];
      }
      return array;
    }
    module2.exports = arrayPush;
  }
});

// node_modules/lodash/_isFlattenable.js
var require_isFlattenable = __commonJS({
  "node_modules/lodash/_isFlattenable.js"(exports, module2) {
    var Symbol2 = require_Symbol();
    var isArguments = require_isArguments();
    var isArray = require_isArray();
    var spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : void 0;
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
    }
    module2.exports = isFlattenable;
  }
});

// node_modules/lodash/_baseFlatten.js
var require_baseFlatten = __commonJS({
  "node_modules/lodash/_baseFlatten.js"(exports, module2) {
    var arrayPush = require_arrayPush();
    var isFlattenable = require_isFlattenable();
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1, length2 = array.length;
      predicate || (predicate = isFlattenable);
      result || (result = []);
      while (++index < length2) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }
    module2.exports = baseFlatten;
  }
});

// node_modules/lodash/flatten.js
var require_flatten = __commonJS({
  "node_modules/lodash/flatten.js"(exports, module2) {
    var baseFlatten = require_baseFlatten();
    function flatten(array) {
      var length2 = array == null ? 0 : array.length;
      return length2 ? baseFlatten(array, 1) : [];
    }
    module2.exports = flatten;
  }
});

// node_modules/lodash/_apply.js
var require_apply = __commonJS({
  "node_modules/lodash/_apply.js"(exports, module2) {
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    module2.exports = apply;
  }
});

// node_modules/lodash/_overRest.js
var require_overRest = __commonJS({
  "node_modules/lodash/_overRest.js"(exports, module2) {
    var apply = require_apply();
    var nativeMax = Math.max;
    function overRest(func, start, transform) {
      start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
      return function() {
        var args = arguments, index = -1, length2 = nativeMax(args.length - start, 0), array = Array(length2);
        while (++index < length2) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }
    module2.exports = overRest;
  }
});

// node_modules/lodash/constant.js
var require_constant = __commonJS({
  "node_modules/lodash/constant.js"(exports, module2) {
    function constant(value) {
      return function() {
        return value;
      };
    }
    module2.exports = constant;
  }
});

// node_modules/lodash/identity.js
var require_identity = __commonJS({
  "node_modules/lodash/identity.js"(exports, module2) {
    function identity(value) {
      return value;
    }
    module2.exports = identity;
  }
});

// node_modules/lodash/_baseSetToString.js
var require_baseSetToString = __commonJS({
  "node_modules/lodash/_baseSetToString.js"(exports, module2) {
    var constant = require_constant();
    var defineProperty = require_defineProperty();
    var identity = require_identity();
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
      });
    };
    module2.exports = baseSetToString;
  }
});

// node_modules/lodash/_shortOut.js
var require_shortOut = __commonJS({
  "node_modules/lodash/_shortOut.js"(exports, module2) {
    var HOT_COUNT = 800;
    var HOT_SPAN = 16;
    var nativeNow = Date.now;
    function shortOut(func) {
      var count = 0, lastCalled = 0;
      return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(void 0, arguments);
      };
    }
    module2.exports = shortOut;
  }
});

// node_modules/lodash/_setToString.js
var require_setToString = __commonJS({
  "node_modules/lodash/_setToString.js"(exports, module2) {
    var baseSetToString = require_baseSetToString();
    var shortOut = require_shortOut();
    var setToString = shortOut(baseSetToString);
    module2.exports = setToString;
  }
});

// node_modules/lodash/_flatRest.js
var require_flatRest = __commonJS({
  "node_modules/lodash/_flatRest.js"(exports, module2) {
    var flatten = require_flatten();
    var overRest = require_overRest();
    var setToString = require_setToString();
    function flatRest(func) {
      return setToString(overRest(func, void 0, flatten), func + "");
    }
    module2.exports = flatRest;
  }
});

// node_modules/lodash/pick.js
var require_pick = __commonJS({
  "node_modules/lodash/pick.js"(exports, module2) {
    var basePick = require_basePick();
    var flatRest = require_flatRest();
    var pick3 = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });
    module2.exports = pick3;
  }
});

// node_modules/stop-media-stream/index.js
var require_stop_media_stream = __commonJS({
  "node_modules/stop-media-stream/index.js"(exports, module2) {
    function stopAndRemoveTrack(mediaStream) {
      return function(track) {
        track.stop();
        mediaStream.removeTrack(track);
      };
    }
    function stopMediaStream4(mediaStream) {
      if (!mediaStream) {
        return;
      }
      mediaStream.getTracks().forEach(stopAndRemoveTrack(mediaStream));
    }
    module2.exports = stopMediaStream4;
  }
});

// node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object) {
          if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment3 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment3;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// node_modules/react-is/index.js
var require_react_is = __commonJS({
  "node_modules/react-is/index.js"(exports, module2) {
    "use strict";
    if (false) {
      module2.exports = null;
    } else {
      module2.exports = require_react_is_development();
    }
  }
});

// node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var require_hoist_non_react_statics_cjs = __commonJS({
  "node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js"(exports, module2) {
    "use strict";
    var reactIs = require_react_is();
    var REACT_STATICS = {
      childContextTypes: true,
      contextType: true,
      contextTypes: true,
      defaultProps: true,
      displayName: true,
      getDefaultProps: true,
      getDerivedStateFromError: true,
      getDerivedStateFromProps: true,
      mixins: true,
      propTypes: true,
      type: true
    };
    var KNOWN_STATICS = {
      name: true,
      length: true,
      prototype: true,
      caller: true,
      callee: true,
      arguments: true,
      arity: true
    };
    var FORWARD_REF_STATICS = {
      "$$typeof": true,
      render: true,
      defaultProps: true,
      displayName: true,
      propTypes: true
    };
    var MEMO_STATICS = {
      "$$typeof": true,
      compare: true,
      defaultProps: true,
      displayName: true,
      propTypes: true,
      type: true
    };
    var TYPE_STATICS = {};
    TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
    TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
    function getStatics(component) {
      if (reactIs.isMemo(component)) {
        return MEMO_STATICS;
      }
      return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
    }
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = Object.prototype;
    function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
      if (typeof sourceComponent !== "string") {
        if (objectPrototype) {
          var inheritedComponent = getPrototypeOf(sourceComponent);
          if (inheritedComponent && inheritedComponent !== objectPrototype) {
            hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
          }
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) {
          keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for (var i = 0; i < keys.length; ++i) {
          var key2 = keys[i];
          if (!KNOWN_STATICS[key2] && !(blacklist && blacklist[key2]) && !(sourceStatics && sourceStatics[key2]) && !(targetStatics && targetStatics[key2])) {
            var descriptor = getOwnPropertyDescriptor(sourceComponent, key2);
            try {
              defineProperty(targetComponent, key2, descriptor);
            } catch (e) {
            }
          }
        }
      }
      return targetComponent;
    }
    module2.exports = hoistNonReactStatics;
  }
});

// node_modules/lodash/now.js
var require_now = __commonJS({
  "node_modules/lodash/now.js"(exports, module2) {
    var root = require_root();
    var now = function() {
      return root.Date.now();
    };
    module2.exports = now;
  }
});

// node_modules/lodash/_trimmedEndIndex.js
var require_trimmedEndIndex = __commonJS({
  "node_modules/lodash/_trimmedEndIndex.js"(exports, module2) {
    var reWhitespace = /\s/;
    function trimmedEndIndex(string) {
      var index = string.length;
      while (index-- && reWhitespace.test(string.charAt(index))) {
      }
      return index;
    }
    module2.exports = trimmedEndIndex;
  }
});

// node_modules/lodash/_baseTrim.js
var require_baseTrim = __commonJS({
  "node_modules/lodash/_baseTrim.js"(exports, module2) {
    var trimmedEndIndex = require_trimmedEndIndex();
    var reTrimStart = /^\s+/;
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    module2.exports = baseTrim;
  }
});

// node_modules/lodash/toNumber.js
var require_toNumber = __commonJS({
  "node_modules/lodash/toNumber.js"(exports, module2) {
    var baseTrim = require_baseTrim();
    var isObject = require_isObject();
    var isSymbol = require_isSymbol();
    var NAN = 0 / 0;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module2.exports = toNumber;
  }
});

// node_modules/lodash/debounce.js
var require_debounce = __commonJS({
  "node_modules/lodash/debounce.js"(exports, module2) {
    var isObject = require_isObject();
    var now = require_now();
    var toNumber = require_toNumber();
    var FUNC_ERROR_TEXT = "Expected a function";
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    function debounce2(func, wait, options) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now());
      }
      function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    module2.exports = debounce2;
  }
});

// node_modules/lodash/_baseRest.js
var require_baseRest = __commonJS({
  "node_modules/lodash/_baseRest.js"(exports, module2) {
    var identity = require_identity();
    var overRest = require_overRest();
    var setToString = require_setToString();
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + "");
    }
    module2.exports = baseRest;
  }
});

// node_modules/lodash/_WeakMap.js
var require_WeakMap = __commonJS({
  "node_modules/lodash/_WeakMap.js"(exports, module2) {
    var getNative = require_getNative();
    var root = require_root();
    var WeakMap2 = getNative(root, "WeakMap");
    module2.exports = WeakMap2;
  }
});

// node_modules/lodash/_metaMap.js
var require_metaMap = __commonJS({
  "node_modules/lodash/_metaMap.js"(exports, module2) {
    var WeakMap2 = require_WeakMap();
    var metaMap = WeakMap2 && new WeakMap2();
    module2.exports = metaMap;
  }
});

// node_modules/lodash/_baseSetData.js
var require_baseSetData = __commonJS({
  "node_modules/lodash/_baseSetData.js"(exports, module2) {
    var identity = require_identity();
    var metaMap = require_metaMap();
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };
    module2.exports = baseSetData;
  }
});

// node_modules/lodash/_baseCreate.js
var require_baseCreate = __commonJS({
  "node_modules/lodash/_baseCreate.js"(exports, module2) {
    var isObject = require_isObject();
    var objectCreate = Object.create;
    var baseCreate = function() {
      function object() {
      }
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object();
        object.prototype = void 0;
        return result;
      };
    }();
    module2.exports = baseCreate;
  }
});

// node_modules/lodash/_createCtor.js
var require_createCtor = __commonJS({
  "node_modules/lodash/_createCtor.js"(exports, module2) {
    var baseCreate = require_baseCreate();
    var isObject = require_isObject();
    function createCtor(Ctor) {
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0:
            return new Ctor();
          case 1:
            return new Ctor(args[0]);
          case 2:
            return new Ctor(args[0], args[1]);
          case 3:
            return new Ctor(args[0], args[1], args[2]);
          case 4:
            return new Ctor(args[0], args[1], args[2], args[3]);
          case 5:
            return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6:
            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7:
            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        return isObject(result) ? result : thisBinding;
      };
    }
    module2.exports = createCtor;
  }
});

// node_modules/lodash/_createBind.js
var require_createBind = __commonJS({
  "node_modules/lodash/_createBind.js"(exports, module2) {
    var createCtor = require_createCtor();
    var root = require_root();
    var WRAP_BIND_FLAG = 1;
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
      function wrapper() {
        var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }
    module2.exports = createBind;
  }
});

// node_modules/lodash/_composeArgs.js
var require_composeArgs = __commonJS({
  "node_modules/lodash/_composeArgs.js"(exports, module2) {
    var nativeMax = Math.max;
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }
    module2.exports = composeArgs;
  }
});

// node_modules/lodash/_composeArgsRight.js
var require_composeArgsRight = __commonJS({
  "node_modules/lodash/_composeArgsRight.js"(exports, module2) {
    var nativeMax = Math.max;
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }
    module2.exports = composeArgsRight;
  }
});

// node_modules/lodash/_countHolders.js
var require_countHolders = __commonJS({
  "node_modules/lodash/_countHolders.js"(exports, module2) {
    function countHolders(array, placeholder) {
      var length2 = array.length, result = 0;
      while (length2--) {
        if (array[length2] === placeholder) {
          ++result;
        }
      }
      return result;
    }
    module2.exports = countHolders;
  }
});

// node_modules/lodash/_baseLodash.js
var require_baseLodash = __commonJS({
  "node_modules/lodash/_baseLodash.js"(exports, module2) {
    function baseLodash() {
    }
    module2.exports = baseLodash;
  }
});

// node_modules/lodash/_LazyWrapper.js
var require_LazyWrapper = __commonJS({
  "node_modules/lodash/_LazyWrapper.js"(exports, module2) {
    var baseCreate = require_baseCreate();
    var baseLodash = require_baseLodash();
    var MAX_ARRAY_LENGTH = 4294967295;
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;
    module2.exports = LazyWrapper;
  }
});

// node_modules/lodash/noop.js
var require_noop = __commonJS({
  "node_modules/lodash/noop.js"(exports, module2) {
    function noop() {
    }
    module2.exports = noop;
  }
});

// node_modules/lodash/_getData.js
var require_getData = __commonJS({
  "node_modules/lodash/_getData.js"(exports, module2) {
    var metaMap = require_metaMap();
    var noop = require_noop();
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };
    module2.exports = getData;
  }
});

// node_modules/lodash/_realNames.js
var require_realNames = __commonJS({
  "node_modules/lodash/_realNames.js"(exports, module2) {
    var realNames = {};
    module2.exports = realNames;
  }
});

// node_modules/lodash/_getFuncName.js
var require_getFuncName = __commonJS({
  "node_modules/lodash/_getFuncName.js"(exports, module2) {
    var realNames = require_realNames();
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    function getFuncName(func) {
      var result = func.name + "", array = realNames[result], length2 = hasOwnProperty2.call(realNames, result) ? array.length : 0;
      while (length2--) {
        var data = array[length2], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }
    module2.exports = getFuncName;
  }
});

// node_modules/lodash/_LodashWrapper.js
var require_LodashWrapper = __commonJS({
  "node_modules/lodash/_LodashWrapper.js"(exports, module2) {
    var baseCreate = require_baseCreate();
    var baseLodash = require_baseLodash();
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = void 0;
    }
    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;
    module2.exports = LodashWrapper;
  }
});

// node_modules/lodash/_copyArray.js
var require_copyArray = __commonJS({
  "node_modules/lodash/_copyArray.js"(exports, module2) {
    function copyArray(source, array) {
      var index = -1, length2 = source.length;
      array || (array = Array(length2));
      while (++index < length2) {
        array[index] = source[index];
      }
      return array;
    }
    module2.exports = copyArray;
  }
});

// node_modules/lodash/_wrapperClone.js
var require_wrapperClone = __commonJS({
  "node_modules/lodash/_wrapperClone.js"(exports, module2) {
    var LazyWrapper = require_LazyWrapper();
    var LodashWrapper = require_LodashWrapper();
    var copyArray = require_copyArray();
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__ = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }
    module2.exports = wrapperClone;
  }
});

// node_modules/lodash/wrapperLodash.js
var require_wrapperLodash = __commonJS({
  "node_modules/lodash/wrapperLodash.js"(exports, module2) {
    var LazyWrapper = require_LazyWrapper();
    var LodashWrapper = require_LodashWrapper();
    var baseLodash = require_baseLodash();
    var isArray = require_isArray();
    var isObjectLike = require_isObjectLike();
    var wrapperClone = require_wrapperClone();
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty2.call(value, "__wrapped__")) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;
    module2.exports = lodash;
  }
});

// node_modules/lodash/_isLaziable.js
var require_isLaziable = __commonJS({
  "node_modules/lodash/_isLaziable.js"(exports, module2) {
    var LazyWrapper = require_LazyWrapper();
    var getData = require_getData();
    var getFuncName = require_getFuncName();
    var lodash = require_wrapperLodash();
    function isLaziable(func) {
      var funcName = getFuncName(func), other = lodash[funcName];
      if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }
    module2.exports = isLaziable;
  }
});

// node_modules/lodash/_setData.js
var require_setData = __commonJS({
  "node_modules/lodash/_setData.js"(exports, module2) {
    var baseSetData = require_baseSetData();
    var shortOut = require_shortOut();
    var setData = shortOut(baseSetData);
    module2.exports = setData;
  }
});

// node_modules/lodash/_getWrapDetails.js
var require_getWrapDetails = __commonJS({
  "node_modules/lodash/_getWrapDetails.js"(exports, module2) {
    var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/;
    var reSplitDetails = /,? & /;
    function getWrapDetails(source) {
      var match2 = source.match(reWrapDetails);
      return match2 ? match2[1].split(reSplitDetails) : [];
    }
    module2.exports = getWrapDetails;
  }
});

// node_modules/lodash/_insertWrapDetails.js
var require_insertWrapDetails = __commonJS({
  "node_modules/lodash/_insertWrapDetails.js"(exports, module2) {
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
    function insertWrapDetails(source, details) {
      var length2 = details.length;
      if (!length2) {
        return source;
      }
      var lastIndex = length2 - 1;
      details[lastIndex] = (length2 > 1 ? "& " : "") + details[lastIndex];
      details = details.join(length2 > 2 ? ", " : " ");
      return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
    }
    module2.exports = insertWrapDetails;
  }
});

// node_modules/lodash/_arrayEach.js
var require_arrayEach = __commonJS({
  "node_modules/lodash/_arrayEach.js"(exports, module2) {
    function arrayEach(array, iteratee) {
      var index = -1, length2 = array == null ? 0 : array.length;
      while (++index < length2) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }
    module2.exports = arrayEach;
  }
});

// node_modules/lodash/_baseFindIndex.js
var require_baseFindIndex = __commonJS({
  "node_modules/lodash/_baseFindIndex.js"(exports, module2) {
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length2 = array.length, index = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index-- : ++index < length2) {
        if (predicate(array[index], index, array)) {
          return index;
        }
      }
      return -1;
    }
    module2.exports = baseFindIndex;
  }
});

// node_modules/lodash/_baseIsNaN.js
var require_baseIsNaN = __commonJS({
  "node_modules/lodash/_baseIsNaN.js"(exports, module2) {
    function baseIsNaN(value) {
      return value !== value;
    }
    module2.exports = baseIsNaN;
  }
});

// node_modules/lodash/_strictIndexOf.js
var require_strictIndexOf = __commonJS({
  "node_modules/lodash/_strictIndexOf.js"(exports, module2) {
    function strictIndexOf(array, value, fromIndex) {
      var index = fromIndex - 1, length2 = array.length;
      while (++index < length2) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }
    module2.exports = strictIndexOf;
  }
});

// node_modules/lodash/_baseIndexOf.js
var require_baseIndexOf = __commonJS({
  "node_modules/lodash/_baseIndexOf.js"(exports, module2) {
    var baseFindIndex = require_baseFindIndex();
    var baseIsNaN = require_baseIsNaN();
    var strictIndexOf = require_strictIndexOf();
    function baseIndexOf(array, value, fromIndex) {
      return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    module2.exports = baseIndexOf;
  }
});

// node_modules/lodash/_arrayIncludes.js
var require_arrayIncludes = __commonJS({
  "node_modules/lodash/_arrayIncludes.js"(exports, module2) {
    var baseIndexOf = require_baseIndexOf();
    function arrayIncludes(array, value) {
      var length2 = array == null ? 0 : array.length;
      return !!length2 && baseIndexOf(array, value, 0) > -1;
    }
    module2.exports = arrayIncludes;
  }
});

// node_modules/lodash/_updateWrapDetails.js
var require_updateWrapDetails = __commonJS({
  "node_modules/lodash/_updateWrapDetails.js"(exports, module2) {
    var arrayEach = require_arrayEach();
    var arrayIncludes = require_arrayIncludes();
    var WRAP_BIND_FLAG = 1;
    var WRAP_BIND_KEY_FLAG = 2;
    var WRAP_CURRY_FLAG = 8;
    var WRAP_CURRY_RIGHT_FLAG = 16;
    var WRAP_PARTIAL_FLAG = 32;
    var WRAP_PARTIAL_RIGHT_FLAG = 64;
    var WRAP_ARY_FLAG = 128;
    var WRAP_REARG_FLAG = 256;
    var WRAP_FLIP_FLAG = 512;
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = "_." + pair[0];
        if (bitmask & pair[1] && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }
    module2.exports = updateWrapDetails;
  }
});

// node_modules/lodash/_setWrapToString.js
var require_setWrapToString = __commonJS({
  "node_modules/lodash/_setWrapToString.js"(exports, module2) {
    var getWrapDetails = require_getWrapDetails();
    var insertWrapDetails = require_insertWrapDetails();
    var setToString = require_setToString();
    var updateWrapDetails = require_updateWrapDetails();
    function setWrapToString(wrapper, reference, bitmask) {
      var source = reference + "";
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }
    module2.exports = setWrapToString;
  }
});

// node_modules/lodash/_createRecurry.js
var require_createRecurry = __commonJS({
  "node_modules/lodash/_createRecurry.js"(exports, module2) {
    var isLaziable = require_isLaziable();
    var setData = require_setData();
    var setWrapToString = require_setWrapToString();
    var WRAP_BIND_FLAG = 1;
    var WRAP_BIND_KEY_FLAG = 2;
    var WRAP_CURRY_BOUND_FLAG = 4;
    var WRAP_CURRY_FLAG = 8;
    var WRAP_PARTIAL_FLAG = 32;
    var WRAP_PARTIAL_RIGHT_FLAG = 64;
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : void 0, newHoldersRight = isCurry ? void 0 : holders, newPartials = isCurry ? partials : void 0, newPartialsRight = isCurry ? void 0 : partials;
      bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
      ];
      var result = wrapFunc.apply(void 0, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }
    module2.exports = createRecurry;
  }
});

// node_modules/lodash/_getHolder.js
var require_getHolder = __commonJS({
  "node_modules/lodash/_getHolder.js"(exports, module2) {
    function getHolder(func) {
      var object = func;
      return object.placeholder;
    }
    module2.exports = getHolder;
  }
});

// node_modules/lodash/_reorder.js
var require_reorder = __commonJS({
  "node_modules/lodash/_reorder.js"(exports, module2) {
    var copyArray = require_copyArray();
    var isIndex = require_isIndex();
    var nativeMin = Math.min;
    function reorder(array, indexes) {
      var arrLength = array.length, length2 = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
      while (length2--) {
        var index = indexes[length2];
        array[length2] = isIndex(index, arrLength) ? oldArray[index] : void 0;
      }
      return array;
    }
    module2.exports = reorder;
  }
});

// node_modules/lodash/_replaceHolders.js
var require_replaceHolders = __commonJS({
  "node_modules/lodash/_replaceHolders.js"(exports, module2) {
    var PLACEHOLDER = "__lodash_placeholder__";
    function replaceHolders(array, placeholder) {
      var index = -1, length2 = array.length, resIndex = 0, result = [];
      while (++index < length2) {
        var value = array[index];
        if (value === placeholder || value === PLACEHOLDER) {
          array[index] = PLACEHOLDER;
          result[resIndex++] = index;
        }
      }
      return result;
    }
    module2.exports = replaceHolders;
  }
});

// node_modules/lodash/_createHybrid.js
var require_createHybrid = __commonJS({
  "node_modules/lodash/_createHybrid.js"(exports, module2) {
    var composeArgs = require_composeArgs();
    var composeArgsRight = require_composeArgsRight();
    var countHolders = require_countHolders();
    var createCtor = require_createCtor();
    var createRecurry = require_createRecurry();
    var getHolder = require_getHolder();
    var reorder = require_reorder();
    var replaceHolders = require_replaceHolders();
    var root = require_root();
    var WRAP_BIND_FLAG = 1;
    var WRAP_BIND_KEY_FLAG = 2;
    var WRAP_CURRY_FLAG = 8;
    var WRAP_CURRY_RIGHT_FLAG = 16;
    var WRAP_ARY_FLAG = 128;
    var WRAP_FLIP_FLAG = 512;
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? void 0 : createCtor(func);
      function wrapper() {
        var length2 = arguments.length, args = Array(length2), index = length2;
        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length2 -= holdersCount;
        if (isCurried && length2 < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func,
            bitmask,
            createHybrid,
            wrapper.placeholder,
            thisArg,
            args,
            newHolders,
            argPos,
            ary,
            arity - length2
          );
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length2 = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length2 > 1) {
          args.reverse();
        }
        if (isAry && ary < length2) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }
    module2.exports = createHybrid;
  }
});

// node_modules/lodash/_createCurry.js
var require_createCurry = __commonJS({
  "node_modules/lodash/_createCurry.js"(exports, module2) {
    var apply = require_apply();
    var createCtor = require_createCtor();
    var createHybrid = require_createHybrid();
    var createRecurry = require_createRecurry();
    var getHolder = require_getHolder();
    var replaceHolders = require_replaceHolders();
    var root = require_root();
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);
      function wrapper() {
        var length2 = arguments.length, args = Array(length2), index = length2, placeholder = getHolder(wrapper);
        while (index--) {
          args[index] = arguments[index];
        }
        var holders = length2 < 3 && args[0] !== placeholder && args[length2 - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
        length2 -= holders.length;
        if (length2 < arity) {
          return createRecurry(
            func,
            bitmask,
            createHybrid,
            wrapper.placeholder,
            void 0,
            args,
            holders,
            void 0,
            void 0,
            arity - length2
          );
        }
        var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }
    module2.exports = createCurry;
  }
});

// node_modules/lodash/_createPartial.js
var require_createPartial = __commonJS({
  "node_modules/lodash/_createPartial.js"(exports, module2) {
    var apply = require_apply();
    var createCtor = require_createCtor();
    var root = require_root();
    var WRAP_BIND_FLAG = 1;
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
      function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }
    module2.exports = createPartial;
  }
});

// node_modules/lodash/_mergeData.js
var require_mergeData = __commonJS({
  "node_modules/lodash/_mergeData.js"(exports, module2) {
    var composeArgs = require_composeArgs();
    var composeArgsRight = require_composeArgsRight();
    var replaceHolders = require_replaceHolders();
    var PLACEHOLDER = "__lodash_placeholder__";
    var WRAP_BIND_FLAG = 1;
    var WRAP_BIND_KEY_FLAG = 2;
    var WRAP_CURRY_BOUND_FLAG = 4;
    var WRAP_CURRY_FLAG = 8;
    var WRAP_ARY_FLAG = 128;
    var WRAP_REARG_FLAG = 256;
    var nativeMin = Math.min;
    function mergeData(data, source) {
      var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
      var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
      if (!(isCommon || isCombo)) {
        return data;
      }
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      value = source[7];
      if (value) {
        data[7] = value;
      }
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      if (data[9] == null) {
        data[9] = source[9];
      }
      data[0] = source[0];
      data[1] = newBitmask;
      return data;
    }
    module2.exports = mergeData;
  }
});

// node_modules/lodash/toFinite.js
var require_toFinite = __commonJS({
  "node_modules/lodash/toFinite.js"(exports, module2) {
    var toNumber = require_toNumber();
    var INFINITY = 1 / 0;
    var MAX_INTEGER = 17976931348623157e292;
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }
    module2.exports = toFinite;
  }
});

// node_modules/lodash/toInteger.js
var require_toInteger = __commonJS({
  "node_modules/lodash/toInteger.js"(exports, module2) {
    var toFinite = require_toFinite();
    function toInteger(value) {
      var result = toFinite(value), remainder = result % 1;
      return result === result ? remainder ? result - remainder : result : 0;
    }
    module2.exports = toInteger;
  }
});

// node_modules/lodash/_createWrap.js
var require_createWrap = __commonJS({
  "node_modules/lodash/_createWrap.js"(exports, module2) {
    var baseSetData = require_baseSetData();
    var createBind = require_createBind();
    var createCurry = require_createCurry();
    var createHybrid = require_createHybrid();
    var createPartial = require_createPartial();
    var getData = require_getData();
    var mergeData = require_mergeData();
    var setData = require_setData();
    var setWrapToString = require_setWrapToString();
    var toInteger = require_toInteger();
    var FUNC_ERROR_TEXT = "Expected a function";
    var WRAP_BIND_FLAG = 1;
    var WRAP_BIND_KEY_FLAG = 2;
    var WRAP_CURRY_FLAG = 8;
    var WRAP_CURRY_RIGHT_FLAG = 16;
    var WRAP_PARTIAL_FLAG = 32;
    var WRAP_PARTIAL_RIGHT_FLAG = 64;
    var nativeMax = Math.max;
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length2 = partials ? partials.length : 0;
      if (!length2) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = void 0;
      }
      ary = ary === void 0 ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === void 0 ? arity : toInteger(arity);
      length2 -= holders ? holders.length : 0;
      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = void 0;
      }
      var data = isBindKey ? void 0 : getData(func);
      var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
      ];
      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === void 0 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length2, 0);
      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(void 0, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }
    module2.exports = createWrap;
  }
});

// node_modules/lodash/partial.js
var require_partial = __commonJS({
  "node_modules/lodash/partial.js"(exports, module2) {
    var baseRest = require_baseRest();
    var createWrap = require_createWrap();
    var getHolder = require_getHolder();
    var replaceHolders = require_replaceHolders();
    var WRAP_PARTIAL_FLAG = 32;
    var partial3 = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial3));
      return createWrap(func, WRAP_PARTIAL_FLAG, void 0, partials, holders);
    });
    partial3.placeholder = {};
    module2.exports = partial3;
  }
});

// node_modules/lodash/head.js
var require_head = __commonJS({
  "node_modules/lodash/head.js"(exports, module2) {
    function head(array) {
      return array && array.length ? array[0] : void 0;
    }
    module2.exports = head;
  }
});

// node_modules/lodash/first.js
var require_first = __commonJS({
  "node_modules/lodash/first.js"(exports, module2) {
    module2.exports = require_head();
  }
});

// node_modules/lodash/_setCacheAdd.js
var require_setCacheAdd = __commonJS({
  "node_modules/lodash/_setCacheAdd.js"(exports, module2) {
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }
    module2.exports = setCacheAdd;
  }
});

// node_modules/lodash/_setCacheHas.js
var require_setCacheHas = __commonJS({
  "node_modules/lodash/_setCacheHas.js"(exports, module2) {
    function setCacheHas(value) {
      return this.__data__.has(value);
    }
    module2.exports = setCacheHas;
  }
});

// node_modules/lodash/_SetCache.js
var require_SetCache = __commonJS({
  "node_modules/lodash/_SetCache.js"(exports, module2) {
    var MapCache = require_MapCache();
    var setCacheAdd = require_setCacheAdd();
    var setCacheHas = require_setCacheHas();
    function SetCache(values) {
      var index = -1, length2 = values == null ? 0 : values.length;
      this.__data__ = new MapCache();
      while (++index < length2) {
        this.add(values[index]);
      }
    }
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    module2.exports = SetCache;
  }
});

// node_modules/lodash/_arrayIncludesWith.js
var require_arrayIncludesWith = __commonJS({
  "node_modules/lodash/_arrayIncludesWith.js"(exports, module2) {
    function arrayIncludesWith(array, value, comparator) {
      var index = -1, length2 = array == null ? 0 : array.length;
      while (++index < length2) {
        if (comparator(value, array[index])) {
          return true;
        }
      }
      return false;
    }
    module2.exports = arrayIncludesWith;
  }
});

// node_modules/lodash/_baseUnary.js
var require_baseUnary = __commonJS({
  "node_modules/lodash/_baseUnary.js"(exports, module2) {
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    module2.exports = baseUnary;
  }
});

// node_modules/lodash/_cacheHas.js
var require_cacheHas = __commonJS({
  "node_modules/lodash/_cacheHas.js"(exports, module2) {
    function cacheHas(cache, key2) {
      return cache.has(key2);
    }
    module2.exports = cacheHas;
  }
});

// node_modules/lodash/_baseIntersection.js
var require_baseIntersection = __commonJS({
  "node_modules/lodash/_baseIntersection.js"(exports, module2) {
    var SetCache = require_SetCache();
    var arrayIncludes = require_arrayIncludes();
    var arrayIncludesWith = require_arrayIncludesWith();
    var arrayMap = require_arrayMap();
    var baseUnary = require_baseUnary();
    var cacheHas = require_cacheHas();
    var nativeMin = Math.min;
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes, length2 = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length2 >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : void 0;
      }
      array = arrays[0];
      var index = -1, seen = caches[0];
      outer:
        while (++index < length2 && result.length < maxLength) {
          var value = array[index], computed = iteratee ? iteratee(value) : value;
          value = comparator || value !== 0 ? value : 0;
          if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while (--othIndex) {
              var cache = caches[othIndex];
              if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
                continue outer;
              }
            }
            if (seen) {
              seen.push(computed);
            }
            result.push(value);
          }
        }
      return result;
    }
    module2.exports = baseIntersection;
  }
});

// node_modules/lodash/isArrayLike.js
var require_isArrayLike = __commonJS({
  "node_modules/lodash/isArrayLike.js"(exports, module2) {
    var isFunction = require_isFunction();
    var isLength = require_isLength();
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    module2.exports = isArrayLike;
  }
});

// node_modules/lodash/isArrayLikeObject.js
var require_isArrayLikeObject = __commonJS({
  "node_modules/lodash/isArrayLikeObject.js"(exports, module2) {
    var isArrayLike = require_isArrayLike();
    var isObjectLike = require_isObjectLike();
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    module2.exports = isArrayLikeObject;
  }
});

// node_modules/lodash/_castArrayLikeObject.js
var require_castArrayLikeObject = __commonJS({
  "node_modules/lodash/_castArrayLikeObject.js"(exports, module2) {
    var isArrayLikeObject = require_isArrayLikeObject();
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }
    module2.exports = castArrayLikeObject;
  }
});

// node_modules/lodash/intersection.js
var require_intersection = __commonJS({
  "node_modules/lodash/intersection.js"(exports, module2) {
    var arrayMap = require_arrayMap();
    var baseIntersection = require_baseIntersection();
    var baseRest = require_baseRest();
    var castArrayLikeObject = require_castArrayLikeObject();
    var intersection2 = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
    });
    module2.exports = intersection2;
  }
});

// node_modules/lodash/before.js
var require_before = __commonJS({
  "node_modules/lodash/before.js"(exports, module2) {
    var toInteger = require_toInteger();
    var FUNC_ERROR_TEXT = "Expected a function";
    function before(n, func) {
      var result;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = void 0;
        }
        return result;
      };
    }
    module2.exports = before;
  }
});

// node_modules/lodash/once.js
var require_once = __commonJS({
  "node_modules/lodash/once.js"(exports, module2) {
    var before = require_before();
    function once2(func) {
      return before(2, func);
    }
    module2.exports = once2;
  }
});

// node_modules/lodash/_createRound.js
var require_createRound = __commonJS({
  "node_modules/lodash/_createRound.js"(exports, module2) {
    var root = require_root();
    var toInteger = require_toInteger();
    var toNumber = require_toNumber();
    var toString = require_toString();
    var nativeIsFinite = root.isFinite;
    var nativeMin = Math.min;
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
          pair = (toString(value) + "e").split("e");
          return +(pair[0] + "e" + (+pair[1] - precision));
        }
        return func(number);
      };
    }
    module2.exports = createRound;
  }
});

// node_modules/lodash/ceil.js
var require_ceil = __commonJS({
  "node_modules/lodash/ceil.js"(exports, module2) {
    var createRound = require_createRound();
    var ceil2 = createRound("ceil");
    module2.exports = ceil2;
  }
});

// node_modules/lodash/_baseClamp.js
var require_baseClamp = __commonJS({
  "node_modules/lodash/_baseClamp.js"(exports, module2) {
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== void 0) {
          number = number <= upper ? number : upper;
        }
        if (lower !== void 0) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }
    module2.exports = baseClamp;
  }
});

// node_modules/lodash/clamp.js
var require_clamp = __commonJS({
  "node_modules/lodash/clamp.js"(exports, module2) {
    var baseClamp = require_baseClamp();
    var toNumber = require_toNumber();
    function clamp2(number, lower, upper) {
      if (upper === void 0) {
        upper = lower;
        lower = void 0;
      }
      if (upper !== void 0) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== void 0) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }
    module2.exports = clamp2;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/_virtual/_rollupPluginBabelHelpers.js
var require_rollupPluginBabelHelpers = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/_virtual/_rollupPluginBabelHelpers.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function _typeof(obj) {
      "@babel/helpers - typeof";
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function(obj2) {
          return typeof obj2;
        };
      } else {
        _typeof = function(obj2) {
          return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
        };
      }
      return _typeof(obj);
    }
    function _defineProperty(obj, key2, value) {
      if (key2 in obj) {
        Object.defineProperty(obj, key2, {
          value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key2] = value;
      }
      return obj;
    }
    function ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
          symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
          });
        keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function _objectSpread2(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
          ownKeys(Object(source), true).forEach(function(key2) {
            _defineProperty(target, key2, source[key2]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys(Object(source)).forEach(function(key2) {
            Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
          });
        }
      }
      return target;
    }
    function _slicedToArray(arr, i) {
      return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
      if (Array.isArray(arr))
        return arr;
    }
    function _iterableToArrayLimit(arr, i) {
      if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr)))
        return;
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = void 0;
      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);
          if (i && _arr.length === i)
            break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"] != null)
            _i["return"]();
        } finally {
          if (_d)
            throw _e;
        }
      }
      return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
      if (!o)
        return;
      if (typeof o === "string")
        return _arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor)
        n = o.constructor.name;
      if (n === "Map" || n === "Set")
        return Array.from(o);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length)
        len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++)
        arr2[i] = arr[i];
      return arr2;
    }
    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    exports.arrayLikeToArray = _arrayLikeToArray;
    exports.arrayWithHoles = _arrayWithHoles;
    exports.defineProperty = _defineProperty;
    exports.iterableToArrayLimit = _iterableToArrayLimit;
    exports.nonIterableRest = _nonIterableRest;
    exports.objectSpread2 = _objectSpread2;
    exports.slicedToArray = _slicedToArray;
    exports.typeof = _typeof;
    exports.unsupportedIterableToArray = _unsupportedIterableToArray;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/createHandlerSetter.js
var require_createHandlerSetter = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/createHandlerSetter.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var react = require("react");
    var createHandlerSetter = function createHandlerSetter2(handlerValue) {
      var handlerRef = react.useRef(handlerValue);
      handlerRef.current = handlerValue;
      var setHandler = react.useCallback(function(nextCallback) {
        if (typeof nextCallback !== "function") {
          throw new Error("the argument supplied to the 'setHandler' function should be of type function");
        }
        handlerRef.current = nextCallback;
      });
      return [handlerRef, setHandler];
    };
    exports.default = createHandlerSetter;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useDidMount.js
var require_useDidMount = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useDidMount.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var useDidMount = function useDidMount2(handler) {
      var _createHandlerSetter = createHandlerSetter.default(handler), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onMountHandler = _createHandlerSetter2[0], setOnMountHandler = _createHandlerSetter2[1];
      react.useEffect(function() {
        if (onMountHandler.current) {
          onMountHandler.current();
        }
      }, []);
      return setOnMountHandler;
    };
    exports.default = useDidMount;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useWillUnmount.js
var require_useWillUnmount = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useWillUnmount.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var useWillUnmount = function useWillUnmount2(handler) {
      var _createHandlerSetter = createHandlerSetter.default(handler), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onUnmountHandler = _createHandlerSetter2[0], setOnUnmount = _createHandlerSetter2[1];
      react.useEffect(function() {
        return function() {
          if (onUnmountHandler.current) {
            onUnmountHandler.current();
          }
        };
      }, []);
      return setOnUnmount;
    };
    exports.default = useWillUnmount;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useLifecycle.js
var require_useLifecycle = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useLifecycle.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var useDidMount = require_useDidMount();
    var useWillUnmount = require_useWillUnmount();
    var useLifecycle = function useLifecycle2(mount, unmount) {
      var onDidMount = useDidMount.default(mount);
      var onWillUnmount = useWillUnmount.default(unmount);
      return {
        onDidMount,
        onWillUnmount
      };
    };
    exports.default = useLifecycle;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useGlobalEvent.js
var require_useGlobalEvent = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useGlobalEvent.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var defaultOptions = {
      capture: false,
      once: false,
      passive: false
    };
    var useGlobalEvent = function useGlobalEvent2(eventName) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultOptions;
      var fn = arguments.length > 2 ? arguments[2] : void 0;
      var _createHandlerSetter = createHandlerSetter.default(fn), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), callbackRef = _createHandlerSetter2[0], setCallbackRef = _createHandlerSetter2[1];
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options || {});
      react.useEffect(function() {
        var cb = function cb2(event) {
          if (callbackRef.current) {
            callbackRef.current(event);
          }
        };
        if (callbackRef.current && eventName) {
          window.addEventListener(eventName, cb, opts);
        }
        return function() {
          if (eventName) {
            window.removeEventListener(eventName, cb, opts);
          }
        };
      }, [eventName, options]);
      return setCallbackRef;
    };
    exports.default = useGlobalEvent;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useWindowResize.js
var require_useWindowResize = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useWindowResize.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var useGlobalEvent = require_useGlobalEvent();
    var useWindowResize = function useWindowResize2(handler) {
      return useGlobalEvent.default("resize", null, handler);
    };
    exports.default = useWindowResize;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useWindowScroll.js
var require_useWindowScroll = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useWindowScroll.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var useGlobalEvent = require_useGlobalEvent();
    var useWindowScroll = function useWindowScroll2(handler) {
      return useGlobalEvent.default("scroll", null, handler);
    };
    exports.default = useWindowScroll;
  }
});

// node_modules/lodash.debounce/index.js
var require_lodash = __commonJS({
  "node_modules/lodash.debounce/index.js"(exports, module2) {
    var FUNC_ERROR_TEXT = "Expected a function";
    var NAN = 0 / 0;
    var symbolTag = "[object Symbol]";
    var reTrim = /^\s+|\s+$/g;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var objectProto = Object.prototype;
    var objectToString = objectProto.toString;
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    var now = function() {
      return root.Date.now();
    };
    function debounce2(func, wait, options) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait - timeSinceLastCall;
        return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now());
      }
      function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    function isObject(value) {
      var type = typeof value;
      return !!value && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return !!value && typeof value == "object";
    }
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
    }
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, "");
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module2.exports = debounce2;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useDebouncedFn.js
var require_useDebouncedFn = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useDebouncedFn.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function _interopDefault(ex) {
      return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
    }
    var react = require("react");
    var debounce2 = _interopDefault(require_lodash());
    var defaultOptions = {
      leading: false,
      trailing: true
    };
    var useDebouncedFn = function useDebouncedFn2(fn) {
      var wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultOptions;
      var dependencies = arguments.length > 3 ? arguments[3] : void 0;
      var debounced = debounce2(fn, wait, options);
      return react.useCallback(debounced, dependencies);
    };
    exports.default = useDebouncedFn;
  }
});

// node_modules/lodash.throttle/index.js
var require_lodash2 = __commonJS({
  "node_modules/lodash.throttle/index.js"(exports, module2) {
    var FUNC_ERROR_TEXT = "Expected a function";
    var NAN = 0 / 0;
    var symbolTag = "[object Symbol]";
    var reTrim = /^\s+|\s+$/g;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var objectProto = Object.prototype;
    var objectToString = objectProto.toString;
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    var now = function() {
      return root.Date.now();
    };
    function debounce2(func, wait, options) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait - timeSinceLastCall;
        return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now());
      }
      function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    function throttle(func, wait, options) {
      var leading = true, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      return debounce2(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
      });
    }
    function isObject(value) {
      var type = typeof value;
      return !!value && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return !!value && typeof value == "object";
    }
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
    }
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, "");
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module2.exports = throttle;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useThrottledFn.js
var require_useThrottledFn = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useThrottledFn.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function _interopDefault(ex) {
      return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
    }
    var react = require("react");
    var throttle = _interopDefault(require_lodash2());
    var defaultOptions = {
      leading: false,
      trailing: true
    };
    var useThrottledFn = function useThrottledFn2(fn) {
      var wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultOptions;
      var dependencies = arguments.length > 3 ? arguments[3] : void 0;
      var throttled = throttle(fn, wait, options);
      return react.useCallback(throttled, dependencies);
    };
    exports.default = useThrottledFn;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/createCbSetterErrorProxy.js
var require_createCbSetterErrorProxy = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/createCbSetterErrorProxy.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var createCbSetterErrorProxy = function createCbSetterErrorProxy2(errorMessage) {
      return new Proxy(/* @__PURE__ */ Object.create(null), {
        get: function get(target, property) {
          if (property && typeof property === "string" && property.slice(0, 2) === "on") {
            return function() {
              throw new Error(errorMessage);
            };
          }
          return {
            error: errorMessage
          };
        }
      });
    };
    exports.default = createCbSetterErrorProxy;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/hasOwnProperty.js
var require_hasOwnProperty = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/hasOwnProperty.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var hasOwnProperty2 = function hasOwnProperty3(obj, prop) {
      return obj ? Object.prototype.hasOwnProperty.call(obj, prop) : false;
    };
    exports.default = hasOwnProperty2;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useMouseEvents.js
var require_useMouseEvents = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useMouseEvents.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var createCbSetterErrorProxy = require_createCbSetterErrorProxy();
    var hasOwnProperty2 = require_hasOwnProperty();
    var assignMouseEventOnMount = function assignMouseEventOnMount2(targetRef, handlerRef, eventName) {
      react.useEffect(function() {
        var cb = function cb2(mouseEvent) {
          if (handlerRef.current) {
            handlerRef.current(mouseEvent);
          }
        };
        var target;
        if (targetRef !== null && !!targetRef.current) {
          target = targetRef.current;
        }
        if (targetRef === null) {
          target = document;
        }
        if (target && target.addEventListener) {
          target.addEventListener(eventName, cb);
        }
        return function() {
          if (target && target.removeEventListener) {
            target.removeEventListener(eventName, cb);
          }
        };
      }, []);
    };
    var useMouseEvents = function useMouseEvents2() {
      var targetRef = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      var _createHandlerSetter = createHandlerSetter.default(), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onMouseDownHandler = _createHandlerSetter2[0], setOnMouseDown = _createHandlerSetter2[1];
      var _createHandlerSetter3 = createHandlerSetter.default(), _createHandlerSetter4 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter3, 2), onMouseEnterHandler = _createHandlerSetter4[0], setOnMouseEnter = _createHandlerSetter4[1];
      var _createHandlerSetter5 = createHandlerSetter.default(), _createHandlerSetter6 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter5, 2), onMouseLeaveHandler = _createHandlerSetter6[0], setOnMouseLeave = _createHandlerSetter6[1];
      var _createHandlerSetter7 = createHandlerSetter.default(), _createHandlerSetter8 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter7, 2), onMouseMoveHandler = _createHandlerSetter8[0], setOnMouseMove = _createHandlerSetter8[1];
      var _createHandlerSetter9 = createHandlerSetter.default(), _createHandlerSetter10 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter9, 2), onMouseOutHandler = _createHandlerSetter10[0], setOnMouseOut = _createHandlerSetter10[1];
      var _createHandlerSetter11 = createHandlerSetter.default(), _createHandlerSetter12 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter11, 2), onMouseOverHandler = _createHandlerSetter12[0], setOnMouseOver = _createHandlerSetter12[1];
      var _createHandlerSetter13 = createHandlerSetter.default(), _createHandlerSetter14 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter13, 2), onMouseUpHandler = _createHandlerSetter14[0], setOnMouseUp = _createHandlerSetter14[1];
      if (targetRef !== null && !hasOwnProperty2.default(targetRef, "current")) {
        return createCbSetterErrorProxy.default("Unable to assign any mouse event to the given ref");
      }
      assignMouseEventOnMount(targetRef, onMouseDownHandler, "mousedown");
      assignMouseEventOnMount(targetRef, onMouseEnterHandler, "mouseenter");
      assignMouseEventOnMount(targetRef, onMouseLeaveHandler, "mouseleave");
      assignMouseEventOnMount(targetRef, onMouseMoveHandler, "mousemove");
      assignMouseEventOnMount(targetRef, onMouseOutHandler, "mouseout");
      assignMouseEventOnMount(targetRef, onMouseOverHandler, "mouseover");
      assignMouseEventOnMount(targetRef, onMouseUpHandler, "mouseup");
      return Object.freeze({
        onMouseDown: setOnMouseDown,
        onMouseEnter: setOnMouseEnter,
        onMouseLeave: setOnMouseLeave,
        onMouseMove: setOnMouseMove,
        onMouseOut: setOnMouseOut,
        onMouseOver: setOnMouseOver,
        onMouseUp: setOnMouseUp
      });
    };
    exports.default = useMouseEvents;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useMouseState.js
var require_useMouseState = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useMouseState.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var useMouseEvents = require_useMouseEvents();
    var createStateObject = function createStateObject2(event) {
      return {
        clientX: event.clientX,
        clientY: event.clientY,
        screenX: event.screenX,
        screenY: event.screenY
      };
    };
    var useMouseState = function useMouseState2() {
      var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      var _useState = react.useState({
        clientX: 0,
        clientY: 0,
        screenX: 0,
        screenY: 0
      }), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
      var _useMouseEvents = useMouseEvents.default(ref), onMouseMove = _useMouseEvents.onMouseMove;
      onMouseMove(function(event) {
        var nextState = createStateObject(event);
        setState(nextState);
      });
      return state;
    };
    exports.default = useMouseState;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useMouse.js
var require_useMouse = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useMouse.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var useMouseEvents = require_useMouseEvents();
    var useMouseState = require_useMouseState();
    var useMouse = function useMouse2() {
      var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      var state = useMouseState.default(ref);
      var events = useMouseEvents.default(ref);
      return [state, events];
    };
    exports.default = useMouse;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useTimeout.js
var require_useTimeout = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useTimeout.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var defaultOptions = {
      cancelOnUnmount: true
    };
    var useTimeout = function useTimeout2(fn, milliseconds) {
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultOptions;
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options || {});
      var timeout = react.useRef();
      var callback = react.useRef(fn);
      var _useState = react.useState(false), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isCleared = _useState2[0], setIsCleared = _useState2[1];
      var clear = react.useCallback(function() {
        if (timeout.current) {
          clearTimeout(timeout.current);
          setIsCleared(true);
        }
      }, []);
      react.useEffect(function() {
        if (typeof fn === "function") {
          callback.current = fn;
        }
      }, [fn]);
      react.useEffect(function() {
        if (typeof milliseconds === "number") {
          timeout.current = setTimeout(function() {
            callback.current();
          }, milliseconds);
        }
      }, [milliseconds]);
      react.useEffect(function() {
        return function() {
          if (opts.cancelOnUnmount) {
            clear();
          }
        };
      }, []);
      return [isCleared, clear];
    };
    exports.default = useTimeout;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/usePreviousValue.js
var require_usePreviousValue = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/usePreviousValue.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var react = require("react");
    var usePreviousValue = function usePreviousValue2(value) {
      var prevValue = react.useRef();
      react.useEffect(function() {
        prevValue.current = value;
        return function() {
          prevValue.current = void 0;
        };
      });
      return prevValue.current;
    };
    exports.default = usePreviousValue;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useConditionalTimeout.js
var require_useConditionalTimeout = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useConditionalTimeout.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var usePreviousValue = require_usePreviousValue();
    var defaultOptions = {
      cancelOnUnmount: true,
      cancelOnConditionChange: true
    };
    var useConditionalTimeout = function useConditionalTimeout2(fn, milliseconds, condition) {
      var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : defaultOptions;
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options || {});
      var timeout = react.useRef();
      var callback = react.useRef(fn);
      var _useState = react.useState(false), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isCleared = _useState2[0], setIsCleared = _useState2[1];
      var prevCondition = usePreviousValue.default(condition);
      var clear = react.useCallback(function() {
        if (timeout.current) {
          clearTimeout(timeout.current);
          setIsCleared(true);
        }
      }, []);
      react.useEffect(function() {
        if (typeof fn === "function") {
          callback.current = fn;
        }
      }, [fn]);
      react.useEffect(function() {
        if (condition && typeof milliseconds === "number") {
          timeout.current = setTimeout(function() {
            callback.current();
          }, milliseconds);
        }
      }, [condition, milliseconds]);
      react.useEffect(function() {
        if (prevCondition && condition !== prevCondition && opts.cancelOnConditionChange) {
          clear();
        }
      }, [condition, options]);
      react.useEffect(function() {
        return function() {
          if (opts.cancelOnUnmount) {
            clear();
          }
        };
      }, []);
      return [isCleared, clear];
    };
    exports.default = useConditionalTimeout;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useInterval.js
var require_useInterval = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useInterval.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var defaultOptions = {
      cancelOnUnmount: true
    };
    var useInterval2 = function useInterval3(fn, milliseconds) {
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultOptions;
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options || {});
      var timeout = react.useRef();
      var callback = react.useRef(fn);
      var _useState = react.useState(false), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isCleared = _useState2[0], setIsCleared = _useState2[1];
      var clear = react.useCallback(function() {
        if (timeout.current) {
          clearInterval(timeout.current);
          setIsCleared(true);
        }
      }, []);
      react.useEffect(function() {
        if (typeof fn === "function") {
          callback.current = fn;
        }
      }, [fn]);
      react.useEffect(function() {
        clear();
        if (typeof milliseconds === "number") {
          timeout.current = setInterval(function() {
            callback.current();
          }, milliseconds);
        }
      }, [milliseconds]);
      react.useEffect(function() {
        return function() {
          if (opts.cancelOnUnmount) {
            clear();
          }
        };
      }, []);
      return [isCleared, clear];
    };
    exports.default = useInterval2;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/geolocationStandardOptions.js
var require_geolocationStandardOptions = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/geolocationStandardOptions.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var geoStandardOptions = /* @__PURE__ */ Object.create(null);
    geoStandardOptions.enableHighAccuracy = false;
    geoStandardOptions.timeout = 4294967295;
    geoStandardOptions.maximumAge = 0;
    var geolocationStandardOptions = Object.freeze(geoStandardOptions);
    exports.default = geolocationStandardOptions;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useGeolocationEvents.js
var require_useGeolocationEvents = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useGeolocationEvents.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var createCbSetterErrorProxy = require_createCbSetterErrorProxy();
    var geolocationStandardOptions = require_geolocationStandardOptions();
    var useGeolocationEvents = function useGeolocationEvents2() {
      var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : geolocationStandardOptions.default;
      var watchId = react.useRef();
      var _createHandlerSetter = createHandlerSetter.default(), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onChangeRef = _createHandlerSetter2[0], setOnChangeRef = _createHandlerSetter2[1];
      var _createHandlerSetter3 = createHandlerSetter.default(), _createHandlerSetter4 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter3, 2), onErrorRef = _createHandlerSetter4[0], setOnErrorRef = _createHandlerSetter4[1];
      var isSupported = typeof window !== "undefined" && "geolocation" in window.navigator;
      react.useEffect(function() {
        var onSuccess = function onSuccess2(successEvent) {
          if (onChangeRef.current) {
            onChangeRef.current(successEvent);
          }
        };
        var onError = function onError2(err) {
          if (onErrorRef.current) {
            onErrorRef.current(err);
          }
        };
        if (isSupported) {
          watchId.current = window.navigator.geolocation.watchPosition(onSuccess, onError, options);
        }
        return function() {
          if (isSupported) {
            window.navigator.geolocation.clearWatch(watchId.current);
          }
        };
      }, []);
      return !isSupported ? createCbSetterErrorProxy.default("The Geolocation API is not supported") : Object.freeze({
        isSupported,
        onChange: setOnChangeRef,
        onError: setOnErrorRef
      });
    };
    exports.default = useGeolocationEvents;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/makePositionObject.js
var require_makePositionObject = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/makePositionObject.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var makePositionObj = function makePositionObj2(position2) {
      return !position2 ? null : {
        timestamp: position2.timestamp,
        coords: {
          latitude: position2.coords.latitude,
          longitude: position2.coords.longitude,
          altitude: position2.coords.altitude,
          accuracy: position2.coords.accuracy,
          altitudeAccuracy: position2.coords.altitudeAccuracy,
          heading: position2.coords.heading,
          speed: position2.coords.speed
        }
      };
    };
    exports.default = makePositionObj;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/isSamePosition.js
var require_isSamePosition = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/isSamePosition.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var isSamePosition = function isSamePosition2(current, next2) {
      if (!current || !next2 || !next2.coords)
        return false;
      if (current.timestamp && next2.timestamp && current.timestamp !== next2.timestamp)
        return false;
      return current.coords.latitude === next2.coords.latitude && current.coords.longitude === next2.coords.longitude && current.coords.altitude === next2.coords.altitude && current.coords.accuracy === next2.coords.accuracy && current.coords.altitudeAccuracy === next2.coords.altitudeAccuracy && current.coords.heading === next2.coords.heading && current.coords.speed === next2.coords.speed;
    };
    exports.default = isSamePosition;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useGeolocationState.js
var require_useGeolocationState = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useGeolocationState.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var geolocationStandardOptions = require_geolocationStandardOptions();
    var useGeolocationEvents = require_useGeolocationEvents();
    var makePositionObject = require_makePositionObject();
    var isSamePosition = require_isSamePosition();
    var useGeolocationState = function useGeolocationState2() {
      var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : geolocationStandardOptions.default;
      var _useState = react.useState(null), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), position2 = _useState2[0], setPosition = _useState2[1];
      var _useState3 = react.useState(false), _useState4 = _rollupPluginBabelHelpers.slicedToArray(_useState3, 2), isRetrieving = _useState4[0], setRetrieving = _useState4[1];
      var _useGeolocationEvents = useGeolocationEvents.default(options), isSupported = _useGeolocationEvents.isSupported, onChange = _useGeolocationEvents.onChange;
      var savePosition = react.useCallback(function() {
        if (position2 === null) {
          setRetrieving(true);
          navigator.geolocation.getCurrentPosition(function(nextPosition) {
            if (!isSamePosition.default(position2, nextPosition)) {
              setPosition(makePositionObject.default(nextPosition));
              setRetrieving(false);
            }
          });
        }
      }, [position2]);
      react.useEffect(savePosition, [position2]);
      onChange(savePosition);
      return Object.freeze({
        isSupported,
        isRetrieving,
        position: position2
      });
    };
    exports.default = useGeolocationState;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useGeolocation.js
var require_useGeolocation = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useGeolocation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var geolocationStandardOptions = require_geolocationStandardOptions();
    var useGeolocationEvents = require_useGeolocationEvents();
    var useGeolocationState = require_useGeolocationState();
    var useGeolocation = function useGeolocation2() {
      var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : geolocationStandardOptions.default;
      var state = useGeolocationState.default(options);
      var events = useGeolocationEvents.default(options);
      return [state, events];
    };
    exports.default = useGeolocation;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/isClient.js
var require_isClient = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/isClient.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var isClient = (typeof window === "undefined" ? "undefined" : _rollupPluginBabelHelpers.typeof(window)) === "object";
    exports.default = isClient;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/isAPISupported.js
var require_isAPISupported = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/isAPISupported.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var isApiSupported = function isApiSupported2(api) {
      return api in window;
    };
    exports.default = isApiSupported;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useMediaQuery.js
var require_useMediaQuery = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useMediaQuery.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var isClient = require_isClient();
    var isAPISupported = require_isAPISupported();
    var errorMessage = "matchMedia is not supported, this could happen both because window.matchMedia is not supported by your current browser or you're using the useMediaQuery hook whilst server side rendering.";
    var useMediaQuery = function useMediaQuery2(mediaQuery) {
      if (!isClient.default || !isAPISupported.default("matchMedia")) {
        console.warn(errorMessage);
        return null;
      }
      var _useState = react.useState(!!window.matchMedia(mediaQuery).matches), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isVerified = _useState2[0], setIsVerified = _useState2[1];
      react.useEffect(function() {
        var mediaQueryList = window.matchMedia(mediaQuery);
        var documentChangeHandler = function documentChangeHandler2() {
          return setIsVerified(!!mediaQueryList.matches);
        };
        mediaQueryList.addListener(documentChangeHandler);
        documentChangeHandler();
        return function() {
          mediaQueryList.removeListener(documentChangeHandler);
        };
      }, [mediaQuery]);
      return isVerified;
    };
    exports.default = useMediaQuery;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useValueHistory.js
var require_useValueHistory = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useValueHistory.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var react = require("react");
    var useValueHistory = function useValueHistory2(value) {
      var history = react.useRef([]);
      react.useEffect(function() {
        history.current.push(value);
      }, [value]);
      return history.current;
    };
    exports.default = useValueHistory;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useOnlineState.js
var require_useOnlineState = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useOnlineState.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var useGlobalEvent = require_useGlobalEvent();
    var useOnlineState = function useOnlineState2() {
      var isSupported = typeof window !== "undefined" && "ononline" in window;
      var _useState = react.useState(isSupported ? navigator.onLine : true), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isOnline = _useState2[0], setIsOnline = _useState2[1];
      var whenOnline = useGlobalEvent.default("online", {
        capture: true
      });
      var whenOffline = useGlobalEvent.default("offline", {
        capture: true
      });
      if (!isSupported) {
        console.warn("The current device does not support the 'online/offline' events, you should avoid using useOnlineState");
        return isOnline;
      }
      whenOnline(function() {
        setIsOnline(true);
      });
      whenOffline(function() {
        setIsOnline(false);
      });
      return isOnline;
    };
    exports.default = useOnlineState;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useViewportSpy.js
var require_useViewportSpy = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useViewportSpy.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var defaultOptions = {
      root: void 0,
      rootMargin: "0px",
      threshold: 0
    };
    var useViewportSpy = function useViewportSpy2(elementRef) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultOptions;
      var _useState = react.useState(), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isVisible = _useState2[0], setIsVisible = _useState2[1];
      react.useLayoutEffect(function() {
        var observer = new IntersectionObserver(function(entries) {
          return entries.forEach(function(item) {
            var nextValue = item.isIntersecting;
            setIsVisible(nextValue);
          });
        }, options);
        observer.observe(elementRef.current);
        return function() {
          observer.disconnect(elementRef.current);
        };
      }, [elementRef]);
      return isVisible;
    };
    exports.default = useViewportSpy;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useValidatedState.js
var require_useValidatedState = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useValidatedState.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var useValidatedState = function useValidatedState2(validator, initialValue) {
      var _useState = react.useState(initialValue), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
      var validation = react.useRef({
        changed: false
      });
      var onChange = react.useCallback(function(nextValue) {
        setState(nextValue);
        validation.current = {
          changed: true,
          valid: validator(nextValue)
        };
      }, [validator]);
      return [state, onChange, validation.current];
    };
    exports.default = useValidatedState;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useDragEvents.js
var require_useDragEvents = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useDragEvents.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var createCbSetterErrorProxy = require_createCbSetterErrorProxy();
    var hasOwnProperty2 = require_hasOwnProperty();
    var assignDragEventOnMount = function assignDragEventOnMount2(targetRef, handlerRef, eventName) {
      react.useEffect(function() {
        var cb = function cb2(dragEvent) {
          if (handlerRef.current) {
            handlerRef.current(dragEvent);
          }
        };
        if (targetRef.current) {
          targetRef.current.addEventListener(eventName, cb);
        }
        return function() {
          if (targetRef.current) {
            targetRef.current.removeEventListener(eventName, cb);
          }
        };
      }, []);
    };
    var useDragEvents = function useDragEvents2(targetRef) {
      var setDraggable = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
      var _createHandlerSetter = createHandlerSetter.default(), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onDrag = _createHandlerSetter2[0], setOnDrag = _createHandlerSetter2[1];
      var _createHandlerSetter3 = createHandlerSetter.default(), _createHandlerSetter4 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter3, 2), onDrop = _createHandlerSetter4[0], setOnDrop = _createHandlerSetter4[1];
      var _createHandlerSetter5 = createHandlerSetter.default(), _createHandlerSetter6 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter5, 2), onDragEnter = _createHandlerSetter6[0], setOnDragEnter = _createHandlerSetter6[1];
      var _createHandlerSetter7 = createHandlerSetter.default(), _createHandlerSetter8 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter7, 2), onDragEnd = _createHandlerSetter8[0], setOnDragEnd = _createHandlerSetter8[1];
      var _createHandlerSetter9 = createHandlerSetter.default(), _createHandlerSetter10 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter9, 2), onDragExit = _createHandlerSetter10[0], setOnDragExit = _createHandlerSetter10[1];
      var _createHandlerSetter11 = createHandlerSetter.default(), _createHandlerSetter12 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter11, 2), onDragLeave = _createHandlerSetter12[0], setOnDragLeave = _createHandlerSetter12[1];
      var _createHandlerSetter13 = createHandlerSetter.default(), _createHandlerSetter14 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter13, 2), onDragOver = _createHandlerSetter14[0], setOnDragOver = _createHandlerSetter14[1];
      var _createHandlerSetter15 = createHandlerSetter.default(), _createHandlerSetter16 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter15, 2), onDragStart = _createHandlerSetter16[0], setOnDragStart = _createHandlerSetter16[1];
      if (targetRef !== null && !hasOwnProperty2.default(targetRef, "current")) {
        return createCbSetterErrorProxy.default("Unable to assign any drag event to the given ref");
      }
      react.useEffect(function() {
        if (setDraggable && targetRef.current && !targetRef.current.hasAttribute("draggable")) {
          targetRef.current.setAttribute("draggable", true);
        }
      }, []);
      assignDragEventOnMount(targetRef, onDrag, "drag");
      assignDragEventOnMount(targetRef, onDrop, "drop");
      assignDragEventOnMount(targetRef, onDragEnter, "dragenter");
      assignDragEventOnMount(targetRef, onDragEnd, "dragend");
      assignDragEventOnMount(targetRef, onDragExit, "dragexit");
      assignDragEventOnMount(targetRef, onDragLeave, "dragleave");
      assignDragEventOnMount(targetRef, onDragOver, "dragover");
      assignDragEventOnMount(targetRef, onDragStart, "dragstart");
      return Object.freeze({
        onDrag: setOnDrag,
        onDrop: setOnDrop,
        onDragEnter: setOnDragEnter,
        onDragEnd: setOnDragEnd,
        onDragExit: setOnDragExit,
        onDragLeave: setOnDragLeave,
        onDragOver: setOnDragOver,
        onDragStart: setOnDragStart
      });
    };
    exports.default = useDragEvents;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useDrag.js
var require_useDrag = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useDrag.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var useDragEvents = require_useDragEvents();
    var defaultOptions = {
      dragImage: null,
      dragImageXOffset: 0,
      dragImageYOffset: 0,
      transfer: null,
      transferFormat: "text"
    };
    var useDrag = function useDrag2(targetRef) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultOptions;
      var _useDragEvents = useDragEvents.default(targetRef, true), onDragStart = _useDragEvents.onDragStart, onDragEnd = _useDragEvents.onDragEnd;
      var _useState = react.useState(false), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isDragging = _useState2[0], setIsDragging = _useState2[1];
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options || {});
      onDragStart(function(event) {
        setIsDragging(true);
        if (opts.dragImage) {
          var img = new Image();
          img.src = opts.dragImage;
          event.dataTransfer.setDragImage(img, opts.dragImageXOffset, opts.dragImageYOffset);
        }
        if (opts.transfer) {
          var data = _rollupPluginBabelHelpers.typeof(opts.transfer) === "object" ? JSON.stringify(opts.transfer) : "".concat(opts.transfer);
          event.dataTransfer.setData(opts.transferFormat, data);
        }
      });
      onDragEnd(function() {
        return setIsDragging(false);
      });
      return isDragging;
    };
    exports.default = useDrag;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useDropZone.js
var require_useDropZone = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useDropZone.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var useDragEvents = require_useDragEvents();
    var useDropZone = function useDropZone2(targetRef) {
      var _useDragEvents = useDragEvents.default(targetRef, false), onDrop = _useDragEvents.onDrop, onDragOver = _useDragEvents.onDragOver, onDragLeave = _useDragEvents.onDragLeave;
      var _useState = react.useState(false), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), isOver = _useState2[0], setIsOver = _useState2[1];
      onDragOver(function(event) {
        event.preventDefault();
        setIsOver(true);
      });
      onDragLeave(function() {
        setIsOver(false);
      });
      return {
        isOver,
        onDrop
      };
    };
    exports.default = useDropZone;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useRequestAnimationFrame.js
var require_useRequestAnimationFrame = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useRequestAnimationFrame.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var createHandlerSetter = require_createHandlerSetter();
    var createCbSetterErrorProxy = require_createCbSetterErrorProxy();
    var isClient = require_isClient();
    var isAPISupported = require_isAPISupported();
    var defaultOptions = {
      increment: 1,
      startAt: 0,
      finishAt: 100
    };
    var errorMessage = "requestAnimationFrame is not supported, this could happen both because window.requestAnimationFrame is not supported by your current browser version or you're using the useRequestAnimationFrame hook whilst server side rendering.";
    var useRequestAnimationFrame = function useRequestAnimationFrame2(func) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultOptions;
      if (!isClient.default || !isAPISupported.default("requestAnimationFrame")) {
        console.warn(errorMessage);
        return createCbSetterErrorProxy.default(errorMessage);
      }
      var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options);
      var progress = react.useRef(opts.startAt);
      var _createHandlerSetter = createHandlerSetter.default(), _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2), onFinish = _createHandlerSetter2[0], setOnFinish = _createHandlerSetter2[1];
      var next2 = function next3() {
        return window.requestAnimationFrame(step);
      };
      var step = react.useCallback(function() {
        if (progress.current <= opts.finishAt || opts.finishAt === -1) {
          func(progress.current, next2);
          progress.current += opts.increment;
        } else if (onFinish.current) {
          onFinish.current();
        }
      }, [func, opts.finishAt, opts.increment, progress.current, onFinish.current]);
      if (progress.current <= opts.startAt) {
        next2();
      }
      return setOnFinish;
    };
    exports.default = useRequestAnimationFrame;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/utils/safelyParseJson.js
var require_safelyParseJson = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/utils/safelyParseJson.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var safelyParseJson = function safelyParseJson2(parseString) {
      try {
        return JSON.parse(parseString);
      } catch (e) {
        return null;
      }
    };
    exports.default = safelyParseJson;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useLocalStorage.js
var require_useLocalStorage = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useLocalStorage.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var isClient = require_isClient();
    var isAPISupported = require_isAPISupported();
    var safelyParseJson = require_safelyParseJson();
    var errorMessageSSR = "localStorage is not supported, this could happen because you're using the useLocalStorage hook whilst server side rendering.";
    var errorMessageIsNotSupported = "localStorage is not supported, this could happen because window.localStorage is not supported by your current browser";
    var useLocalStorage = function useLocalStorage2(localStorageKey, defaultValue) {
      if (!isClient.default) {
        console.warn(errorMessageSSR);
        return [JSON.stringify(defaultValue), function() {
          return void 0;
        }];
      }
      if (!isAPISupported.default("localStorage")) {
        console.warn(errorMessageIsNotSupported);
        return [JSON.stringify(defaultValue), function() {
          return void 0;
        }];
      }
      var _useState = react.useState(safelyParseJson.default(window.localStorage.getItem(localStorageKey) || JSON.stringify(defaultValue))), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), value = _useState2[0], setValue = _useState2[1];
      react.useEffect(function() {
        window.localStorage.setItem(localStorageKey, JSON.stringify(value));
      }, [localStorageKey, value]);
      return [value, setValue];
    };
    exports.default = useLocalStorage;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/useStorage.js
var require_useStorage = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/useStorage.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _rollupPluginBabelHelpers = require_rollupPluginBabelHelpers();
    var react = require("react");
    var isClient = require_isClient();
    var safelyParseJson = require_safelyParseJson();
    var useStorage = function useStorage2(type) {
      return function(initialValue) {
        var _useState = react.useState(initialValue), _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2), store = _useState2[0], setStore = _useState2[1];
        var storageType = type;
        if (storageType !== "local" && storageType !== "session") {
          storageType = "local";
        }
        storageType += "Storage";
        var get = function get2(key2) {
          return safelyParseJson.default(isClient.default ? window[storageType].getItem(key2) : store[key2]);
        };
        var set = function set2(key2, value) {
          var valueToStore = value instanceof Function ? value(safelyParseJson.default(store[key2])) : value;
          if (isClient.default) {
            window[storageType].setItem(key2, JSON.stringify(valueToStore));
          }
          return setStore(function(x) {
            return _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, x), {}, _rollupPluginBabelHelpers.defineProperty({}, key2, valueToStore));
          });
        };
        react.useEffect(function() {
          if (isClient.default) {
            Object.keys(store).map(function(k) {
              return window[storageType].setItem(k, JSON.stringify(store[k]));
            });
          }
        }, [store]);
        var storage = store;
        if (isClient.default) {
          storage = window[storageType];
        }
        return _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, storage), {}, {
          get,
          set
        });
      };
    };
    exports.default = useStorage;
  }
});

// node_modules/beautiful-react-hooks/dist/cjs/index.js
var require_cjs = __commonJS({
  "node_modules/beautiful-react-hooks/dist/cjs/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var useDidMount = require_useDidMount();
    var useWillUnmount = require_useWillUnmount();
    var useLifecycle = require_useLifecycle();
    var useGlobalEvent = require_useGlobalEvent();
    var useWindowResize = require_useWindowResize();
    var useWindowScroll = require_useWindowScroll();
    var useDebouncedFn = require_useDebouncedFn();
    var useThrottledFn = require_useThrottledFn();
    var useMouseEvents = require_useMouseEvents();
    var useMouseState = require_useMouseState();
    var useMouse = require_useMouse();
    var useTimeout = require_useTimeout();
    var usePreviousValue = require_usePreviousValue();
    var useConditionalTimeout = require_useConditionalTimeout();
    var useInterval2 = require_useInterval();
    var useGeolocationEvents = require_useGeolocationEvents();
    var useGeolocationState = require_useGeolocationState();
    var useGeolocation = require_useGeolocation();
    var useMediaQuery = require_useMediaQuery();
    var useValueHistory = require_useValueHistory();
    var useOnlineState = require_useOnlineState();
    var useViewportSpy = require_useViewportSpy();
    var useValidatedState = require_useValidatedState();
    var useDragEvents = require_useDragEvents();
    var useDrag = require_useDrag();
    var useDropZone = require_useDropZone();
    var useRequestAnimationFrame = require_useRequestAnimationFrame();
    var useLocalStorage = require_useLocalStorage();
    var useStorage = require_useStorage();
    exports.useDidMount = useDidMount.default;
    exports.useWillUnmount = useWillUnmount.default;
    exports.useLifecycle = useLifecycle.default;
    exports.useGlobalEvent = useGlobalEvent.default;
    exports.useWindowResize = useWindowResize.default;
    exports.useWindowScroll = useWindowScroll.default;
    exports.useDebouncedFn = useDebouncedFn.default;
    exports.useThrottledFn = useThrottledFn.default;
    exports.useMouseEvents = useMouseEvents.default;
    exports.useMouseState = useMouseState.default;
    exports.useMouse = useMouse.default;
    exports.useTimeout = useTimeout.default;
    exports.usePreviousValue = usePreviousValue.default;
    exports.useConditionalTimeout = useConditionalTimeout.default;
    exports.useInterval = useInterval2.default;
    exports.useGeolocationEvents = useGeolocationEvents.default;
    exports.useGeolocationState = useGeolocationState.default;
    exports.useGeolocation = useGeolocation.default;
    exports.useMediaQuery = useMediaQuery.default;
    exports.useValueHistory = useValueHistory.default;
    exports.useOnlineState = useOnlineState.default;
    exports.useViewportSpy = useViewportSpy.default;
    exports.useValidatedState = useValidatedState.default;
    exports.useDragEvents = useDragEvents.default;
    exports.useDrag = useDrag.default;
    exports.useDropZone = useDropZone.default;
    exports.useRequestAnimationFrame = useRequestAnimationFrame.default;
    exports.useLocalStorage = useLocalStorage.default;
    exports.useStorage = useStorage.default;
  }
});

// src/components/VideoRecorder/index.tsx
var VideoRecorder_exports = {};
__export(VideoRecorder_exports, {
  ManualUploadButton: () => ManualUploadButton,
  RecorderState: () => RecorderState_default,
  VideoRecorder: () => VideoRecorderWrapper
});
module.exports = __toCommonJS(VideoRecorder_exports);

// src/components/VideoRecorder/VideoRecorderWrapper.tsx
var import_react57 = __toESM(require("react"));
var import_react_i18next9 = require("react-i18next");

// src/components/VideoRecorder/Recorder.tsx
var import_react55 = __toESM(require("react"));
var import_classnames29 = __toESM(require("classnames"));

// node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var faTrash = {
  prefix: "fas",
  iconName: "trash",
  icon: [448, 512, [], "f1f8", "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"]
};
var faArrowLeft = {
  prefix: "fas",
  iconName: "arrow-left",
  icon: [448, 512, [8592], "f060", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]
};
var faArrowRotateLeft = {
  prefix: "fas",
  iconName: "arrow-rotate-left",
  icon: [512, 512, [8634, "arrow-left-rotate", "arrow-rotate-back", "arrow-rotate-backward", "undo"], "f0e2", "M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"]
};
var faUndo = faArrowRotateLeft;
var faXmark = {
  prefix: "fas",
  iconName: "xmark",
  icon: [320, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"]
};
var faTimes = faXmark;
var faSpinner = {
  prefix: "fas",
  iconName: "spinner",
  icon: [512, 512, [], "f110", "M304 48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zm0 416c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM48 304c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm464-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM142.9 437c18.7-18.7 18.7-49.1 0-67.9s-49.1-18.7-67.9 0s-18.7 49.1 0 67.9s49.1 18.7 67.9 0zm0-294.2c18.7-18.7 18.7-49.1 0-67.9S93.7 56.2 75 75s-18.7 49.1 0 67.9s49.1 18.7 67.9 0zM369.1 437c18.7 18.7 49.1 18.7 67.9 0s18.7-49.1 0-67.9s-49.1-18.7-67.9 0s-18.7 49.1 0 67.9z"]
};
var faCheck = {
  prefix: "fas",
  iconName: "check",
  icon: [512, 512, [10003, 10004], "f00c", "M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
};

// src/utils/assetUrl.ts
function assetUrl(path) {
  return `https://cdn.bonjoro.com/assets/bonjoro-ui-components/${path}`;
}

// src/components/VideoRecorder/ActionButton.tsx
var import_react = __toESM(require("react"));
var import_react_fontawesome = require("@fortawesome/react-fontawesome");
function ActionButton({
  icon,
  label,
  onClick,
  className = ""
}) {
  return /* @__PURE__ */ import_react.default.createElement(
    "div",
    {
      className: `v2-inline-flex v2-items-center v2-bg-black/50 v2-rounded-full v2-text-white v2-px-2 v2-py-1 hover:v2-bg-black/100 v2-transition-colors ${className}`,
      role: "button",
      onClick
    },
    /* @__PURE__ */ import_react.default.createElement(import_react_fontawesome.FontAwesomeIcon, { className: "v2-text-xl", icon }),
    /* @__PURE__ */ import_react.default.createElement("span", { className: "v2-ml-2" }, label)
  );
}

// src/components/VideoRecorder/VideoRecorder.tsx
var import_pick2 = __toESM(require_pick());
var import_stop_media_stream3 = __toESM(require_stop_media_stream());
var import_react_page_visibility = __toESM(require("react-page-visibility"));
var import_toolkit4 = require("@reduxjs/toolkit");
var import_react50 = __toESM(require("react"));

// src/components/VideoRecorder/VideoPane.tsx
var import_classnames25 = __toESM(require("classnames"));

// node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var import_react4 = require("react");

// node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}
function createStyleElement(options) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options.key);
  if (options.nonce !== void 0) {
    tag.setAttribute("nonce", options.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === void 0 ? false : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce;
    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (true) {
      var isImportRule3 = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;
      if (isImportRule3 && this._alreadyInsertedOrderInsensitiveRule) {
        console.error("You're attempting to insert the following rule:\n" + rule + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.");
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule3;
    }
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (!/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) {
          console.error('There was a problem inserting the following rule: "' + rule + '"', e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
    if (true) {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };
  return StyleSheet2;
}();

// node_modules/stylis/src/Enum.js
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";

// node_modules/stylis/src/Utility.js
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash(value, length2) {
  return charat(value, 0) ^ 45 ? (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim(value) {
  return value.trim();
}
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search) {
  return value.indexOf(search);
}
function charat(value, index) {
  return value.charCodeAt(index) | 0;
}
function substr(value, begin, end) {
  return value.slice(begin, end);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array) {
  return array.push(value), value;
}
function combine(array, callback) {
  return array.map(callback).join("");
}

// node_modules/stylis/src/Tokenizer.js
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root, parent, type, props, children, length2) {
  return { value, root, parent, type, props, children, line, column, length: length2, return: "" };
}
function copy(root, props) {
  return assign(node("", null, null, "", null, null, 0), root, { length: -root.length }, props);
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(begin, end) {
  return substr(characters, begin, end);
}
function token(type) {
  switch (type) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type) {
  return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function whitespace(type) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index, count) {
  while (--count && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type) {
  while (next())
    switch (character) {
      case type:
        return position;
      case 34:
      case 39:
        if (type !== 34 && type !== 39)
          delimiter(character);
        break;
      case 40:
        if (type === 41)
          delimiter(type);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type, index) {
  while (next())
    if (type + character === 47 + 10)
      break;
    else if (type + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index, position - 1) + "*" + from(type === 47 ? type : next());
}
function identifier(index) {
  while (!token(peek()))
    next();
  return slice(index, position);
}

// node_modules/stylis/src/Parser.js
function compile(value) {
  return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index = 0;
  var offset = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type = "";
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters2 = type;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root, parent), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      case 123 * variable:
        points[index++] = strlen(characters2) * ampersand;
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          case 0:
          case 125:
            scanning = 0;
          case 59 + offset:
            if (property > 0 && strlen(characters2) - length2)
              append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
            break;
          case 59:
            characters2 += ";";
          default:
            append(reference = ruleset(characters2, root, parent, index, offset, rules, points, type, props = [], children = [], length2), rulesets);
            if (character2 === 123)
              if (offset === 0)
                parse(characters2, root, reference, reference, props, rulesets, length2, points, children);
              else
                switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                  case 100:
                  case 109:
                  case 115:
                    parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
                    break;
                  default:
                    parse(characters2, reference, reference, reference, [""], children, 0, points, children);
                }
        }
        index = offset = property = 0, variable = ampersand = 1, type = characters2 = "", length2 = pseudo;
        break;
      case 58:
        length2 = 1 + strlen(characters2), property = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          case 38:
            ampersand = offset > 0 ? 1 : (characters2 += "\f", -1);
            break;
          case 44:
            points[index++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset = length2 = strlen(type = characters2 += identifier(caret())), character2++;
            break;
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length2) {
  var post = offset - 1;
  var rule = offset === 0 ? rules : [""];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k = 0; i < index; ++i)
    for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
      if (z = trim(j > 0 ? rule[x] + " " + y : replace(y, /&\f/g, rule[x])))
        props[k++] = z;
  return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length2);
}
function comment(value, root, parent) {
  return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root, parent, length2) {
  return node(value, root, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}

// node_modules/stylis/src/Serializer.js
function serialize(children, callback) {
  var output = "";
  var length2 = sizeof(children);
  for (var i = 0; i < length2; i++)
    output += callback(children[i], i, children, callback) || "";
  return output;
}
function stringify(element, index, children, callback) {
  switch (element.type) {
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      element.value = element.props.join(",");
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}

// node_modules/stylis/src/Middleware.js
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element, index, children, callback) {
    var output = "";
    for (var i = 0; i < length2; i++)
      output += collection[i](element, index, children, callback) || "";
    return output;
  };
}

// node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache[arg] === void 0)
      cache[arg] = fn(arg);
    return cache[arg];
  };
}
var emotion_memoize_esm_default = memoize;

// node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek();
    if (previous === 38 && character2 === 12) {
      points[index] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice(begin, position);
};
var toRules = function toRules2(parsed, points) {
  var index = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index] = 1;
        }
        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;
      case 2:
        parsed[index] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index] = peek() === 58 ? "&\f" : "";
          points[index] = parsed[index].length;
          break;
        }
      default:
        parsed[index] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }
  var value = element.value, parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent)
      return;
  }
  if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value = element.value;
    if (
      // charcode for l
      value.charCodeAt(0) === 108 && // charcode for b
      value.charCodeAt(2) === 98
    ) {
      element["return"] = "";
      element.value = "";
    }
  }
};
var ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var isIgnoringComment = function isIgnoringComment2(element) {
  return element.type === "comm" && element.children.indexOf(ignoreFlag) > -1;
};
var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm2(cache) {
  return function(element, index, children) {
    if (element.type !== "rule" || cache.compat)
      return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
    if (unsafePseudoClasses) {
      var isNested = element.parent === children[0];
      var commentContainer = isNested ? children[0].children : (
        // global rule at the root level
        children
      );
      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node2 = commentContainer[i];
        if (node2.line < element.line) {
          break;
        }
        if (node2.column < element.column) {
          if (isIgnoringComment(node2)) {
            return;
          }
          break;
        }
      }
      unsafePseudoClasses.forEach(function(unsafePseudoClass) {
        console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
      });
    }
  };
};
var isImportRule = function isImportRule2(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var isPrependedWithRegularRules = function isPrependedWithRegularRules2(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }
  return false;
};
var nullifyElement = function nullifyElement2(element) {
  element.type = "";
  element.value = "";
  element["return"] = "";
  element.children = "";
  element.props = "";
};
var incorrectImportAlarm = function incorrectImportAlarm2(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }
  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};
function prefix(value, length2) {
  switch (hash(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
    case 5548:
      return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
    case 5292:
      return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6)
        switch (charat(value, length2 + 1)) {
          case 109:
            if (charat(value, length2 + 4) !== 45)
              break;
          case 102:
            return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
          case 115:
            return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
        }
      break;
    case 4949:
      if (charat(value, length2 + 1) !== 115)
        break;
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        case 107:
          return replace(value, ":", ":" + WEBKIT) + value;
        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
var prefixer = function prefixer2(element, index, children, callback) {
  if (element.length > -1) {
    if (!element["return"])
      switch (element.type) {
        case DECLARATION:
          element["return"] = prefix(element.value, element.length);
          break;
        case KEYFRAMES:
          return serialize([copy(element, {
            value: replace(element.value, "@", "@" + WEBKIT)
          })], callback);
        case RULESET:
          if (element.length)
            return combine(element.props, function(value) {
              switch (match(value, /(::plac\w+|:read-\w+)/)) {
                case ":read-only":
                case ":read-write":
                  return serialize([copy(element, {
                    props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")]
                  })], callback);
                case "::placeholder":
                  return serialize([copy(element, {
                    props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
                  }), copy(element, {
                    props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")]
                  }), copy(element, {
                    props: [replace(value, /:(plac\w+)/, MS + "input-$1")]
                  })], callback);
              }
              return "";
            });
      }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options) {
  var key2 = options.key;
  if (!key2) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\nIf multiple caches share the same key they might \"fight\" for each other's style elements.");
  }
  if (key2 === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  if (true) {
    if (/[^a-z-]/.test(key2)) {
      throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + key2 + '" was passed');
    }
  }
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options.container || document.head;
    Array.prototype.forEach.call(
      // this means we will ignore elements which don't have a space in them which
      // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
      document.querySelectorAll('style[data-emotion^="' + key2 + ' "]'),
      function(node2) {
        var attrib = node2.getAttribute("data-emotion").split(" ");
        for (var i = 1; i < attrib.length; i++) {
          inserted[attrib[i]] = true;
        }
        nodesToHydrate.push(node2);
      }
    );
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  if (true) {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }
    }), incorrectImportAlarm);
  }
  {
    var currentSheet;
    var finalizingPlugins = [stringify, true ? function(element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles) {
      return serialize(compile(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      if (serialized.map !== void 0) {
        currentSheet = {
          insert: function insert2(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }
  var cache = {
    key: key2,
    sheet: new StyleSheet({
      key: key2,
      container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};
var emotion_cache_browser_esm_default = createCache;

// node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js
var import_react3 = require("react");

// node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = "";
  classNames.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if (
    // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false) && cache.registered[className] === void 0
  ) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};

// node_modules/@emotion/hash/dist/emotion-hash.esm.js
function murmur2(str) {
  var h = 0;
  var k, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 255;
      h = /* Math.imul(h, m): */
      (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}
var emotion_hash_esm_default = murmur2;

// node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var emotion_unitless_esm_default = unitlessKeys;

// node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`;
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */ emotion_memoize_esm_default(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key2, value) {
  switch (key2) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match2, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (emotion_unitless_esm_default[key2] !== 1 && !isCustomProperty(key2) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
if (true) {
  contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  contentValues = ["normal", "none", "initial", "inherit", "unset"];
  oldProcessStyleValue = processStyleValue;
  msPattern = /^-ms-/;
  hyphenPattern = /-(.)/g;
  hyphenatedCache = {};
  processStyleValue = function processStyleValue3(key2, value) {
    if (key2 === "content") {
      if (typeof value !== "string" || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }
    var processed = oldProcessStyleValue(key2, value);
    if (processed !== "" && !isCustomProperty(key2) && key2.indexOf("-") !== -1 && hyphenatedCache[key2] === void 0) {
      hyphenatedCache[key2] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key2.replace(msPattern, "ms-").replace(hyphenPattern, function(str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }
    return processed;
  };
}
var contentValuePattern;
var contentValues;
var oldProcessStyleValue;
var msPattern;
var hyphenPattern;
var hyphenatedCache;
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  if (interpolation.__emotion_styles !== void 0) {
    if (interpolation.toString() === "NO_COMPONENT_SELECTOR") {
      throw new Error(noComponentSelectorMessage);
    }
    return interpolation;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      if (interpolation.anim === 1) {
        cursor = {
          name: interpolation.name,
          styles: interpolation.styles,
          next: cursor
        };
        return interpolation.name;
      }
      if (interpolation.styles !== void 0) {
        var next2 = interpolation.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles = interpolation.styles + ";";
        if (interpolation.map !== void 0) {
          styles += interpolation.map;
        }
        return styles;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      } else if (true) {
        console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      }
      break;
    }
    case "string":
      if (true) {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function(match2, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, "") + "`");
          return "${" + fakeVarName + "}";
        });
        if (matched.length) {
          console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(matched, ["`" + replaced + "`"]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\n" + ("css`" + replaced + "`"));
        }
      }
      break;
  }
  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== void 0 ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== "object") {
        if (registered != null && registered[value] !== void 0) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === "NO_COMPONENT_SELECTOR" && true) {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (_key) {
            case "animation":
            case "animationName": {
              string += processStyleName(_key) + ":" + interpolated + ";";
              break;
            }
            default: {
              if (_key === "undefined") {
                console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
              }
              string += _key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;
if (true) {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
}
var cursor;
var serializeStyles = function serializeStyles2(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (strings[0] === void 0) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }
    styles += strings[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      if (strings[i] === void 0) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }
      styles += strings[i];
    }
  }
  var sourceMap;
  if (true) {
    styles = styles.replace(sourceMapPattern, function(match3) {
      sourceMap = match3;
      return "";
    });
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles)) !== null) {
    identifierName += "-" + // $FlowFixMe we know it's not null
    match2[1];
  }
  var name = emotion_hash_esm_default(styles) + identifierName;
  if (true) {
    return {
      name,
      styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }
  return {
    name,
    styles,
    next: cursor
  };
};

// node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var React2 = __toESM(require("react"));
var import_react2 = require("react");
var syncFallback = function syncFallback2(create) {
  return create();
};
var useInsertionEffect2 = React2["useInsertionEffect"] ? React2["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect2 || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect2 || import_react2.useLayoutEffect;

// node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js
var hasOwnProperty = {}.hasOwnProperty;
var EmotionCacheContext = /* @__PURE__ */ (0, import_react3.createContext)(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== "undefined" ? /* @__PURE__ */ emotion_cache_browser_esm_default({
    key: "css"
  }) : null
);
if (true) {
  EmotionCacheContext.displayName = "EmotionCacheContext";
}
var CacheProvider = EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ (0, import_react3.forwardRef)(function(props, ref) {
    var cache = (0, import_react3.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};
var ThemeContext = /* @__PURE__ */ (0, import_react3.createContext)({});
if (true) {
  ThemeContext.displayName = "EmotionThemeContext";
}
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var Insertion = function Insertion2(_ref) {
  var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache, serialized, isStringTag);
  });
  return null;
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props, cache, ref) {
  var cssProp = props.css;
  if (typeof cssProp === "string" && cache.registered[cssProp] !== void 0) {
    cssProp = cache.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, void 0, (0, import_react3.useContext)(ThemeContext));
  if (serialized.name.indexOf("-") === -1) {
    var labelFromStack = props[labelPropName];
    if (labelFromStack) {
      serialized = serializeStyles([serialized, "label:" + labelFromStack + ";"]);
    }
  }
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var key2 in props) {
    if (hasOwnProperty.call(props, key2) && key2 !== "css" && key2 !== typePropName && key2 !== labelPropName) {
      newProps[key2] = props[key2];
    }
  }
  newProps.ref = ref;
  newProps.className = className;
  return /* @__PURE__ */ (0, import_react3.createElement)(import_react3.Fragment, null, /* @__PURE__ */ (0, import_react3.createElement)(Insertion, {
    cache,
    serialized,
    isStringTag: typeof WrappedComponent === "string"
  }), /* @__PURE__ */ (0, import_react3.createElement)(WrappedComponent, newProps));
});
if (true) {
  Emotion.displayName = "EmotionCssPropInternal";
}

// node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var import_hoist_non_react_statics = __toESM(require_hoist_non_react_statics_cjs());
var pkg = {
  name: "@emotion/react",
  version: "11.10.5",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        "default": "./dist/emotion-react.esm.js"
      },
      "default": "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": "./macro.js"
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.js",
    "macro.d.ts",
    "macro.js.flow"
  ],
  sideEffects: false,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.10.5",
    "@emotion/cache": "^11.10.5",
    "@emotion/serialize": "^1.1.1",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
    "@emotion/utils": "^1.2.0",
    "@emotion/weak-memoize": "^0.3.0",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    "@babel/core": "^7.0.0",
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@babel/core": {
      optional: true
    },
    "@types/react": {
      optional: true
    }
  },
  devDependencies: {
    "@babel/core": "^7.18.5",
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.10.5",
    "@emotion/css-prettifier": "1.1.1",
    "@emotion/server": "11.10.0",
    "@emotion/styled": "11.10.5",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": "./macro.js"
      }
    }
  }
};
var warnedAboutCssPropForGlobal = false;
var Global = /* @__PURE__ */ withEmotionCache(function(props, cache) {
  if (!warnedAboutCssPropForGlobal && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (props.className || props.css)) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }
  var styles = props.styles;
  var serialized = serializeStyles([styles], void 0, (0, import_react4.useContext)(ThemeContext));
  var sheetRef = (0, import_react4.useRef)();
  useInsertionEffectWithLayoutFallback(function() {
    var key2 = cache.key + "-global";
    var sheet = new cache.sheet.constructor({
      key: key2,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false;
    var node2 = document.querySelector('style[data-emotion="' + key2 + " " + serialized.name + '"]');
    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }
    if (node2 !== null) {
      rehydrating = true;
      node2.setAttribute("data-emotion", key2);
      sheet.hydrate([node2]);
    }
    sheetRef.current = [sheet, rehydrating];
    return function() {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffectWithLayoutFallback(function() {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }
    if (serialized.next !== void 0) {
      insertStyles(cache, serialized.next, true);
    }
    if (sheet.tags.length) {
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }
    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});
if (true) {
  Global.displayName = "EmotionGlobal";
}
function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
var classnames = function classnames2(args) {
  var len = args.length;
  var i = 0;
  var cls = "";
  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null)
      continue;
    var toAdd = void 0;
    switch (typeof arg) {
      case "boolean":
        break;
      case "object": {
        if (Array.isArray(arg)) {
          toAdd = classnames2(arg);
        } else {
          if (arg.styles !== void 0 && arg.name !== void 0) {
            console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.");
          }
          toAdd = "";
          for (var k in arg) {
            if (arg[k] && k) {
              toAdd && (toAdd += " ");
              toAdd += k;
            }
          }
        }
        break;
      }
      default: {
        toAdd = arg;
      }
    }
    if (toAdd) {
      cls && (cls += " ");
      cls += toAdd;
    }
  }
  return cls;
};
function merge(registered, css2, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
  if (registeredStyles.length < 2) {
    return className;
  }
  return rawClassName + css2(registeredStyles);
}
var Insertion3 = function Insertion4(_ref) {
  var cache = _ref.cache, serializedArr = _ref.serializedArr;
  var rules = useInsertionEffectAlwaysWithSyncFallback(function() {
    for (var i = 0; i < serializedArr.length; i++) {
      var res = insertStyles(cache, serializedArr[i], false);
    }
  });
  return null;
};
var ClassNames = /* @__PURE__ */ withEmotionCache(function(props, cache) {
  var hasRendered = false;
  var serializedArr = [];
  var css2 = function css3() {
    if (hasRendered && true) {
      throw new Error("css can only be used during render");
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized);
    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };
  var cx31 = function cx32() {
    if (hasRendered && true) {
      throw new Error("cx can only be used during render");
    }
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return merge(cache.registered, css2, classnames(args));
  };
  var content = {
    css: css2,
    cx: cx31,
    theme: (0, import_react4.useContext)(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /* @__PURE__ */ (0, import_react4.createElement)(import_react4.Fragment, null, /* @__PURE__ */ (0, import_react4.createElement)(Insertion3, {
    cache,
    serializedArr
  }), ele);
});
if (true) {
  ClassNames.displayName = "EmotionClassNames";
}
if (true) {
  isBrowser3 = true;
  isTestEnv = typeof jest !== "undefined" || typeof vi !== "undefined";
  if (isBrowser3 && !isTestEnv) {
    globalContext = // $FlowIgnore
    typeof globalThis !== "undefined" ? globalThis : isBrowser3 ? window : global;
    globalKey = "__EMOTION_REACT_" + pkg.version.split(".")[0] + "__";
    if (globalContext[globalKey]) {
      console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used.");
    }
    globalContext[globalKey] = true;
  }
}
var isBrowser3;
var isTestEnv;
var globalContext;
var globalKey;

// src/components/VideoRecorder/VideoPane.tsx
var import_styled3 = __toESM(require("@emotion/styled"));
var import_react47 = __toESM(require("react"));
var import_react_fontawesome3 = require("@fortawesome/react-fontawesome");

// src/components/VideoRecorder/Timer.tsx
var import_classnames = __toESM(require("classnames"));
var import_react5 = __toESM(require("react"));
var import_luxon2 = require("luxon");

// src/utils/elapsed.ts
var import_luxon = require("luxon");
function elapsed(input, options) {
  const duration = (import_luxon.Duration.isDuration(input) ? input : import_luxon.Duration.fromObject({ seconds: input })).shiftTo("hours", "minutes", "seconds");
  const shouldPadMinutes = !(options == null ? void 0 : options.noPadMinutes);
  const format = ` ${duration.hours ? "hh:" : ""}${shouldPadMinutes ? "mm:ss" : "m:ss"}`;
  return duration.toFormat(format);
}

// src/components/VideoRecorder/Timer.tsx
var Timer = (0, import_react5.memo)(({ startTime, endTime, className }) => {
  const [intervalId, setIntervalId] = (0, import_react5.useState)();
  const [currentTick, setCurrentTick] = (0, import_react5.useState)(0);
  function tick() {
    setCurrentTick((tick2) => tick2 + 1);
  }
  (0, import_react5.useEffect)(() => {
    if (startTime != null && endTime == null) {
      setIntervalId(setInterval(tick, 250));
    } else if (intervalId) {
      clearInterval(intervalId);
    }
    return () => intervalId && clearInterval(intervalId);
  }, [startTime, endTime]);
  const output = (0, import_react5.useMemo)(() => {
    const now = import_luxon2.DateTime.local();
    let duration;
    if (startTime != null) {
      duration = (endTime != null ? endTime : now).diff(startTime);
    } else {
      duration = import_luxon2.Duration.fromMillis(0);
    }
    return elapsed(duration);
  }, [startTime, endTime, currentTick]);
  return /* @__PURE__ */ import_react5.default.createElement(
    "div",
    {
      className: (0, import_classnames.default)(
        "v2-text-md v2-px-2 v2-text-white v2-bg-black/20 v2-rounded-full",
        className
      )
    },
    output
  );
});
Timer.displayName = "Timer";
var Timer_default = Timer;

// src/components/VideoRecorder/Video.tsx
var import_classnames2 = __toESM(require("classnames"));

// node_modules/react-use/esm/misc/util.js
function on(obj) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  if (obj && obj.addEventListener) {
    obj.addEventListener.apply(obj, args);
  }
}
function off(obj) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  if (obj && obj.removeEventListener) {
    obj.removeEventListener.apply(obj, args);
  }
}
var isBrowser2 = typeof window !== "undefined";

// node_modules/react-use/esm/useEffectOnce.js
var import_react6 = require("react");
var useEffectOnce = function(effect) {
  (0, import_react6.useEffect)(effect, []);
};
var useEffectOnce_default = useEffectOnce;

// node_modules/react-use/esm/useEvent.js
var import_react7 = require("react");
var defaultTarget = isBrowser2 ? window : null;
var isListenerType1 = function(target) {
  return !!target.addEventListener;
};
var isListenerType2 = function(target) {
  return !!target.on;
};
var useEvent = function(name, handler, target, options) {
  if (target === void 0) {
    target = defaultTarget;
  }
  (0, import_react7.useEffect)(function() {
    if (!handler) {
      return;
    }
    if (!target) {
      return;
    }
    if (isListenerType1(target)) {
      on(target, name, handler, options);
    } else if (isListenerType2(target)) {
      target.on(name, handler, options);
    }
    return function() {
      if (isListenerType1(target)) {
        off(target, name, handler, options);
      } else if (isListenerType2(target)) {
        target.off(name, handler, options);
      }
    };
  }, [name, handler, target, JSON.stringify(options)]);
};
var useEvent_default = useEvent;

// node_modules/react-use/esm/useRafState.js
var import_react9 = require("react");

// node_modules/react-use/esm/useUnmount.js
var import_react8 = require("react");
var useUnmount = function(fn) {
  var fnRef = (0, import_react8.useRef)(fn);
  fnRef.current = fn;
  useEffectOnce_default(function() {
    return function() {
      return fnRef.current();
    };
  });
};
var useUnmount_default = useUnmount;

// node_modules/react-use/esm/useRafState.js
var useRafState = function(initialState2) {
  var frame = (0, import_react9.useRef)(0);
  var _a = (0, import_react9.useState)(initialState2), state = _a[0], setState = _a[1];
  var setRafState = (0, import_react9.useCallback)(function(value) {
    cancelAnimationFrame(frame.current);
    frame.current = requestAnimationFrame(function() {
      setState(value);
    });
  }, []);
  useUnmount_default(function() {
    cancelAnimationFrame(frame.current);
  });
  return [state, setRafState];
};
var useRafState_default = useRafState;

// node_modules/react-use/esm/useWindowSize.js
var import_react10 = require("react");
var useWindowSize = function(initialWidth, initialHeight) {
  if (initialWidth === void 0) {
    initialWidth = Infinity;
  }
  if (initialHeight === void 0) {
    initialHeight = Infinity;
  }
  var _a = useRafState_default({
    width: isBrowser2 ? window.innerWidth : initialWidth,
    height: isBrowser2 ? window.innerHeight : initialHeight
  }), state = _a[0], setState = _a[1];
  (0, import_react10.useEffect)(function() {
    if (isBrowser2) {
      var handler_1 = function() {
        setState({
          width: window.innerWidth,
          height: window.innerHeight
        });
      };
      on(window, "resize", handler_1);
      return function() {
        off(window, "resize", handler_1);
      };
    }
  }, []);
  return state;
};
var useWindowSize_default = useWindowSize;

// src/components/VideoRecorder/Video.tsx
var import_debounce = __toESM(require_debounce());
var import_partial = __toESM(require_partial());
var import_react11 = __toESM(require("react"));
var loadedData = (0, import_debounce.default)((callback, evt) => {
  setTimeout((0, import_partial.default)(callback, evt), 100);
}, 100);
var landscapeVideoClassName = "v2-h-full v2-w-auto v2-min-h-[min(100vh,450px)]";
var portraitVideoClassName = "v2-h-auto v2-w-full v2-min-w-[min(100vw,450px)]";
function Video(_a) {
  var _b = _a, {
    videoRef,
    canvasRef,
    src,
    mediaStream,
    preload = "auto"
  } = _b, props = __objRest(_b, [
    "videoRef",
    "canvasRef",
    "src",
    "mediaStream",
    "preload"
  ]);
  const windowSize = useWindowSize_default();
  const video = (0, import_react11.useRef)();
  const [canvasResolution, setCanvasResolution] = (0, import_react11.useState)({
    height: 450,
    width: 800
  });
  const [videoClassName, setVideoClassName] = (0, import_react11.useState)(
    windowSize.width > windowSize.height ? landscapeVideoClassName : portraitVideoClassName
  );
  function getVideoRef(ref) {
    videoRef.current = video.current = ref;
  }
  (0, import_react11.useEffect)(() => {
    var _a2;
    const handleLoadedData = (0, import_partial.default)(
      loadedData,
      (evt) => {
        const { videoWidth, videoHeight } = evt.target;
        const isLandscape = videoWidth > videoHeight;
        setVideoClassName(
          isLandscape ? landscapeVideoClassName : portraitVideoClassName
        );
      }
    );
    (_a2 = video.current) == null ? void 0 : _a2.addEventListener("loadeddata", handleLoadedData);
    return () => {
      var _a3;
      (_a3 = video.current) == null ? void 0 : _a3.removeEventListener("loadeddata", handleLoadedData);
    };
  }, [video]);
  (0, import_react11.useEffect)(() => {
    if (!video.current)
      return;
    if (src != null) {
      video.current.srcObject = null;
      if (video.current.readyState === 0) {
        video.current.load();
      }
    } else if (mediaStream != null) {
      video.current.srcObject = mediaStream;
      video.current.onloadedmetadata = function() {
        video.current.play().catch((e) => {
          console.debug(e);
        });
      };
    } else {
      video.current.srcObject = null;
    }
  }, [src, video.current, mediaStream]);
  return /* @__PURE__ */ import_react11.default.createElement(import_react11.default.Fragment, null, /* @__PURE__ */ import_react11.default.createElement(
    "video",
    __spreadProps(__spreadValues({
      className: (0, import_classnames2.default)(
        "v2-object-fit v2-absolute !v2-block v2-translate-x-[-50%] v2-translate-y-[-50%] v2-left-[50%] v2-top-[50%] v2-z-0 v2-max-w-none",
        {
          "v2-hidden": !!src
        },
        videoClassName
      ),
      ref: getVideoRef
    }, props), {
      src,
      preload,
      playsInline: true,
      onPlaying: () => setCanvasResolution({
        width: video.current.videoWidth,
        height: video.current.videoHeight
      })
    })
  ), /* @__PURE__ */ import_react11.default.createElement(
    "canvas",
    {
      id: "canvas",
      className: (0, import_classnames2.default)(
        "v2-object-fit v2-absolute !v2-block v2-translate-x-[-50%] v2-translate-y-[-50%] v2-left-[50%] v2-top-[50%] v2-z-0 v2-max-w-none",
        {
          "!v2-hidden": src
        },
        videoClassName
      ),
      ref: canvasRef,
      width: canvasResolution.width,
      height: canvasResolution.height
    }
  ));
}

// src/components/VideoRecorder/StartStop.tsx
var import_react12 = __toESM(require("react"));
var import_classnames3 = __toESM(require("classnames"));
var StartStop = ({
  isComplete: isComplete2,
  isPlaying,
  onStartClick,
  onStopClick,
  className
}) => {
  return /* @__PURE__ */ import_react12.default.createElement(
    "div",
    {
      role: "button",
      onClick: isPlaying ? onStopClick : onStartClick,
      className
    },
    /* @__PURE__ */ import_react12.default.createElement(
      "img",
      {
        src: assetUrl("video-recorder/ic_record_start.svg"),
        className: (0, import_classnames3.default)("v2-h-12 v2-w-12 v2-z-20", {
          "v2-hidden": isComplete2 || isPlaying
        })
      }
    ),
    /* @__PURE__ */ import_react12.default.createElement(
      "img",
      {
        src: assetUrl("video-recorder/ic_record_stop.svg"),
        className: (0, import_classnames3.default)("v2-h-12 v2-w-12 v2-z-20", {
          "v2-hidden": !isPlaying
        })
      }
    ),
    /* @__PURE__ */ import_react12.default.createElement(
      "img",
      {
        src: assetUrl("video-recorder/ic_record_play.svg"),
        className: (0, import_classnames3.default)("v2-h-12 v2-w-12 v2-z-20", {
          "v2-hidden": isPlaying || !isComplete2
        })
      }
    )
  );
};
var StartStop_default = StartStop;

// src/components/VideoRecorder/SettingsAlert.tsx
var import_classnames8 = __toESM(require("classnames"));
var import_react_i18next3 = require("react-i18next");
var import_react22 = __toESM(require("react"));

// src/components/Button/index.tsx
var import_react13 = __toESM(require("react"));
var import_classnames4 = __toESM(require("classnames"));
var sizeClasses = {
  DEFAULT: "v2-font-bold v2-border v2-font-circular",
  ["sm" /* Small */]: "v2-py-[5px] v2-px-2.5 v2-text-xs",
  ["md" /* Medium */]: "v2-py-2.5 v2-px-[15px] v2-text-[15px]",
  ["lg" /* Large */]: "v2-py-2.5 v2-px-[15px] v2-text-base",
  ["xl" /* ExtraLarge */]: "v2-py-2.5 v2-px-[15px] v2-text-lg"
};
var shapeClasses = {
  ["rectangle" /* Rectangle */]: "",
  ["round" /* Round */]: "v2-rounded-md"
};
var variantClasses = {
  ["danger" /* Danger */]: "v2-border-solid v2-border-pink-900 v2-text-white",
  ["danger-white" /* DangerWhite */]: "v2-border-solid v2-border-neutral-500 v2-text-neutral-900",
  ["default" /* Default */]: "v2-border-solid v2-border-turquoise v2-text-white",
  ["disabled" /* Disabled */]: "v2-border-solid v2-border-neutral-200 v2-text-neutral-400",
  ["primary" /* Primary */]: "v2-border-solid v2-text-neutral-900 v2-border-yellow-500",
  ["secondary" /* Secondary */]: "v2-border-solid v2-border-neutral-500",
  ["secondary-white" /* SecondaryWhite */]: "v2-text-white v2-border-solid v2-border-white",
  ["info" /* Info */]: "v2-text-brown-700 v2-border-solid v2-border-neutral-200",
  ["blue" /* Blue */]: "v2-text-white v2-border-solid v2-border-blue-500",
  ["magenta" /* Magenta */]: "v2-text-white v2-border-solid v2-border-magenta-500",
  ["icon" /* Icon */]: "v2-text-neutral-400 v2-border-none v2-outline-none",
  ["rounded" /* Rounded */]: "v2-cursor-pointer v2-rounded-full v2-border-1 v2-border-solid v2-border-neutral-500"
};
function Button(_a) {
  var _b = _a, {
    children,
    variant: variantProp,
    size: sizeProp,
    shape = "rectangle" /* Rectangle */,
    bgColorClassName,
    disableHover
  } = _b, props = __objRest(_b, [
    "children",
    "variant",
    "size",
    "shape",
    "bgColorClassName",
    "disableHover"
  ]);
  var _a2;
  const variant = (0, import_react13.useMemo)(() => {
    if (props.disabled) {
      return "disabled" /* Disabled */;
    }
    if (variantProp != null) {
      return variantProp;
    }
    if (props.primary) {
      return "primary" /* Primary */;
    }
    if (props.secondary) {
      return "secondary" /* Secondary */;
    }
    if (props.info) {
      return "info" /* Info */;
    }
    if (props.danger) {
      return "danger" /* Danger */;
    }
    return "default" /* Default */;
  }, [props]);
  const size = (0, import_react13.useMemo)(() => {
    if (sizeProp != null) {
      return sizeProp;
    }
    if (props.sm || props.small) {
      return "sm" /* Small */;
    }
    if (props.md || props.medium) {
      return "md" /* Medium */;
    }
    if (props.lg || props.large) {
      return "lg" /* Large */;
    }
    if (props.xl || props.extraLarge) {
      return "xl" /* ExtraLarge */;
    }
    return "md" /* Medium */;
  }, [props]);
  const disabledClass = (0, import_react13.useMemo)(() => {
    if (props.disabled) {
      switch (variant) {
        case "primary" /* Primary */:
          return "!v2-text-neutral-300 !v2-bg-neutral-100 !v2-border-neutral-100";
        case "secondary" /* Secondary */:
        case "secondary-white" /* SecondaryWhite */:
          return "!v2-text-neutral-300 !v2-bg-transparent !v2-border-white";
      }
    }
    return "";
  }, [props, variant]);
  const hoverClass = (0, import_react13.useMemo)(() => {
    if (!disableHover) {
      switch (variant) {
        case "danger" /* Danger */:
          return "hover:v2-bg-orange-700 hover:v2-border-orange-700";
        case "danger-white" /* DangerWhite */:
          return "hover:v2-bg-orange-600 hover:v2-border-orange-600 hover:v2-text-white";
        case "default" /* Default */:
          return "hover:v2-bg-turquoise-900 hover:v2-border-turquoise-900";
        case "disabled" /* Disabled */:
          return "hover:v2-bg-neutral-300 hover:v2-border-neutral-300 v2-cursor-not-allowed";
        case "primary" /* Primary */:
          return "hover:v2-bg-yellow-300 hover:v2-border-yellow-300";
        case "secondary" /* Secondary */:
          return "hover:v2-bg-yellow-500 hover:v2-border-transparent";
        case "secondary-white" /* SecondaryWhite */:
          return "hover:v2-bg-yellow-500 hover:v2-border-transparent hover:v2-text-neutral-900";
        case "blue" /* Blue */:
          return "hover:v2-bg-blue-700 hover:v2-border-blue-700";
        case "magenta" /* Magenta */:
          return "hover:v2-bg-magenta-700 hover:v2-border-magenta-700";
        case "info" /* Info */:
          return "hover:v2-bg-neutral-300 hover:v2-border-neutral-300";
        case "icon" /* Icon */:
          return "hover:v2-text-turquoise";
        case "rounded" /* Rounded */:
          return "hover:v2-bg-yellow-500 hover:v2-border-yellow-500";
      }
    }
    return "";
  }, [props, variant]);
  const bgColorClass = (0, import_react13.useMemo)(() => {
    if (!bgColorClassName) {
      switch (variant) {
        case "danger" /* Danger */:
          return "v2-bg-orange-600";
        case "danger-white" /* DangerWhite */:
          return "v2-bg-white";
        case "default" /* Default */:
          return "v2-bg-turquoise";
        case "disabled" /* Disabled */:
          return "v2-bg-neutral-200 ";
        case "primary" /* Primary */:
          return "v2-bg-yellow-500";
        case "secondary" /* Secondary */:
        case "secondary-white" /* SecondaryWhite */:
          return "v2-bg-transparent ";
        case "blue" /* Blue */:
          return "v2-bg-blue-500";
        case "magenta" /* Magenta */:
          return "v2-bg-magenta-500";
        case "info" /* Info */:
          return "v2-bg-neutral-200";
        case "icon" /* Icon */:
          return "v2-bg-transparent";
        case "rounded" /* Rounded */:
          return "v2-bg-transparent ";
      }
    }
    return bgColorClassName;
  }, [props, variant]);
  const className = (0, import_react13.useMemo)(() => {
    return [
      sizeClasses.DEFAULT,
      sizeClasses[size],
      shapeClasses[shape],
      variantClasses[variant],
      disabledClass,
      hoverClass,
      bgColorClass
    ].join(" ");
  }, [size, variant, shape]);
  return /* @__PURE__ */ import_react13.default.createElement("button", __spreadProps(__spreadValues({}, props), { className: (0, import_classnames4.default)(`${(_a2 = props.className) != null ? _a2 : ""} ${className}`) }), children);
}

// src/components/VideoRecorder/DevicesDropdown.tsx
var import_react18 = __toESM(require("react"));
var import_react_i18next = require("react-i18next");

// src/components/Select/index.tsx
var import_react17 = __toESM(require("react"));
var import_react_select2 = __toESM(require("react-select"));

// src/components/Select/Control.tsx
var import_react14 = __toESM(require("react"));
var import_classnames5 = __toESM(require("classnames"));
function Control(props) {
  const { children, isFocused, innerRef, innerProps } = props;
  const className = [
    props.className,
    "v2-relative v2-box-border",
    "v2-flex v2-items-center v2-justify-between v2-flex-wrap",
    "v2-bg-white",
    "v2-text-sm v2-font-normal",
    "v2-border v2-border-solid v2-rounded-md hover:v2-border-turquoise-500",
    "v2-shadow-none"
  ].join(" ");
  return /* @__PURE__ */ import_react14.default.createElement(
    "div",
    __spreadValues({
      ref: innerRef,
      className: (0, import_classnames5.default)(className, {
        "v2-text-turquoise-700 v2-border-turquoise-500": isFocused,
        "v2-text-neutral-400 v2-border-neutral-400": !isFocused
      })
    }, innerProps),
    children
  );
}

// src/components/Select/Option.tsx
var import_react15 = __toESM(require("react"));
var import_classnames6 = __toESM(require("classnames"));
function Option(props) {
  const { children, isDisabled, isFocused, isSelected, innerRef, innerProps } = props;
  const className = "v2-option v2-block v2-w-full v2-box-border v2-px-3 v2-py-2";
  return /* @__PURE__ */ import_react15.default.createElement(
    "div",
    __spreadValues({
      ref: innerRef,
      className: (0, import_classnames6.default)(className, {
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected v2-bg-turquoise-700 v2-text-white": isSelected,
        "v2-bg-turquoise-100": isFocused && !isSelected
      })
    }, innerProps),
    children
  );
}

// src/components/Select/DropdownIndicator.tsx
var import_react16 = __toESM(require("react"));
var import_react_select = require("react-select");
var import_classnames7 = __toESM(require("classnames"));
function DropdownIndicator(props) {
  const { menuIsOpen } = props.selectProps;
  return /* @__PURE__ */ import_react16.default.createElement(import_react_select.components.DropdownIndicator, __spreadValues({}, props), /* @__PURE__ */ import_react16.default.createElement(
    import_react_select.components.DownChevron,
    {
      className: (0, import_classnames7.default)("v2-transition-transform v2-transform", {
        "v2-rotate-180": menuIsOpen
      })
    }
  ));
}

// src/components/Select/index.tsx
function Select(_a) {
  var _b = _a, {
    clearable = false,
    disabled = false,
    loading = false,
    multi = false,
    rtl = false,
    searchable = false,
    relativeMenu = false,
    controlClassName,
    dropdownIndicatorClassName
  } = _b, props = __objRest(_b, [
    "clearable",
    "disabled",
    "loading",
    "multi",
    "rtl",
    "searchable",
    "relativeMenu",
    "controlClassName",
    "dropdownIndicatorClassName"
  ]);
  return /* @__PURE__ */ import_react17.default.createElement(
    import_react_select2.default,
    __spreadProps(__spreadValues({
      isClearable: clearable,
      isDisabled: disabled,
      isLoading: loading,
      isMulti: multi,
      isRtl: rtl,
      isSearchable: searchable
    }, props), {
      components: {
        Control: (controlProps) => /* @__PURE__ */ import_react17.default.createElement(Control, __spreadProps(__spreadValues({}, controlProps), { className: controlClassName })),
        Option,
        DropdownIndicator: (dropdownIndicatorProps) => /* @__PURE__ */ import_react17.default.createElement(
          DropdownIndicator,
          __spreadProps(__spreadValues({}, dropdownIndicatorProps), {
            className: dropdownIndicatorClassName
          })
        )
      },
      styles: {
        menu: (base) => __spreadProps(__spreadValues({}, base), {
          position: relativeMenu ? "relative" : "absolute"
        })
      }
    })
  );
}

// src/components/VideoRecorder/DevicesDropdown.tsx
var DevicesDropdown = ({
  devices,
  label,
  onChange,
  current,
  labelColorClassName = "text-white"
}) => {
  const { t } = (0, import_react_i18next.useTranslation)();
  return /* @__PURE__ */ import_react18.default.createElement("div", null, /* @__PURE__ */ import_react18.default.createElement("label", { className: `text-base ${labelColorClassName} text-bold` }, label), /* @__PURE__ */ import_react18.default.createElement(
    Select,
    {
      placeholder: t("videoRecorder:settings.select"),
      value: current,
      getOptionLabel: ({ label: label2 }) => label2,
      getOptionValue: ({ deviceId }) => deviceId,
      options: devices,
      onChange,
      maxMenuHeight: 120
    }
  ));
};
var DevicesDropdown_default = DevicesDropdown;

// src/components/VideoRecorder/support/Devices.ts
var import_react_query = require("react-query");

// src/utils/localStorage.ts
var import_localforage = __toESM(require("localforage"));
var keyToStr = (key2) => key2.join(".");
function remember(key2, value) {
  return import_localforage.default.setItem(keyToStr(key2), JSON.stringify(value));
}
function recall(key2) {
  return __async(this, null, function* () {
    const json = yield import_localforage.default.getItem(keyToStr(key2));
    if (json) {
      return JSON.parse(json);
    }
    return null;
  });
}

// src/components/VideoRecorder/support/Devices.ts
var queryKeys = {
  all: ["devices"],
  lists: () => [...queryKeys.all, "lists"],
  list: (kind) => [...queryKeys.lists(), { kind }],
  details: () => [...queryKeys.all, "details"],
  detail: (kind) => [...queryKeys.details(), kind]
};
var storageKeys = {
  all: ["bonjoro", "devices"],
  audioDevice: () => [...storageKeys.all, "audioinput"],
  videoDevice: () => [...storageKeys.all, "videoinput"]
};
function getDevices() {
  return __async(this, null, function* () {
    const allDevices = yield navigator.mediaDevices.enumerateDevices();
    if (allDevices.some((device) => device.deviceId.length === 0)) {
      throw new Error("No permissions");
    }
    return allDevices.filter((device) => device.kind.endsWith("input"));
  });
}
function useDevices() {
  return (0, import_react_query.useQuery)(queryKeys.lists(), getDevices, {
    staleTime: Infinity
  });
}
function useAudioDevices() {
  const { data: devices, isSuccess } = useDevices();
  const kind = "audioinput";
  return (0, import_react_query.useQuery)(
    queryKeys.list(kind),
    () => devices == null ? void 0 : devices.filter((device) => device.kind === kind),
    {
      enabled: isSuccess
    }
  );
}
function useVideoDevices() {
  const { data: devices, isSuccess } = useDevices();
  const kind = "videoinput";
  return (0, import_react_query.useQuery)(
    queryKeys.list(kind),
    () => devices == null ? void 0 : devices.filter((device) => device.kind === kind),
    {
      enabled: isSuccess
    }
  );
}
function rememberAudioDevice(device) {
  return remember(storageKeys.audioDevice(), device);
}
function rememberVideoDevice(device) {
  return remember(storageKeys.videoDevice(), device);
}
function useRememberAudioDevice() {
  const queryClient = (0, import_react_query.useQueryClient)();
  return (0, import_react_query.useMutation)(rememberAudioDevice, {
    onSuccess: (_, device) => {
      queryClient.setQueryData(queryKeys.detail("audioinput"), device);
    }
  });
}
function useRememberVideoDevice() {
  const queryClient = (0, import_react_query.useQueryClient)();
  return (0, import_react_query.useMutation)(rememberVideoDevice, {
    onSuccess: (_, device) => {
      queryClient.setQueryData(queryKeys.detail("videoinput"), device);
    }
  });
}
function deviceExists(device, devices) {
  return device != null && devices.some((d) => (d == null ? void 0 : d.deviceId) === device.deviceId);
}
function getAudioDevice() {
  return recall(storageKeys.audioDevice());
}
function useDevice(kind, getDevice) {
  const devicesResult = useDevices();
  const { data: devices = [], isSuccess } = devicesResult;
  const result = (0, import_react_query.useQuery)(queryKeys.detail(kind), getDevice, {
    enabled: isSuccess && devices.length > 0
  });
  const device = devices.find(
    (device2) => {
      var _a;
      return device2.kind === kind && device2.deviceId === ((_a = result.data) == null ? void 0 : _a.deviceId);
    }
  );
  return __spreadProps(__spreadValues({}, result), {
    data: device,
    isValidDevice: deviceExists(result.data, devices)
  });
}
function useAudioDevice() {
  return useDevice("audioinput", getAudioDevice);
}
function getVideoDevice() {
  return __async(this, null, function* () {
    return recall(storageKeys.videoDevice());
  });
}
function useVideoDevice() {
  return useDevice("videoinput", getVideoDevice);
}
function getDeviceName(deviceId, devices) {
  var _a;
  return (_a = devices == null ? void 0 : devices.find((device) => device.deviceId === deviceId)) == null ? void 0 : _a.label;
}

// src/utils/BrowserSupport.ts
var import_memoize3 = __toESM(require_memoize());
var detectBrowser = (0, import_memoize3.default)(() => {
  const isIE = !!document.documentMode;
  if (isIE) {
    return "ie";
  }
  const isEdge = !isIE && !!window.StyleMedia;
  if (isEdge) {
    return "edge";
  }
  const isChrome = !!window.chrome;
  if (isChrome) {
    return "chrome";
  }
  const isOpera = !!window.opera || navigator.userAgent.includes(" OPR/");
  if (isOpera) {
    return "opera";
  }
  const isFirefox = typeof InstallTrigger !== "undefined";
  if (isFirefox) {
    return "firefox";
  }
  const isSafari = /constructor/i.test(window.HTMLElement.toString()) || // eslint-disable-next-line
  function(p) {
    return p.toString() === "[object SafariRemoteNotification]";
  }(!window["safari"] || window["safari"].pushNotification) || navigator.userAgent.includes("Safari");
  if (isSafari) {
    return "safari";
  }
  const isBlink = (isChrome || isOpera) && !!window.CSS;
  if (isBlink) {
    return "blink";
  }
});

// src/components/VideoRecorder/support/settings.ts
var import_first = __toESM(require_first());
var import_intersection = __toESM(require_intersection());
var import_memoize4 = __toESM(require_memoize());
var defaultUserMediaConstraints = {
  audio: {
    sampleRate: 44100,
    sampleSize: 16
  },
  /**
   * If 1280x720 is not supported, `ideal` will look for resolution that is near 1280x720.
   * Note: Do not use `min` and `max` constraints as it throws an `OverConstraintError`
   * on the camera devices that does not support the resolutions. Unless we are willing to catch it
   * on `use-msr-handler` then use a fallback constraint that is supported by the camera device.
   */
  video: {
    facingMode: "user",
    width: {
      ideal: 1280
    },
    height: {
      ideal: 720
    }
  }
};
var RecordingQuality = /* @__PURE__ */ ((RecordingQuality2) => {
  RecordingQuality2["High"] = "high";
  RecordingQuality2["Medium"] = "medium";
  RecordingQuality2["Low"] = "low";
  return RecordingQuality2;
})(RecordingQuality || {});
function getVideoConstraints(videoDevice, quality = "medium" /* Medium */) {
  var _a;
  const capabilities = videoDevice && "getCapabilities" in videoDevice && videoDevice.getCapabilities() || void 0;
  let videoConstraints = {};
  if ((_a = capabilities == null ? void 0 : capabilities.facingMode) == null ? void 0 : _a.length) {
    videoConstraints = __spreadProps(__spreadValues({}, defaultUserMediaConstraints.video), {
      facingMode: capabilities.facingMode[0]
    });
  } else {
    videoConstraints = __spreadProps(__spreadValues({}, defaultUserMediaConstraints.video), {
      deviceId: videoDevice == null ? void 0 : videoDevice.deviceId,
      groupId: videoDevice == null ? void 0 : videoDevice.groupId,
      facingMode: void 0
    });
  }
  switch (quality) {
    case "high" /* High */:
      videoConstraints.width = {
        ideal: 1920
      };
      videoConstraints.height = {
        ideal: 1080
      };
      break;
    case "low" /* Low */:
      videoConstraints.width = {
        ideal: 854
      };
      videoConstraints.height = {
        ideal: 480
      };
      break;
    case "medium" /* Medium */:
    default:
      videoConstraints.width = {
        ideal: 1280
      };
      videoConstraints.height = {
        ideal: 720
      };
      break;
  }
  return videoConstraints;
}
var videoCodecs = ["vp9", "vp8", "avc1"];
function getDefaultVideoCodecForBrowser() {
  const browser = detectBrowser();
  switch (browser) {
    case "chrome":
      return "vp9";
    case "firefox":
      return "vp8";
    case "safari":
    default:
      return "avc1";
  }
}
var parseMimeType = (0, import_memoize4.default)((mimeType) => {
  var _a, _b;
  const [container, ...options] = mimeType.split(";");
  const optionsArray = options == null ? void 0 : options.map((option) => {
    const [name, args] = option.split("=");
    return {
      name,
      args: args == null ? void 0 : args.split(",")
    };
  });
  const codecs = (_b = (_a = optionsArray.find((option) => option.name === "codecs")) == null ? void 0 : _a.args) != null ? _b : [];
  return {
    container,
    codecs
  };
});
function getVp9VideoBitrate(quality) {
  const baseKbps = {
    ["high" /* High */]: 2800,
    ["medium" /* Medium */]: 1600,
    ["low" /* Low */]: 750
  };
  return baseKbps[quality] * 1e3;
}
function getVp8VideoBitrate(quality) {
  const baseKbps = {
    ["high" /* High */]: 3e3,
    ["medium" /* Medium */]: 1850,
    ["low" /* Low */]: 1e3
  };
  return baseKbps[quality] * 1e3;
}
function getH264VideoBitrate(quality) {
  const baseKbps = {
    ["high" /* High */]: 3500,
    ["medium" /* Medium */]: 1750,
    ["low" /* Low */]: 1400
  };
  return baseKbps[quality] * 1e3;
}
var getVideoBitrate = (0, import_memoize4.default)(
  (quality, mimeType) => {
    var _a;
    const { codecs } = parseMimeType(mimeType);
    const videoCodec = (_a = (0, import_first.default)((0, import_intersection.default)(videoCodecs, codecs))) != null ? _a : getDefaultVideoCodecForBrowser();
    switch (videoCodec) {
      case "vp9":
        return getVp9VideoBitrate(quality);
      case "vp8":
        return getVp8VideoBitrate(quality);
      case "avc1":
      default:
        return getH264VideoBitrate(quality);
    }
  },
  (quality, mimeType) => `${quality}${mimeType}`
);
function getMediaRecorderOptions({
  mimeType,
  quality
}) {
  return {
    mimeType,
    videoBitsPerSecond: getVideoBitrate(quality, mimeType)
  };
}
var storageKeys2 = {
  all: ["bonjoro", "settings"]
};
function rememberSettings(settings) {
  return __async(this, null, function* () {
    const currentSettings = yield getSettings();
    return remember(storageKeys2.all, __spreadValues(__spreadValues({}, currentSettings), settings));
  });
}
function getSettings() {
  return recall(storageKeys2.all);
}

// src/components/VideoRecorder/QualityDropdown.tsx
var import_react19 = __toESM(require("react"));
var import_react_i18next2 = require("react-i18next");
var QualityDropdown = ({
  label,
  onChange,
  current,
  disabled
}) => {
  const { t } = (0, import_react_i18next2.useTranslation)();
  const options = (0, import_react19.useMemo)(
    () => Object.values(RecordingQuality).map((quality) => ({
      label: t(`videoRecorder:settings.quality.${quality}`),
      value: quality
    })),
    []
  );
  const selected = (0, import_react19.useMemo)(
    () => options.find(({ value }) => value === current),
    [current]
  );
  return /* @__PURE__ */ import_react19.default.createElement("div", null, /* @__PURE__ */ import_react19.default.createElement("label", { className: "v2-text-white" }, label), /* @__PURE__ */ import_react19.default.createElement(
    Select,
    {
      disabled,
      placeholder: t("videoRecorder:settings.select"),
      value: selected,
      options,
      onChange: (option) => onChange == null ? void 0 : onChange(option.value),
      maxMenuHeight: 120
    }
  ));
};
var QualityDropdown_default = QualityDropdown;

// src/components/VideoRecorder/hooks/useRecordingQuality.ts
var import_react_query2 = require("react-query");
var import_react21 = require("react");

// src/components/VideoRecorder/VideoRecorderContext.ts
var import_react20 = require("react");
var VideoRecorderContext = (0, import_react20.createContext)({});
var VideoRecorderContext_default = VideoRecorderContext;

// src/components/VideoRecorder/hooks/useRecordingQuality.ts
var key = ["bonjoro", "video-recorder", "quality"];
function useRecordingQuality() {
  const queryClient = (0, import_react_query2.useQueryClient)();
  const query = (0, import_react_query2.useQuery)(key, () => recall(key));
  const { mutate } = (0, import_react_query2.useMutation)(
    (quality) => remember(key, quality),
    {
      onSuccess: (_, value) => {
        queryClient.setQueryData(key, value);
      }
    }
  );
  const { options: contextOptions } = (0, import_react21.useContext)(VideoRecorderContext_default);
  const defaultRecordingQuality = "medium" /* Medium */;
  const recordingQuality = (0, import_react21.useMemo)(() => {
    var _a, _b;
    return (_b = (_a = contextOptions.recordingQuality) != null ? _a : query.data) != null ? _b : defaultRecordingQuality;
  }, [contextOptions.recordingQuality, query]);
  return {
    defaultRecordingQuality,
    recordingQuality,
    setRecordingQuality: mutate,
    isLoading: query.isLoading
  };
}

// src/components/VideoRecorder/SettingsAlert.tsx
function Settings({
  onDeviceChange,
  onClose,
  className,
  positionClassName = "v2-absolute v2-top-0 v2-left-0",
  backgroundColorClassName = "v2-bg-neutral-800",
  textColorClassName = "v2-text-white",
  paddingClassName = "v2-p-7",
  hideTitle = false,
  hideSave = false
}) {
  const { data: videoDevice } = useVideoDevice();
  const { data: audioDevice } = useAudioDevice();
  const { data: videoDevices = [] } = useVideoDevices();
  const { data: audioDevices = [] } = useAudioDevices();
  const { mutateAsync: rememberAudioDevice2 } = useRememberAudioDevice();
  const { mutateAsync: rememberVideoDevice2 } = useRememberVideoDevice();
  const { recordingQuality, setRecordingQuality } = useRecordingQuality();
  const { options } = (0, import_react22.useContext)(VideoRecorderContext_default);
  const createDeviceChangeHandler = (onChangeAction) => (newValue) => {
    onChangeAction(newValue);
    onDeviceChange == null ? void 0 : onDeviceChange();
  };
  const handleVideoDeviceChange = (0, import_react22.useMemo)(
    () => createDeviceChangeHandler((device) => {
      void rememberVideoDevice2(device);
    }),
    [videoDevices]
  );
  const handleAudioDeviceChange = (0, import_react22.useMemo)(
    () => createDeviceChangeHandler((device) => {
      void rememberAudioDevice2(device);
    }),
    [audioDevices]
  );
  const handleConfirm = (0, import_react22.useCallback)(() => {
    onClose == null ? void 0 : onClose(videoDevice, audioDevice);
  }, [videoDevice, audioDevice]);
  const { t } = (0, import_react_i18next3.useTranslation)();
  return /* @__PURE__ */ import_react22.default.createElement(
    "div",
    {
      className: (0, import_classnames8.default)(
        "v2-h-full v2-w-full v2-flex v2-z-50",
        className,
        paddingClassName,
        positionClassName,
        backgroundColorClassName
      )
    },
    /* @__PURE__ */ import_react22.default.createElement("div", { className: "v2-my-auto v2-w-full" }, !hideTitle && /* @__PURE__ */ import_react22.default.createElement("h3", { className: `v2-text-xl ${textColorClassName} v2-text-center` }, t("videoRecorder:settings.header")), /* @__PURE__ */ import_react22.default.createElement(
      DevicesDropdown_default,
      {
        label: t("videoRecorder:settings.camera"),
        devices: videoDevices,
        current: videoDevice,
        onChange: handleVideoDeviceChange,
        labelColorClassName: textColorClassName
      }
    ), /* @__PURE__ */ import_react22.default.createElement(
      DevicesDropdown_default,
      {
        label: t("videoRecorder:settings.audio"),
        devices: audioDevices,
        current: audioDevice,
        onChange: handleAudioDeviceChange,
        labelColorClassName: textColorClassName
      }
    ), /* @__PURE__ */ import_react22.default.createElement(
      QualityDropdown_default,
      {
        label: "Quality",
        current: recordingQuality,
        onChange: setRecordingQuality,
        disabled: options.recordingQuality != null
      }
    ), !hideSave && /* @__PURE__ */ import_react22.default.createElement("div", { className: "v2-text-center v2-mt-4" }, /* @__PURE__ */ import_react22.default.createElement(Button, { md: true, onClick: handleConfirm }, t("videoRecorder:settings.save"))))
  );
}

// src/components/VideoRecorder/VideoDebug.tsx
var import_react23 = __toESM(require("react"));

// node_modules/reselect/es/defaultMemoize.js
var NOT_FOUND = "NOT_FOUND";
function createSingletonCache(equals) {
  var entry;
  return {
    get: function get(key2) {
      if (entry && equals(entry.key, key2)) {
        return entry.value;
      }
      return NOT_FOUND;
    },
    put: function put(key2, value) {
      entry = {
        key: key2,
        value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = void 0;
    }
  };
}
function createLruCache(maxSize, equals) {
  var entries = [];
  function get(key2) {
    var cacheIndex = entries.findIndex(function(entry2) {
      return equals(key2, entry2.key);
    });
    if (cacheIndex > -1) {
      var entry = entries[cacheIndex];
      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }
      return entry.value;
    }
    return NOT_FOUND;
  }
  function put(key2, value) {
    if (get(key2) === NOT_FOUND) {
      entries.unshift({
        key: key2,
        value
      });
      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }
  function getEntries() {
    return entries;
  }
  function clear() {
    entries = [];
  }
  return {
    get,
    put,
    getEntries,
    clear
  };
}
var defaultEqualityCheck = function defaultEqualityCheck2(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev2, next2) {
    if (prev2 === null || next2 === null || prev2.length !== next2.length) {
      return false;
    }
    var length2 = prev2.length;
    for (var i = 0; i < length2; i++) {
      if (!equalityCheck(prev2[i], next2[i])) {
        return false;
      }
    }
    return true;
  };
}
function defaultMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator);
  function memoized() {
    var value = cache.get(arguments);
    if (value === NOT_FOUND) {
      value = func.apply(null, arguments);
      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function(entry) {
          return resultEqualityCheck(entry.value, value);
        });
        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }
      cache.put(arguments, value);
    }
    return value;
  }
  memoized.clearCache = function() {
    return cache.clear();
  };
  return memoized;
}

// node_modules/reselect/es/index.js
function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
  if (!dependencies.every(function(dep) {
    return typeof dep === "function";
  })) {
    var dependencyTypes = dependencies.map(function(dep) {
      return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
    }).join(", ");
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }
  return dependencies;
}
function createSelectorCreator(memoize5) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }
  var createSelector2 = function createSelector3() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }
    var _recomputations = 0;
    var _lastResult;
    var directlyPassedOptions = {
      memoizeOptions: void 0
    };
    var resultFunc = funcs.pop();
    if (typeof resultFunc === "object") {
      directlyPassedOptions = resultFunc;
      resultFunc = funcs.pop();
    }
    if (typeof resultFunc !== "function") {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    }
    var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2;
    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize5.apply(void 0, [function recomputationWrapper() {
      _recomputations++;
      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions));
    var selector = memoize5(function dependenciesChecker() {
      var params = [];
      var length2 = dependencies.length;
      for (var i = 0; i < length2; i++) {
        params.push(dependencies[i].apply(null, arguments));
      }
      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    Object.assign(selector, {
      resultFunc,
      memoizedResultFunc,
      dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  };
  return createSelector2;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(defaultMemoize);

// src/components/VideoRecorder/store/Selectors.ts
var import_luxon3 = require("luxon");
function getStartTime(state) {
  var _a;
  return (_a = state.startTime) != null ? _a : void 0;
}
function getBlob(state) {
  return state.blob;
}
function getBlobs(state) {
  return state.blobs;
}
function getMediaStream(state) {
  var _a;
  return (_a = state.mediaStream) != null ? _a : void 0;
}
function getEndTime(state) {
  var _a;
  return (_a = state.endTime) != null ? _a : void 0;
}
function getVideoSourceUrl(state) {
  var _a;
  return (_a = state.videoSourceUrl) != null ? _a : null;
}
var isRecording = createSelector(
  getStartTime,
  getEndTime,
  (startTime, endTime) => startTime != null && endTime == null
);
function getDurationState(state) {
  return state.duration;
}
var getDuration = createSelector(
  getStartTime,
  getEndTime,
  getDurationState,
  (startTime, endTime, duration) => duration ? import_luxon3.Duration.fromObject({ seconds: duration }) : endTime != null ? endTime.diff(startTime != null ? startTime : import_luxon3.DateTime.local()) : 0
);
var isComplete = createSelector(
  getStartTime,
  getEndTime,
  getBlob,
  (startTime, endTime, blob) => startTime != null && endTime != null && blob != null
);
function getThumbnails(state) {
  return state.thumbs;
}
var getThumbnailCount = createSelector(
  getThumbnails,
  (thumbs) => thumbs.length
);
var getVideoUrl = createSelector(
  getBlob,
  getVideoSourceUrl,
  (blob, videoSourceUrl) => {
    if (videoSourceUrl)
      return videoSourceUrl;
    return blob != null ? URL.createObjectURL(blob) : null;
  }
);
var getVideoComponentProps = createSelector(
  getVideoUrl,
  getMediaStream,
  (videoUrl, mediaStream) => ({
    src: videoUrl != null ? videoUrl : void 0,
    mediaStream
  })
);
function getDeviceErrorStatus(state) {
  return state.deviceErrorStatus;
}
function getMetadata(state) {
  return state.metadata;
}

// src/components/VideoRecorder/VideoDebug.tsx
function VideoDebug({
  recorderState,
  videoRef,
  currentHandler
}) {
  var _a, _b, _c, _d, _e, _f, _g;
  const { state } = (0, import_react23.useContext)(VideoRecorderContext_default);
  const metadata = (0, import_react23.useMemo)(
    () => getMetadata(state),
    [state.metadata]
  );
  const resolution = (_a = metadata == null ? void 0 : metadata.video) == null ? void 0 : _a.resolution;
  const videoDevice = (_b = metadata == null ? void 0 : metadata.video) == null ? void 0 : _b.device;
  const aspectRatio = (_c = metadata == null ? void 0 : metadata.video) == null ? void 0 : _c.aspectRatio;
  const frameRate = (_d = metadata == null ? void 0 : metadata.video) == null ? void 0 : _d.frameRate;
  const audioDevice = (_e = metadata == null ? void 0 : metadata.audio) == null ? void 0 : _e.device;
  const sampleRate = (_f = metadata == null ? void 0 : metadata.audio) == null ? void 0 : _f.sampleRate;
  const sampleSize = (_g = metadata == null ? void 0 : metadata.audio) == null ? void 0 : _g.sampleSize;
  const [readyState, setReadyState] = (0, import_react23.useState)();
  (0, import_react23.useEffect)(() => {
    var _a2;
    function updateReadyState() {
      var _a3;
      setReadyState((_a3 = videoRef.current) == null ? void 0 : _a3.readyState);
    }
    function handleDataLoaded() {
      updateReadyState();
    }
    (_a2 = videoRef.current) == null ? void 0 : _a2.addEventListener("loadeddata", handleDataLoaded);
    return () => {
      var _a3;
      (_a3 = videoRef.current) == null ? void 0 : _a3.removeEventListener("loadeddata", handleDataLoaded);
    };
  }, [videoRef.current]);
  return /* @__PURE__ */ import_react23.default.createElement("div", { className: "v2-text-white v2-absolute v2-z-20 v2-left-2 v2-top-[60px] v2-pointer-events-none v2-select-none" }, /* @__PURE__ */ import_react23.default.createElement("div", null, "state: ", recorderState), /* @__PURE__ */ import_react23.default.createElement("div", null, "video device: ", videoDevice), /* @__PURE__ */ import_react23.default.createElement("div", null, "resolution:", " ", resolution && `${resolution.width}x${resolution.height}`), /* @__PURE__ */ import_react23.default.createElement("div", null, "aspect ratio: ", aspectRatio == null ? void 0 : aspectRatio.toFixed(2)), /* @__PURE__ */ import_react23.default.createElement("div", null, "frame rate: ", frameRate), /* @__PURE__ */ import_react23.default.createElement("div", null, "audio device: ", audioDevice), /* @__PURE__ */ import_react23.default.createElement("div", null, "sample rate: ", sampleRate), /* @__PURE__ */ import_react23.default.createElement("div", null, "sample size: ", sampleSize), /* @__PURE__ */ import_react23.default.createElement("div", null, "ready state: ", readyState), /* @__PURE__ */ import_react23.default.createElement("div", null, "handler: ", currentHandler));
}

// node_modules/use-reducer-logger/srhfl.js
var import_react24 = require("react");
var logger = (reducer) => {
  const reducerWithLogger = (0, import_react24.useCallback)((state, action) => {
    const next2 = reducer(state, action);
    console.log("%cPrevious State:", "color: #9E9E9E; font-weight: 700;", state);
    console.log("%cAction:", "color: #00A7F7; font-weight: 700;", action);
    console.log("%cNext State:", "color: #47B04B; font-weight: 700;", next2);
    return next2;
  }, [reducer]);
  return reducerWithLogger;
};
var srhfl_default = logger;

// src/components/VideoRecorder/store/Actions.ts
var Actions_exports = {};
__export(Actions_exports, {
  addBlob: () => addBlob,
  addThumbnail: () => addThumbnail,
  createBlob: () => createBlob,
  init: () => init,
  loadExternalVideo: () => loadExternalVideo,
  removeLoadedVideo: () => removeLoadedVideo,
  setBlob: () => setBlob,
  setDeviceErrorStatus: () => setDeviceErrorStatus,
  setDuration: () => setDuration,
  setEndTime: () => setEndTime,
  setIsExternalVideo: () => setIsExternalVideo,
  setMediaStream: () => setMediaStream,
  setMetadata: () => setMetadata,
  setRecorder: () => setRecorder,
  setRecorderState: () => setRecorderState,
  setStartTime: () => setStartTime,
  setVideoSourceUrl: () => setVideoSourceUrl
});
var import_luxon4 = require("luxon");
var import_toolkit = require("@reduxjs/toolkit");
var import_toolkit2 = require("@reduxjs/toolkit");

// src/components/VideoRecorder/store/ActionTypes.ts
var ActionTypes_default = {
  RECORDER_INIT: "RECORDER_INIT",
  RECORDER_RECORDING_START: "RECORDER_RECORDING_START",
  RECORDER_RECORDING_END: "RECORDER_RECORDING_END",
  RECORDER_ADD_THUMBNAIL: "RECORDER_ADD_THUMBNAIL",
  RECORDER_SET_BLOB: "RECORDER_SET_BLOB",
  RECORDER_ADD_BLOB: "RECORDER_ADD_BLOB",
  RECORDER_SET_MEDIA_STREAM: "RECORDER_SET_MEDIA_STREAM",
  RECORDER_SET_RECORDER: "RECORDER_SET_RECORDER",
  RECORDER_SET_IS_EXTERNAL_VIDEO: "RECORDER_SET_IS_EXTERNAL_VIDEO",
  RECORDER_SET_DURATION: "RECORDER_SET_DURATION",
  RECORDER_SET_VIDEO_SOURCE_URL: "RECORDER_SET_VIDEO_SOURCE_URL",
  RECORDER_SET_DEVICE_ERROR_STATUS: "RECORDER_SET_DEVICE_ERROR_STATUS",
  RECORDER_SET_RECORDER_STATE: "RECORDER_SET_RECORDER_STATE",
  RECORDER_SET_METADATA: "RECORDER_SET_METADATA"
};

// src/components/VideoRecorder/RecorderState.ts
var RecorderState = /* @__PURE__ */ ((RecorderState2) => {
  RecorderState2["WaitingForDevices"] = "waiting_for_devices";
  RecorderState2["GenerateThumbnails"] = "generate_thumbnails";
  RecorderState2["Counting"] = "counting";
  RecorderState2["Init"] = "init";
  RecorderState2["Loading"] = "loading";
  RecorderState2["Idle"] = "idle";
  RecorderState2["Starting"] = "starting";
  RecorderState2["Recording"] = "recording";
  RecorderState2["Finishing"] = "finishing";
  RecorderState2["Complete"] = "complete";
  RecorderState2["Playing"] = "playing";
  return RecorderState2;
})(RecorderState || {});
var RecorderState_default = RecorderState;

// src/components/VideoRecorder/store/Actions.ts
var import_once = __toESM(require_once());
var setStartTime = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_RECORDING_START
);
var setEndTime = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_RECORDING_END
);
var init = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_INIT
);
var setBlob = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_BLOB
);
var addBlob = (0, import_toolkit2.createAction)(ActionTypes_default.RECORDER_ADD_BLOB);
var setMediaStream = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_MEDIA_STREAM
);
var setMetadata = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_METADATA
);
var setRecorder = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_RECORDER
);
var setIsExternalVideo = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_IS_EXTERNAL_VIDEO
);
var setDuration = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_DURATION
);
var setVideoSourceUrl = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_VIDEO_SOURCE_URL
);
var addThumbnail = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_ADD_THUMBNAIL
);
var loadExternalVideoAction = (0, import_toolkit2.createAction)(
  "RECORDER_LOAD_EXTERNAL_VIDEO"
);
var loadExternalVideo = (file) => (dispatch) => {
  dispatch(loadExternalVideoAction(file));
  const actions = (0, import_toolkit.bindActionCreators)(
    {
      setBlob,
      init,
      setStartTime,
      setEndTime,
      setRecorder,
      setIsExternalVideo,
      setDuration,
      setVideoSourceUrl
    },
    // eslint-disable-next-line
    dispatch
  );
  actions.init(RecorderState_default.Idle);
  actions.setBlob(file);
  actions.setVideoSourceUrl(null);
  actions.setIsExternalVideo(true);
  const video = document.createElement("video");
  video.muted = true;
  video.id = "external-video-loader";
  video.className = "v2-hidden";
  let interval = null;
  const handleSeeked = (0, import_once.default)(() => {
    interval && clearInterval(interval);
    const start = import_luxon4.DateTime.local();
    const end = start.plus({ seconds: video.duration });
    actions.setStartTime(start);
    actions.setEndTime(end);
    actions.setDuration(video.duration);
    URL.revokeObjectURL(video.src);
    video.removeEventListener("seeked", handleSeeked);
    document.body.removeChild(video);
  });
  interval = setInterval(() => {
    if (isFinite(video.duration)) {
      handleSeeked();
    }
  }, 250);
  const handleLoadedMetadata = () => {
    if (isFinite(video.duration)) {
      handleSeeked();
    } else {
      video.currentTime = 86400;
    }
    video.removeEventListener("loadedmetadata", handleLoadedMetadata);
  };
  video.addEventListener("seeked", handleSeeked);
  video.addEventListener("loadedmetadata", handleLoadedMetadata);
  document.body.appendChild(video);
  video.src = URL.createObjectURL(file);
};
var removeLoadedVideo = () => (dispatch) => {
  const actions = (0, import_toolkit.bindActionCreators)(
    {
      setBlob,
      setStartTime,
      setEndTime,
      setRecorder,
      setDuration,
      setVideoSourceUrl
    },
    // eslint-disable-next-line
    dispatch
  );
  actions.setBlob(null);
  actions.setRecorder(null);
  actions.setStartTime(null);
  actions.setEndTime(null);
  actions.setDuration(null);
  actions.setVideoSourceUrl(null);
};
var createBlob = () => (dispatch, getState) => {
  var _a;
  const blobs = getBlobs(getState());
  dispatch(setBlob(new Blob(blobs, { type: (_a = blobs[0]) == null ? void 0 : _a.type })));
};
var setDeviceErrorStatus = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_DEVICE_ERROR_STATUS
);
var setRecorderState = (0, import_toolkit2.createAction)(
  ActionTypes_default.RECORDER_SET_RECORDER_STATE
);

// src/components/VideoRecorder/store/index.ts
var import_toolkit3 = require("@reduxjs/toolkit");

// src/hook/use-thunk-reducer-hook.ts
var import_react25 = require("react");
function useThunkReducer(reducer, initialArg, init2 = (a) => a) {
  const [hookState, setHookState] = (0, import_react25.useState)(() => init2(initialArg));
  const state = (0, import_react25.useRef)(hookState);
  const getState = (0, import_react25.useCallback)(() => state.current, [state]);
  const setState = (0, import_react25.useCallback)((newState) => {
    state.current = newState;
    setHookState(newState);
  }, [state, setHookState]);
  const reduce = (0, import_react25.useCallback)((action) => {
    return reducer(getState(), action);
  }, [reducer, getState]);
  const dispatch = (0, import_react25.useCallback)((action) => {
    return typeof action === "function" ? action(dispatch, getState) : setState(reduce(action));
  }, [getState, setState, reduce]);
  return [hookState, dispatch];
}

// src/components/VideoRecorder/store/index.ts
var initialState = {
  recorderState: RecorderState_default.Init,
  startTime: null,
  endTime: null,
  thumbs: [],
  blob: null,
  blobs: [],
  recorder: null,
  mediaStream: null,
  isExternalVideo: false,
  duration: null,
  videoSourceUrl: null
};
var recorderReducer = (0, import_toolkit3.createReducer)(initialState, (builder) => {
  builder.addCase(init, (_, action) => {
    var _a;
    return __spreadProps(__spreadValues({}, initialState), {
      recorderState: (_a = action.payload) != null ? _a : initialState.recorderState
    });
  });
  builder.addCase(setStartTime, (state, action) => {
    state.startTime = action.payload;
    state.endTime = null;
  });
  builder.addCase(setEndTime, (state, action) => {
    state.endTime = action.payload;
  });
  builder.addCase(addThumbnail, (state, action) => {
    const thumb = action.payload;
    if (thumb.hash && state.thumbs.findIndex((t) => t.hash === thumb.hash) !== -1) {
      console.warn("VideoRecorder: found duplicate thumbnail hash", thumb.hash);
      return;
    }
    state.thumbs = [...state.thumbs, thumb];
  });
  builder.addCase(setBlob, (state, action) => {
    state.blob = action.payload;
  });
  builder.addCase(addBlob, (state, action) => {
    state.blobs.push(action.payload);
  });
  builder.addCase(setMediaStream, (state, action) => {
    var _a;
    state.mediaStream = (_a = action.payload) != null ? _a : null;
  });
  builder.addCase(setMetadata, (state, action) => {
    state.metadata = action.payload;
    const { duration } = action.payload;
    if (duration && isFinite(duration) && state.startTime) {
      state.endTime = state.startTime.plus({ seconds: duration });
    }
  });
  builder.addCase(setRecorder, (state, action) => {
    state.recorder = action.payload;
  });
  builder.addCase(setIsExternalVideo, (state, action) => {
    state.isExternalVideo = action.payload;
  });
  builder.addCase(setDuration, (state, action) => {
    state.duration = action.payload;
  });
  builder.addCase(setVideoSourceUrl, (state, action) => {
    state.videoSourceUrl = action.payload;
  });
  builder.addCase(setDeviceErrorStatus, (state, action) => {
    state.deviceErrorStatus = action.payload;
  });
  builder.addCase(setRecorderState, (state, action) => {
    state.recorderState = action.payload;
  });
});
var useRecorderReducer = () => {
  return useThunkReducer(
    srhfl_default(recorderReducer),
    initialState
  );
};

// src/components/VideoRecorder/MirrorControl.tsx
var import_react40 = __toESM(require("react"));
var import_classnames21 = __toESM(require("classnames"));

// src/components/Nav/MainNavigation/LogoHeader.tsx
var import_react26 = __toESM(require("react"));
var import_classnames9 = __toESM(require("classnames"));

// src/components/Nav/MainNavigation/MainNavigation.tsx
var import_react27 = __toESM(require("react"));
var import_classnames10 = __toESM(require("classnames"));

// src/components/Nav/MainNavigation/MaskedImage.tsx
var import_react28 = __toESM(require("react"));
var import_styled = __toESM(require("@emotion/styled"));
var import_classnames11 = __toESM(require("classnames"));
var Image2 = import_styled.default.i`
  ${({ imageUrl, bgColor, hideWhiteBackground = false }) => `
    ${!hideWhiteBackground ? "background-color: white;" : ""}
    ${bgColor ? `background-color: ${bgColor} !important;` : ""}
    mask: url("${imageUrl}");
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
  `}
`;

// src/components/Nav/MainNavigation/NavContainer.tsx
var import_react29 = __toESM(require("react"));
var import_classnames12 = __toESM(require("classnames"));

// src/components/Nav/MainNavigation/NavGroup.tsx
var import_react30 = __toESM(require("react"));
var import_classnames13 = __toESM(require("classnames"));

// src/components/Nav/MainNavigation/NavItem.tsx
var import_react32 = __toESM(require("react"));
var import_classnames15 = __toESM(require("classnames"));
var import_styled2 = __toESM(require("@emotion/styled"));

// src/components/Nav/MainNavigation/NavItemLabel.tsx
var import_react31 = __toESM(require("react"));
var import_classnames14 = __toESM(require("classnames"));

// src/components/Nav/MainNavigation/NavItem.tsx
var hoverImageStyle = (hoverImageUrl) => `
  i {
    background: url("${hoverImageUrl != null ? hoverImageUrl : ""}") no-repeat 0 0;
    background-position: center;
    mask: none;
  }
`;
var ItemContainer = import_styled2.default.li`
  ${({ hoverImageUrl, active }) => `
    ${hoverImageUrl ? `:hover { ${hoverImageStyle(hoverImageUrl)}}` : ""}
    ${active ? hoverImageStyle(hoverImageUrl) : ""}
  `}
`;

// src/components/Nav/NavProfileDropdown/NavProfileDropdown.tsx
var import_react39 = __toESM(require("react"));
var import_classnames20 = __toESM(require("classnames"));

// src/components/Nav/NavProfileIcon/NavProfileIcon.tsx
var import_react33 = __toESM(require("react"));
var import_classnames16 = __toESM(require("classnames"));
var import_react_fontawesome2 = require("@fortawesome/react-fontawesome");

// src/components/Nav/NavProfileDropdown/NavProfileDropdownItems.tsx
var import_react35 = __toESM(require("react"));

// src/components/Nav/NavProfileDropdown/NavProfileDropdownItem.tsx
var import_react34 = __toESM(require("react"));
var import_classnames17 = __toESM(require("classnames"));

// src/components/Dropdown/Dropdown.tsx
var import_react38 = __toESM(require("react"));
var import_classnames19 = __toESM(require("classnames"));

// src/components/Dropdown/DropdownContainer.tsx
var import_react36 = __toESM(require("react"));
var import_classnames18 = __toESM(require("classnames"));

// src/hook/use-detect-outside-click-hook.ts
var import_react37 = require("react");

// src/components/VideoRecorder/MirrorControl.tsx
function MirrorControl({
  mirrored,
  onMirror,
  className
}) {
  return /* @__PURE__ */ import_react40.default.createElement(
    "div",
    {
      className: (0, import_classnames21.default)(
        "v2-rounded-full v2-flex v2-gap-1 v2-text-white v2-h-8 v2-px-3 v2-items-center v2-cursor-pointer",
        {
          "v2-bg-black/20 hover:v2-bg-black/70": mirrored,
          "v2-bg-black/70 hover:v2-bg-black/20": !mirrored
        },
        className
      ),
      onClick: onMirror
    },
    /* @__PURE__ */ import_react40.default.createElement(
      Image2,
      {
        imageUrl: "https://cdn.bonjoro.com/assets/Flat-icons/mirror.svg",
        className: (0, import_classnames21.default)("v2-h-5 v2-w-5 v2-text-white")
      }
    ),
    /* @__PURE__ */ import_react40.default.createElement("div", null, mirrored ? "Mirrored" : "Mirror")
  );
}

// src/components/VideoRecorder/TimerControl.tsx
var import_react41 = __toESM(require("react"));
var import_classnames22 = __toESM(require("classnames"));
function TimerControl({
  enable,
  onToggle,
  className
}) {
  return /* @__PURE__ */ import_react41.default.createElement(
    "div",
    {
      className: (0, import_classnames22.default)(
        "v2-rounded-full v2-flex v2-gap-1 v2-w-8 v2-h-8 v2-px-2 v2-items-center v2-cursor-pointer v2-ml-auto",
        {
          "v2-bg-black/20 v2-text-white hover:v2-bg-black/70": !enable,
          "v2-bg-[#fbd001] v2-text-black ": enable
        },
        className
      ),
      onClick: onToggle
    },
    /* @__PURE__ */ import_react41.default.createElement(
      Image2,
      {
        imageUrl: "https://cdn.bonjoro.com/assets/Flat-icons/timer.svg",
        className: (0, import_classnames22.default)("v2-h-5 v2-w-5 v2-text-white")
      }
    )
  );
}

// src/components/VideoRecorder/CountdownTimer.tsx
var import_react42 = __toESM(require("react"));
var import_classnames23 = __toESM(require("classnames"));
function CountdownTimer({ time, className }) {
  return /* @__PURE__ */ import_react42.default.createElement(
    "div",
    {
      className: (0, import_classnames23.default)(
        "v2-absolute v2-inset-x-0 v2-inset-y-0 v2-m-auto v2-flex v2-flex-col v2-w-[100px] v2-h-fit",
        className
      )
    },
    /* @__PURE__ */ import_react42.default.createElement("div", { className: "v2-flex v2-flex-grow v2-z-20 v2-items-center v2-justify-center" }, /* @__PURE__ */ import_react42.default.createElement("div", { className: "v2-text-[200px] v2-text-white/50 v2-leading-[150px] v2-font-bold" }, time))
  );
}

// src/components/VideoRecorder/AudioIndicator.tsx
var import_react44 = __toESM(require("react"));
var import_classnames24 = __toESM(require("classnames"));

// src/components/VideoRecorder/volume-meter-processor.ts
var audioWorkletName = "volume-meter";
var volume_meter_processor_default = `if (globalThis.AudioWorkletProcessor) {
const SMOOTHING_FACTOR = 0.8;
const FRAME_PER_SECOND = 60;
const FRAME_INTERVAL = 1 / FRAME_PER_SECOND;

/**
 *  Measure microphone volume.
 *
 * @class VolumeMeter
 * @extends AudioWorkletProcessor
 */
class VolumeMeter extends AudioWorkletProcessor {
  constructor() {
    super();
    this._lastUpdate = currentTime;
    this._volume = 0;
  }

  calculateRMS(inputChannelData) {
    // Calculate the squared-sum.
    let sum = 0;
    for (let i = 0; i < inputChannelData.length; i++) {
      sum += inputChannelData[i] * inputChannelData[i];
    }

    // Calculate the RMS level and update the volume.
    let rms = Math.sqrt(sum / inputChannelData.length);
    this._volume = Math.max(rms, this._volume * SMOOTHING_FACTOR);
  }

  process(inputs, outputs) {
    // This example only handles mono channel.
    const inputChannelData = inputs[0][0];

    // Post a message to the node every 16ms.
    if (currentTime - this._lastUpdate > FRAME_INTERVAL) {
      this.calculateRMS(inputChannelData);
      this.port.postMessage(this._volume * 1000);
      this._lastUpdate = currentTime;
    }

    return true;
  }
}

registerProcessor('${audioWorkletName}', VolumeMeter);
}`;

// src/components/VideoRecorder/hooks/use-has-audio.ts
var import_react43 = require("react");
function useHasAudio(mediaStream) {
  const [hasAudio, setHasAudio] = (0, import_react43.useState)(true);
  (0, import_react43.useEffect)(() => {
    const intervalId = setInterval(() => {
      if (!mediaStream)
        return;
      if (!mediaStream.getAudioTracks().length) {
        setHasAudio(false);
        return;
      }
      setHasAudio(mediaStream.getAudioTracks()[0].readyState == "live");
    }, 500);
    return () => clearInterval(intervalId);
  }, [mediaStream]);
  return hasAudio;
}

// src/components/VideoRecorder/AudioIndicator.tsx
var AUDIO_LEVEL_COLORS_CLASSNAME = [
  "v2-bg-blue-100",
  "v2-bg-blue-100",
  "v2-bg-blue-200",
  "v2-bg-blue-200",
  "v2-bg-blue-400",
  "v2-bg-blue-400",
  "v2-bg-blue-500",
  "v2-bg-blue-500",
  "v2-bg-blue-600",
  "v2-bg-blue-600",
  "v2-bg-blue-700",
  "v2-bg-blue-700"
];
var AUDIO_TOGGLE_CLASSNAME = "v2-h-5 v2-w-5 v2-text-white";
var SOUND_CHECK_IN_SECONDS = 5;
var RUN_SOUND_CHECK_IN_MILLISECONDS = 500;
function AudioIndicator({
  className,
  mediaStream,
  isRecording: isRecording2,
  onHasAudioChange
}) {
  const [showAudioIndicator, setShowAudioIndicator] = (0, import_react44.useState)(true);
  const [audioContext, setAudioContext] = (0, import_react44.useState)();
  const [volume, setVolume] = (0, import_react44.useState)(0);
  const [hasAudio, setHasAudio] = (0, import_react44.useState)(true);
  const [stopAudioCheckInterval, setStopAudioCheckInterval] = (0, import_react44.useState)(false);
  const hasAudioTrack = useHasAudio(mediaStream);
  const [soundCheckMilliSeconds, setSoundCheckMilliSeconds] = (0, import_react44.useState)(0);
  (0, import_react44.useEffect)(() => {
    if (!hasAudioTrack) {
      setHasAudio(false);
    }
  }, [hasAudioTrack]);
  (0, import_react44.useEffect)(() => {
    if (hasAudio && stopAudioCheckInterval)
      return;
    if (volume) {
      setStopAudioCheckInterval(true);
      setHasAudio(true);
    }
  }, [volume]);
  (0, import_react44.useEffect)(() => {
    onHasAudioChange == null ? void 0 : onHasAudioChange(hasAudio);
  }, [hasAudio]);
  (0, import_react44.useEffect)(() => {
    setSoundCheckMilliSeconds(0);
  }, [mediaStream]);
  (0, import_react44.useEffect)(() => {
    if (!isRecording2)
      return;
    if (soundCheckMilliSeconds / 1e3 >= SOUND_CHECK_IN_SECONDS)
      return;
    const intervalId = setInterval(() => {
      if (stopAudioCheckInterval) {
        clearInterval(intervalId);
        return;
      }
      const nextSoundCheckMilliSeconds = soundCheckMilliSeconds + RUN_SOUND_CHECK_IN_MILLISECONDS;
      setSoundCheckMilliSeconds(nextSoundCheckMilliSeconds);
      if (nextSoundCheckMilliSeconds / 1e3 >= SOUND_CHECK_IN_SECONDS) {
        setHasAudio(false);
        clearInterval(intervalId);
        return;
      }
    }, RUN_SOUND_CHECK_IN_MILLISECONDS);
    return () => clearInterval(intervalId);
  }, [isRecording2, stopAudioCheckInterval, soundCheckMilliSeconds]);
  const startAudio = (context) => __async(this, null, function* () {
    if (!mediaStream)
      return;
    yield context.audioWorklet.addModule(
      URL.createObjectURL(
        new Blob([volume_meter_processor_default], { type: "text/javascript" })
      )
    );
    const micNode = context.createMediaStreamSource(mediaStream);
    const volumeMeterNode = new AudioWorkletNode(context, audioWorkletName);
    volumeMeterNode.port.onmessage = ({ data }) => {
      setVolume(Math.round(data / 10));
    };
    micNode.connect(volumeMeterNode).connect(context.destination);
  });
  const startAudioContext = () => {
    const audioContext2 = new AudioContext();
    void startAudio(audioContext2);
    setAudioContext(audioContext2);
  };
  const toggleAudio = () => {
    if (showAudioIndicator && audioContext) {
      void audioContext.close();
    } else {
      startAudioContext();
    }
    const newShowIndicator = !showAudioIndicator;
    void rememberSettings({
      showAudioIndicator: newShowIndicator
    });
    setShowAudioIndicator(newShowIndicator);
  };
  const startAudioIndicator = () => __async(this, null, function* () {
    if (audioContext) {
      yield audioContext.close();
    }
    const showAudioIndicatorState = showAudioIndicator;
    const showAudioIndicatorLocal = yield getSettings().then((settings) => {
      if (!settings)
        return null;
      const { showAudioIndicator: showAudioIndicator2 = null } = settings;
      setShowAudioIndicator(showAudioIndicator2 != null ? showAudioIndicator2 : false);
      return showAudioIndicator2;
    });
    if ((showAudioIndicatorLocal || showAudioIndicatorLocal == null) && showAudioIndicatorState) {
      startAudioContext();
    }
  });
  const resetChecker = () => {
    setStopAudioCheckInterval(false);
    setHasAudio(true);
  };
  (0, import_react44.useEffect)(() => {
    if (mediaStream) {
      void startAudioIndicator();
      resetChecker();
    }
  }, [mediaStream]);
  return /* @__PURE__ */ import_react44.default.createElement(
    "div",
    {
      className: (0, import_classnames24.default)("v2-relative v2-flex v2-justify-center v2-z-20", className)
    },
    showAudioIndicator && /* @__PURE__ */ import_react44.default.createElement("div", { className: "v2-flex v2-absolute v2-flex-col-reverse v2-justify-center v2-h-[102px] v2-bottom-10 v2-px-1 v2-py-2.5 v2-gap-y-0.5 v2-overflow-hidden v2-items-center v2-rounded-full v2-bg-black/50 v2-w-5" }, hasAudio && AUDIO_LEVEL_COLORS_CLASSNAME.map((color, index) => {
      return /* @__PURE__ */ import_react44.default.createElement(
        "div",
        {
          key: index,
          className: (0, import_classnames24.default)(
            "v2-flex  v2-rounded-full v2-h-[5px] v2-w-2.5",
            {
              [color]: index + 1 <= volume,
              "v2-bg-neutral-50": index + 1 > volume
            }
          )
        }
      );
    }), !hasAudio && /* @__PURE__ */ import_react44.default.createElement(
      Image2,
      {
        imageUrl: "https://cdn.bonjoro.com/assets/Flat-icons/warning.svg",
        className: "v2-bg-yellow-500 v2-h-4 v2-w-3.5",
        hideWhiteBackground: true
      }
    )),
    /* @__PURE__ */ import_react44.default.createElement(
      "div",
      {
        className: (0, import_classnames24.default)(
          "v2-bg-black/20 v2-group hover:v2-bg-black/70 v2-rounded-full v2-flex v2-gap-1 v2-w-8 v2-h-8 v2-items-center v2-px-2 v2-justify-center v2-cursor-pointer",
          {
            "v2-bg-black/70": showAudioIndicator
          }
        ),
        onClick: toggleAudio
      },
      /* @__PURE__ */ import_react44.default.createElement(
        Image2,
        {
          imageUrl: "https://cdn.bonjoro.com/assets/Flat-icons/mic.svg",
          className: (0, import_classnames24.default)(AUDIO_TOGGLE_CLASSNAME, {
            "group-hover:v2-hidden": showAudioIndicator
          })
        }
      ),
      /* @__PURE__ */ import_react44.default.createElement(
        Image2,
        {
          imageUrl: "https://cdn.bonjoro.com/assets/Flat-icons/close.svg",
          className: (0, import_classnames24.default)(AUDIO_TOGGLE_CLASSNAME, "v2-hidden", {
            "group-hover:v2-flex": showAudioIndicator
          })
        }
      )
    )
  );
}

// src/components/VideoRecorder/NoAudioWarning.tsx
var import_react45 = __toESM(require("react"));
function NoAudioWarning({ onCtaClick }) {
  return /* @__PURE__ */ import_react45.default.createElement("div", { className: "v2-absolute v2-bg-white v2-flex v2-flex-col v2-z-50 v2-rounded v2-inset-0 v2-m-auto v2-w-80 v2-justify-center v2-h-52 v2-items-center v2-text-center v2-space-y-4" }, /* @__PURE__ */ import_react45.default.createElement(
    Image2,
    {
      imageUrl: "https://cdn.bonjoro.com/assets/Flat-icons/warning.svg",
      className: "v2-bg-yellow-500 v2-h-12 v2-w-11",
      hideWhiteBackground: true
    }
  ), /* @__PURE__ */ import_react45.default.createElement("div", { className: "v2-flex v2-text-lg v2-flex-col v2-text-black" }, /* @__PURE__ */ import_react45.default.createElement("span", null, "We are not detecting any sound."), /* @__PURE__ */ import_react45.default.createElement("span", null, "Please check your mic setup.")), /* @__PURE__ */ import_react45.default.createElement(
    Button,
    {
      variant: "primary" /* Primary */,
      shape: "round" /* Round */,
      onClick: onCtaClick
    },
    "Ok"
  ));
}

// src/components/VideoRecorder/VideoPane.tsx
var LoadingContainer = import_styled3.default.div`
  font-size: 50px;
  width: 50px;
  height: 50px;
  color: #f2f2f2;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
var videoActions = css`
  display: flex;
  position: absolute;
  padding: 20px;
  text-align: center;
  height: auto;
`;
var VideoActionsBottom = import_styled3.default.div`
  ${videoActions}
  bottom: 0;
  left: 0;
  right: 0;
  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(37, 37, 37, 0.81));
`;
var VideoActionsTop = import_styled3.default.div`
  ${videoActions}
  top: 0;
  left: 0;
  right: 0;
`;
var Settings2 = import_styled3.default.div``;
var animationFrame;
function VideoPane({
  videoRef,
  videoProps,
  onResetClick,
  onStartClick,
  onStopClick,
  onSettingsClick,
  onSettingsClose,
  recorderState,
  hideVideoButtons = false,
  resetButton,
  alignResetButtonToRight = false,
  className,
  currentHandler,
  startTime,
  endTime,
  debug,
  isCountdownEnabled = true,
  onToggleCountdownTimer = () => void 0,
  countdown = 3,
  mirrored = true,
  onToggleMirror = () => void 0,
  canvasRef,
  hideCountdownTimer,
  hideMirror,
  hideAudioIndicator,
  mirrorClassName,
  countdownTimerClassName,
  audioIndicatorClassName
}) {
  var _a;
  const [showSettings, setShowSettings] = (0, import_react47.useState)(false);
  const ctx = (_a = canvasRef == null ? void 0 : canvasRef.current) == null ? void 0 : _a.getContext("2d");
  const [closeAudioModal, setCloseAudioModal] = (0, import_react47.useState)(false);
  const [hasAudio, setHasAudio] = (0, import_react47.useState)(true);
  const isComplete2 = (0, import_react47.useMemo)(
    () => recorderState === RecorderState_default.Complete,
    [recorderState]
  );
  const isRecording2 = (0, import_react47.useMemo)(
    () => recorderState === RecorderState_default.Recording,
    [recorderState]
  );
  const isPlaying = (0, import_react47.useMemo)(
    () => recorderState === RecorderState_default.Playing,
    [recorderState]
  );
  const isLoading = (0, import_react47.useMemo)(
    () => [
      RecorderState_default.Loading,
      RecorderState_default.Finishing,
      RecorderState_default.GenerateThumbnails,
      RecorderState_default.WaitingForDevices
    ].includes(recorderState),
    [recorderState]
  );
  const muted = (0, import_react47.useMemo)(() => {
    if (isRecording2) {
      return true;
    }
    return !isPlaying;
  }, [isPlaying, isRecording2]);
  function handleSettingsClick() {
    onSettingsClick == null ? void 0 : onSettingsClick();
    setShowSettings(true);
  }
  function handleOnSettingsClose(videoDevice, audioDevice) {
    onSettingsClose == null ? void 0 : onSettingsClose(videoDevice, audioDevice);
    setShowSettings(false);
  }
  const containerClassName = [
    "v2-w-full v2-h-full",
    "v2-relative v2-overflow-hidden",
    "v2-rounded",
    "v2-bg-neutral-900"
  ];
  function draw() {
    if (!videoRef.current || !(canvasRef == null ? void 0 : canvasRef.current) || !ctx)
      return;
    if (recorderState !== RecorderState_default.Idle && recorderState !== RecorderState_default.Recording && recorderState !== RecorderState_default.Counting)
      return;
    const sx = 0;
    const sy = 0;
    const sw = videoRef.current.videoWidth;
    const sh = videoRef.current.videoHeight;
    const tw = canvasRef.current.width;
    const th = canvasRef.current.height;
    ctx.scale(-1, 1);
    if (mirrored) {
      const tx = -canvasRef.current.width;
      const ty = 0;
      ctx.drawImage(videoRef.current, sx, sy, sw, sh, tx, ty, tw, th);
    } else {
      ctx.drawImage(videoRef.current, sx, sy, sw, sh, 0, 0, tw, th);
    }
    animationFrame = requestAnimationFrame(draw);
  }
  (0, import_react47.useEffect)(() => {
    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
    }
    if (!ctx || !videoRef.current || !(canvasRef == null ? void 0 : canvasRef.current))
      return;
    draw();
  }, [mirrored, ctx, recorderState, canvasRef, videoRef]);
  (0, import_react47.useEffect)(() => {
    setCloseAudioModal(false);
    setHasAudio(true);
  }, [videoProps.mediaStream]);
  return /* @__PURE__ */ import_react47.default.createElement("div", { className: (0, import_classnames25.default)("recorder-video", containerClassName, className) }, !hasAudio && !isLoading && !closeAudioModal && /* @__PURE__ */ import_react47.default.createElement(NoAudioWarning, { onCtaClick: () => setCloseAudioModal(true) }), /* @__PURE__ */ import_react47.default.createElement("div", { className: "video-inner v2-h-full v2-w-full v2-relative v2-z-10" }, /* @__PURE__ */ import_react47.default.createElement(
    Video,
    __spreadProps(__spreadValues({
      videoRef,
      canvasRef
    }, videoProps), {
      muted
    })
  )), debug && /* @__PURE__ */ import_react47.default.createElement(
    VideoDebug,
    {
      currentHandler,
      recorderState,
      stream: videoProps.mediaStream,
      videoRef
    }
  ), showSettings && /* @__PURE__ */ import_react47.default.createElement(Settings, { onClose: handleOnSettingsClose }), isLoading && /* @__PURE__ */ import_react47.default.createElement(LoadingContainer, { className: "v2-z-40" }, /* @__PURE__ */ import_react47.default.createElement(import_react_fontawesome3.FontAwesomeIcon, { icon: faSpinner, className: "v2-animate-spin" })), /* @__PURE__ */ import_react47.default.createElement(
    VideoActionsTop,
    {
      className: (0, import_classnames25.default)("v2-z-20", { hidden: hideVideoButtons || isLoading })
    },
    !hideMirror && /* @__PURE__ */ import_react47.default.createElement(
      MirrorControl,
      {
        mirrored,
        onMirror: onToggleMirror,
        className: (0, import_classnames25.default)(
          {
            "v2-hidden": recorderState !== RecorderState_default.Idle
          },
          mirrorClassName
        )
      }
    ),
    !hideCountdownTimer && /* @__PURE__ */ import_react47.default.createElement(
      TimerControl,
      {
        enable: isCountdownEnabled,
        onToggle: onToggleCountdownTimer,
        className: (0, import_classnames25.default)(countdownTimerClassName, {
          "v2-hidden": recorderState !== RecorderState_default.Idle
        })
      }
    ),
    /* @__PURE__ */ import_react47.default.createElement(
      "div",
      {
        className: (0, import_classnames25.default)({
          "v2-hidden": isRecording2 || !isComplete2,
          "v2-ml-auto": alignResetButtonToRight
        })
      },
      resetButton != null ? resetButton : /* @__PURE__ */ import_react47.default.createElement(
        "img",
        {
          className: "v2-cursor-pointer",
          src: assetUrl("video-recorder/ic_undo.svg"),
          onClick: onResetClick
        }
      )
    )
  ), isCountdownEnabled && !hideCountdownTimer && /* @__PURE__ */ import_react47.default.createElement(
    CountdownTimer,
    {
      time: countdown,
      className: (0, import_classnames25.default)("v2-hidden", {
        "!v2-flex": recorderState == RecorderState_default.Idle || recorderState == RecorderState_default.Counting
      })
    }
  ), /* @__PURE__ */ import_react47.default.createElement(
    VideoActionsBottom,
    {
      className: (0, import_classnames25.default)("v2-justify-between v2-items-end", {
        hidden: hideVideoButtons
      })
    },
    /* @__PURE__ */ import_react47.default.createElement("div", { className: "v2-flex v2-flex-col v2-space-y-2" }, !hideAudioIndicator && /* @__PURE__ */ import_react47.default.createElement(
      AudioIndicator,
      {
        mediaStream: videoProps.mediaStream,
        className: (0, import_classnames25.default)(audioIndicatorClassName, "v2-hidden", {
          "!v2-flex": recorderState == RecorderState_default.Idle || recorderState == RecorderState_default.Counting || recorderState == RecorderState_default.Recording
        }),
        onHasAudioChange: (hasAudio2) => setHasAudio(hasAudio2),
        isRecording: isRecording2
      }
    ), /* @__PURE__ */ import_react47.default.createElement(Settings2, { className: (0, import_classnames25.default)("v2-z-50") }, /* @__PURE__ */ import_react47.default.createElement(
      "div",
      {
        className: (0, import_classnames25.default)(
          "v2-bg-black/20 hover:v2-bg-black/70 v2-rounded-full v2-flex v2-gap-1 v2-w-8 v2-h-8 v2-items-center v2-px-2 v2-justify-center v2-cursor-pointer",
          {
            hidden: showSettings || ![RecorderState_default.Idle, RecorderState_default.Loading].includes(
              recorderState
            )
          }
        )
      },
      /* @__PURE__ */ import_react47.default.createElement(
        "img",
        {
          role: "button",
          src: assetUrl("video-recorder/ic_gear.svg"),
          onClick: handleSettingsClick,
          className: "v2-cursor-pointer v2-h-5 v2-w-5"
        }
      )
    ))),
    /* @__PURE__ */ import_react47.default.createElement(Timer_default, { className: "v2-z-20", startTime, endTime })
  ), /* @__PURE__ */ import_react47.default.createElement(VideoActionsBottom, { className: "v2-justify-center" }, /* @__PURE__ */ import_react47.default.createElement(
    StartStop_default,
    {
      className: (0, import_classnames25.default)("v2-w-12 v2-h-12 v2-z-20", {
        "v2-hidden": isLoading || recorderState == RecorderState_default.Counting
      }),
      isPlaying: isRecording2 || isPlaying,
      isComplete: isComplete2,
      onStartClick,
      onStopClick
    }
  )));
}

// src/components/VideoRecorder/hooks/use-handlers.tsx
var import_react49 = require("react");

// src/components/VideoRecorder/hooks/use-msr-handlers.tsx
var import_luxon5 = require("luxon");

// src/components/VideoRecorder/store/utils.ts
function getMetadata2(stream, devices) {
  return __async(this, null, function* () {
    var _a, _b;
    const videoSettings = (_a = stream == null ? void 0 : stream.getVideoTracks()[0]) == null ? void 0 : _a.getSettings();
    const audioSettings = (_b = stream == null ? void 0 : stream.getAudioTracks()[0]) == null ? void 0 : _b.getSettings();
    devices != null ? devices : devices = yield getDevices();
    const metadata = {};
    if (videoSettings) {
      metadata.video = {
        resolution: {
          width: videoSettings.width,
          height: videoSettings.height
        },
        frameRate: videoSettings.frameRate,
        aspectRatio: videoSettings.aspectRatio,
        device: getDeviceName(videoSettings.deviceId, devices)
      };
    }
    if (audioSettings) {
      metadata.audio = {
        device: getDeviceName(audioSettings.deviceId, devices),
        channels: audioSettings.channelCount,
        latency: audioSettings.latency,
        sampleRate: audioSettings.sampleRate,
        sampleSize: audioSettings.sampleSize
      };
    }
    return metadata;
  });
}

// src/components/VideoRecorder/support/userMedia.ts
var import_pick = __toESM(require_pick());
var import_stop_media_stream = __toESM(require_stop_media_stream());
var EVENT_GET_USER_MEDIA_SUCCESS = "getusermedia:success";
var EVENT_GET_USER_MEDIA_ERROR = "getusermedia:error";
var GetUserMediaSuccess = class {
  static create(stream) {
    const event = new Event(
      EVENT_GET_USER_MEDIA_SUCCESS
    );
    event.stream = stream;
    return event;
  }
};
var GetUserMediaError = class {
  static create(error) {
    const event = new Event(EVENT_GET_USER_MEDIA_ERROR);
    event.error = error;
    return event;
  }
};
function resolveGetUserMedia() {
  const getUserMedia2 = (constraints, successCallback, errorCallback) => {
    var _a, _b;
    let fn = void 0;
    fn = (_b = (_a = navigator.webkitGetUserMedia) != null ? _a : navigator.mozGetUserMedia) != null ? _b : navigator.msGetUserMedia;
    if (!fn) {
      fn = (constraints2, successCallback2, errorCallback2) => {
        navigator.mediaDevices.getUserMedia(constraints2).then(successCallback2).catch(errorCallback2);
      };
    }
    return fn.call(navigator, constraints, successCallback, errorCallback);
  };
  return getUserMedia2;
}
var getUserMedia = resolveGetUserMedia();
function getUserMediaAsync(constraints) {
  return new Promise((resolve, reject) => {
    getUserMedia(
      constraints,
      (stream) => {
        window.dispatchEvent(GetUserMediaSuccess.create(stream));
        resolve(stream);
      },
      (error) => {
        window.dispatchEvent(GetUserMediaError.create(error));
        reject(error);
      }
    );
  });
}
function transformMediaConstraints(constraints) {
  return __async(this, null, function* () {
    const stream = yield getUserMediaAsync(constraints);
    const newConstraints = constraints;
    if (constraints.video && typeof constraints.video !== "boolean") {
      const video = document.createElement("video");
      const videoTrack = stream.getVideoTracks()[0];
      const htmlVideo = yield new Promise(
        (resolve) => {
          video.muted = true;
          video.id = "transform-media-constraints";
          video.className = "v2-hidden";
          document.body.appendChild(video);
          video.srcObject = stream;
          video.onloadedmetadata = () => {
            resolve({
              width: video.videoWidth,
              height: video.videoHeight
            });
            video.onloadedmetadata = null;
            document.body.removeChild(video);
          };
          void video.play().catch((e) => {
            console.log(e);
          });
        }
      );
      const trackSettings = (0, import_pick.default)(videoTrack.getSettings(), ["width", "height"]);
      if (htmlVideo.width === trackSettings.height && htmlVideo.height === trackSettings.width) {
        const videoConstraints = constraints.video;
        const temp = videoConstraints.width;
        videoConstraints.width = videoConstraints.height;
        videoConstraints.height = temp;
        newConstraints.video = videoConstraints;
      }
    }
    (0, import_stop_media_stream.default)(stream);
    return newConstraints;
  });
}
function hasUserMediaPermission() {
  return __async(this, arguments, function* (flags = 3 /* Both */) {
    const stream = yield getUserMediaAsync({
      video: (flags & 1 /* Video */) > 0,
      audio: (flags & 2 /* Audio */) > 0
    });
    const hasPermission = stream != null;
    (0, import_stop_media_stream.default)(stream);
    return hasPermission;
  });
}

// src/components/VideoRecorder/hooks/use-msr-handlers.tsx
function useMsrHandlers() {
  const handlers = {
    [RecorderState_default.Loading]: {
      onEnter: (_0) => __async(this, [_0], function* ({
        video,
        setMediaStream: setMediaStream2,
        setMetadata: setMetadata2,
        setRecorderState: setRecorderState2,
        userMediaConstraints,
        isExternalVideo
      }) {
        if (isExternalVideo)
          return;
        if (userMediaConstraints == null) {
          setRecorderState2(RecorderState_default.WaitingForDevices);
          return;
        }
        const constraints = yield transformMediaConstraints(
          userMediaConstraints
        );
        const stream = yield getUserMediaAsync(constraints);
        const metadata = yield getMetadata2(stream);
        setMetadata2(metadata);
        setMediaStream2(stream);
        const timeout = setTimeout(() => {
          var _a;
          if (((_a = video.current) == null ? void 0 : _a.readyState) === 0) {
            setRecorderState2(RecorderState_default.Init);
          }
        }, 3e3);
        if (video.current) {
          video.current.oncanplay = () => {
            if (video.current && video.current.readyState !== 0) {
              clearTimeout(timeout);
            }
            setRecorderState2(RecorderState_default.Idle);
          };
        }
      })
    },
    [RecorderState_default.Recording]: {
      onEnter: ({
        addBlob: addBlob2,
        createBlob: createBlob2,
        mimeType,
        video,
        setStartTime: setStartTime2,
        setRecorder: setRecorder2,
        quality,
        metadata,
        stream
      }) => {
        if (!stream)
          return;
        const options = getMediaRecorderOptions({
          quality,
          mimeType,
          metadata
        });
        const recorder = new MediaRecorder(stream, options);
        recorder.addEventListener("dataavailable", (blobEvent) => {
          if (blobEvent.data.size > 0) {
            addBlob2(blobEvent.data);
          }
        });
        recorder.addEventListener("stop", () => {
          createBlob2();
        });
        if (video.current) {
          video.current.muted = true;
          video.current.volume = 0;
        }
        recorder.start(5e3);
        setStartTime2(import_luxon5.DateTime.local());
        setRecorder2(recorder);
      },
      handleStopClick: ({ recorder, setEndTime: setEndTime2, setRecorderState: setRecorderState2 }) => {
        recorder == null ? void 0 : recorder.stop();
        setEndTime2(import_luxon5.DateTime.local());
        setRecorderState2(RecorderState_default.GenerateThumbnails);
      }
    }
  };
  return handlers;
}

// src/components/VideoRecorder/hooks/use-thumbnail-renderer.ts
var import_luxon6 = require("luxon");
var import_react48 = require("react");

// src/utils/crypto.ts
function digestMessage(message, algorithm, encoder) {
  return __async(this, null, function* () {
    encoder != null ? encoder : encoder = new TextEncoder();
    algorithm != null ? algorithm : algorithm = "sha-1";
    const data = encoder.encode(message);
    const hash2 = yield crypto.subtle.digest(algorithm, data);
    return Array.from(new Uint8Array(hash2)).map((b) => b.toString(16)).join("");
  });
}
function sha1(message, encoder) {
  return digestMessage(message, "sha-1", encoder);
}

// src/components/VideoRecorder/hooks/use-thumbnail-renderer.ts
function compressedDataUrl(canvas) {
  return canvas.toDataURL("image/jpeg", 0.5);
}
function useThumbnailRenderer({
  videoRef,
  onComplete,
  interval,
  renderImmediately
}) {
  const squareCanvas = (0, import_react48.useRef)(document.createElement("canvas"));
  const originalCanvas = (0, import_react48.useRef)(document.createElement("canvas"));
  const smallCanvas = (0, import_react48.useRef)(document.createElement("canvas"));
  const [live, setLive] = (0, import_react48.useState)(false);
  const isCanvasTransparent = (x, y, context) => {
    return (context == null ? void 0 : context.getImageData(x, y, 1, 1).data[3]) === 0;
  };
  const drawThumbnailOnCanvas = (video, canvas, startXCoordinate, startYCoordinate, imageWidth, imageHeight) => {
    canvas.width = imageWidth;
    canvas.height = imageHeight;
    const ctx = canvas.getContext("2d", {
      willReadFrequently: true
    });
    ctx == null ? void 0 : ctx.drawImage(
      video,
      // center crop on x-axis if landscape
      startXCoordinate,
      // center crop on y-axis if portrait
      startYCoordinate,
      imageWidth,
      imageHeight,
      0,
      0,
      imageWidth,
      imageHeight
    );
    if (isCanvasTransparent(startXCoordinate, startYCoordinate, ctx))
      return null;
    return canvas;
  };
  const renderThumbnail = (0, import_react48.useCallback)(() => __async(this, null, function* () {
    var _a;
    if (!videoRef.current)
      return;
    const video = videoRef.current;
    const clientWidth = video.videoWidth;
    const clientHeight = video.videoHeight;
    const isLandscape = clientWidth > clientHeight;
    const xAxis = isLandscape ? (clientWidth - clientHeight) / 2 : 0;
    const yAxis = !isLandscape ? (clientHeight - clientWidth) / 2 : 0;
    const oSize = Math.min(clientWidth, clientHeight) || 450;
    const squareThumb = drawThumbnailOnCanvas(
      video,
      squareCanvas.current,
      xAxis,
      yAxis,
      oSize,
      oSize
    );
    const originalThumb = drawThumbnailOnCanvas(
      video,
      originalCanvas.current,
      0,
      0,
      clientWidth,
      clientHeight
    );
    if (!squareThumb || !originalThumb)
      return;
    const time = isFinite(video.currentTime) ? import_luxon6.Duration.fromObject({ seconds: video.currentTime }) : import_luxon6.DateTime.local();
    const thumbCanvas = smallCanvas.current;
    const thumbSize = 150;
    thumbCanvas.width = thumbCanvas.height = thumbSize;
    (_a = thumbCanvas.getContext("2d", {
      willReadFrequently: true
    })) == null ? void 0 : _a.drawImage(squareThumb, 0, 0, thumbSize, thumbSize);
    const thumbnail = {
      original: {
        data: compressedDataUrl(originalCanvas.current),
        height: clientHeight,
        width: clientWidth
      },
      square: {
        data: compressedDataUrl(squareCanvas.current),
        height: oSize,
        width: oSize
      },
      small: {
        data: compressedDataUrl(thumbCanvas),
        height: thumbSize,
        width: thumbSize
      },
      time
    };
    try {
      thumbnail.hash = yield sha1(thumbnail.original.data);
    } catch (e) {
    }
    onComplete == null ? void 0 : onComplete(thumbnail);
  }), [videoRef]);
  const [intervalId, setIntervalId] = (0, import_react48.useState)();
  const start = () => {
    if (renderImmediately != null ? renderImmediately : true) {
      void renderThumbnail();
    }
    setLive(true);
  };
  (0, import_react48.useEffect)(() => {
    if (live) {
      setIntervalId(
        setInterval(() => {
          void renderThumbnail();
        }, interval != null ? interval : 5e3)
      );
    } else {
      if (intervalId) {
        clearInterval(intervalId);
      }
    }
  }, [live]);
  return {
    renderThumbnail,
    startRenderingThumbnails: start,
    stopRenderingThumbnails: () => setLive(false)
  };
}

// src/utils/sleep.ts
function sleep(timeout) {
  return __async(this, null, function* () {
    return new Promise((resolve) => setTimeout(resolve, timeout));
  });
}
var sleep_default = sleep;

// src/components/VideoRecorder/hooks/use-handlers.tsx
var import_stop_media_stream2 = __toESM(require_stop_media_stream());
var import_react_i18next4 = require("react-i18next");

// src/components/VideoRecorder/support/utils.ts
var import_ceil = __toESM(require_ceil());
var import_clamp = __toESM(require_clamp());
var mediaStreamErrors = ["NotReadableError", "TrackStartError", "AbortError"];
function isMediaStreamError(err) {
  return typeof (err == null ? void 0 : err.name) === "string" && mediaStreamErrors.includes(err.name);
}
function getVideoDuration(video, fallback = 120) {
  return (0, import_ceil.default)(isFinite(video.duration) ? video.duration : fallback, 2);
}
function getVideoCurrentTime(video) {
  return (0, import_ceil.default)(video.currentTime, 2);
}
function seekVideoRelative({
  video,
  stepSeconds,
  max = getVideoDuration(video)
}) {
  video.currentTime = (0, import_clamp.default)(video.currentTime + stepSeconds, 0, max);
}
function endOfVideo(currentTime, lastTime, duration) {
  return lastTime === currentTime || currentTime >= duration;
}

// src/components/VideoRecorder/hooks/use-handlers.tsx
function useHandlers(options) {
  const { t } = (0, import_react_i18next4.useTranslation)();
  const {
    video,
    setRecorderState: setRecorderState2,
    addThumbnail: addThumbnail2,
    setVideoReviewed,
    onUnsupportedVideoFormat
  } = options;
  const { renderThumbnail } = useThumbnailRenderer({
    videoRef: video,
    onComplete: addThumbnail2,
    renderImmediately: true
  });
  const waitForMetadata = (0, import_react49.useCallback)(() => __async(this, null, function* () {
    if (!video.current)
      return;
    const timeout = 250;
    const maxWait = 5e3;
    let totalWait = 0;
    let { readyState } = video.current;
    while (readyState <= 0 && totalWait <= maxWait) {
      yield sleep_default(timeout);
      totalWait += timeout;
      readyState = video.current.readyState;
    }
  }), [video.current]);
  const handlers = {
    [RecorderState_default.GenerateThumbnails]: {
      onEnter: () => __async(this, null, function* () {
        if (!video.current)
          return;
        yield waitForMetadata();
        let lastCurrentTime = null;
        video.current.onseeked = () => __async(this, null, function* () {
          if (!video.current)
            return;
          yield renderThumbnail();
          const duration = getVideoDuration(video.current);
          seekVideoRelative({
            video: video.current,
            stepSeconds: 5,
            max: duration
          });
          const currentTime = getVideoCurrentTime(video.current);
          if (endOfVideo(currentTime, lastCurrentTime, duration)) {
            video.current.dispatchEvent(new Event("ended"));
          }
          lastCurrentTime = currentTime;
        });
        video.current.onended = () => __async(this, null, function* () {
          if (!video.current)
            return;
          yield renderThumbnail();
          video.current.onseeked = video.current.onended = null;
          setRecorderState2(RecorderState_default.Complete);
        });
        video.current.load();
        video.current.onloadedmetadata = () => __async(this, null, function* () {
          var _a;
          if (!video.current)
            return;
          const oSize = (_a = video.current.videoHeight) != null ? _a : video.current.videoWidth;
          if (!oSize) {
            (onUnsupportedVideoFormat != null ? onUnsupportedVideoFormat : alert)(
              t("videoRecorder:errors.unsupportedVideoFormat")
            );
            setRecorderState2(RecorderState_default.Complete);
          } else {
            yield renderThumbnail();
            setTimeout(() => {
              if (!video.current)
                return;
              video.current.currentTime = 0;
            }, 500);
            video.current.onloadedmetadata = null;
          }
        });
      })
    },
    [RecorderState_default.Init]: {
      onEnter: ({
        init: init2,
        stream,
        video: video2,
        setRecorderState: setRecorderState3,
        isDevicesLoading,
        isExternalVideo
      }) => {
        if (isExternalVideo)
          return;
        init2();
        if (stream) {
          (0, import_stop_media_stream2.default)(stream);
        }
        if (video2.current) {
          video2.current.src = "";
          video2.current.srcObject = null;
        }
        if (isDevicesLoading) {
          setRecorderState3(RecorderState_default.WaitingForDevices);
        } else {
          setRecorderState3(RecorderState_default.Loading);
        }
      }
    },
    [RecorderState_default.WaitingForDevices]: {
      onEnter: ({ setRecorderState: setRecorderState3 }) => {
        setTimeout(() => setRecorderState3(RecorderState_default.Init), 500);
      }
    },
    [RecorderState_default.Idle]: {
      onEnter: ({ stream, video: video2, isExternalVideo }) => {
        if (isExternalVideo)
          return;
        if (stream && !(stream == null ? void 0 : stream.active)) {
          setRecorderState2(RecorderState_default.Init);
          return;
        }
        if (video2.current) {
          void video2.current.play().catch((e) => {
            console.log(e);
          });
          video2.current.oncanplay = null;
          video2.current.muted = true;
        }
      },
      handleStartClick: ({ setRecorderState: setRecorderState3 }) => {
        setRecorderState3(RecorderState_default.Starting);
      }
    },
    [RecorderState_default.Starting]: {
      onEnter: ({ setRecorderState: setRecorderState3 }) => {
        setRecorderState3(RecorderState_default.Counting);
      }
    },
    [RecorderState_default.Playing]: {
      onEnter() {
        if (!video.current)
          return;
        video.current.muted = false;
        video.current.volume = 1;
        video.current.onended = video.current.onpause = () => setRecorderState2(RecorderState_default.Complete);
        if (video.current.readyState === 0) {
          video.current.load();
        }
        void video.current.play();
        setVideoReviewed(true);
      },
      handleStopClick() {
        var _a;
        (_a = video.current) == null ? void 0 : _a.pause();
        setRecorderState2(RecorderState_default.Complete);
      }
    },
    [RecorderState_default.Complete]: {
      onEnter() {
        if (!video.current)
          return;
        video.current.onended = video.current.onpause = video.current.onload = null;
        video.current.currentTime = 0;
        video.current.muted = true;
      },
      handleStartClick() {
        setRecorderState2(RecorderState_default.Playing);
      }
    },
    [RecorderState_default.Counting]: {
      onEnter: ({ setRecorderState: setRecorderState3, isCountdownEnabled, countdownTimer }) => {
        if (!isCountdownEnabled || countdownTimer === 1) {
          setRecorderState3(RecorderState_default.Recording);
        }
      }
    }
  };
  return (0, import_react49.useMemo)(
    () => __spreadProps(__spreadValues(__spreadValues({}, handlers), useMsrHandlers()), {
      currentHandler: "msr"
    }),
    [handlers]
  );
}

// src/components/VideoRecorder/support/browser.ts
var import_first2 = __toESM(require_first());
var import_memoize5 = __toESM(require_memoize());
var mimeTypes = {
  vp9: [
    "video/mp4;codecs=vp9",
    "video/webm;codecs=vp9,vorbis",
    "video/webm;codecs=vp9,opus",
    "video/webm;codecs=vp9,pcm",
    "video/webm;codecs=vp9"
  ],
  vp8: [
    "video/mp4;codecs=vp8",
    "video/webm;codecs=vp8,vorbis",
    "video/webm;codecs=vp8,opus",
    "video/webm;codecs=vp8,pcm",
    "video/webm;codecs=vp8"
  ],
  avc1: [
    "video/mp4;codecs=avc1,mp4a",
    "video/mp4;codecs=avc1",
    "video/webm;codecs=avc1,opus",
    "video/webm;codecs=avc1,pcm",
    "video/webm;codecs=avc1"
  ],
  default: ["video/mp4", "video/webm"]
};
var preferredMimeTypes = {
  ["high" /* High */]: [
    ...mimeTypes.vp8,
    ...mimeTypes.vp9,
    ...mimeTypes.avc1,
    ...mimeTypes.default
  ],
  ["medium" /* Medium */]: [
    ...mimeTypes.vp8,
    ...mimeTypes.vp9,
    ...mimeTypes.avc1,
    ...mimeTypes.default
  ],
  ["low" /* Low */]: [
    ...mimeTypes.vp8,
    ...mimeTypes.avc1,
    ...mimeTypes.default
  ]
};
var allMimeTypes = [
  ...mimeTypes.vp9,
  ...mimeTypes.vp8,
  ...mimeTypes.avc1,
  ...mimeTypes.default
];
function supportsRecording(mimeType) {
  var _a, _b, _c;
  return (_c = (_b = (_a = window.MediaRecorder) == null ? void 0 : _a.isTypeSupported) == null ? void 0 : _b.call(_a, mimeType)) != null ? _c : false;
}
var getSupportedMimeTypes = (0, import_memoize5.default)(
  (mimeTypes2 = allMimeTypes) => {
    return mimeTypes2.filter(supportsRecording);
  }
);
function getPreferredMimeType(quality) {
  const supportedMimeTypes = getSupportedMimeTypes(preferredMimeTypes[quality]);
  return (0, import_first2.default)(supportedMimeTypes);
}

// src/components/VideoRecorder/VideoRecorder.tsx
var VideoRecorder = import_react50.default.forwardRef(
  ({
    recorderState,
    setRecorderState: setRecorderState2,
    setSelectedTabIndex,
    hideVideoButtons = false,
    onSettingsClick,
    onSettingsClose,
    onResetClick,
    videoPaneClassName,
    resetButton,
    alignResetButtonToRight,
    debug,
    videoRef,
    onInit,
    hideMirror,
    hideCountdownTimer,
    hideAudioIndicator,
    mirrorClassName,
    countdownTimerClassName,
    audioIndicatorClassName
  }, ref) => {
    var _b, _c;
    const canvas = (0, import_react50.useRef)(null);
    const [countdownTimer, setCountdownTimer] = (0, import_react50.useState)(3);
    const [isCountdownEnabled, setIsCountdownEnabled] = (0, import_react50.useState)(true);
    const [intervalId, setIntervalId] = (0, import_react50.useState)();
    const [isMirrored, setIsMirrored] = (0, import_react50.useState)(true);
    (0, import_react50.useEffect)(() => {
      void getSettings().then((settings) => {
        var _a2, _b2;
        if (!settings)
          return;
        setIsCountdownEnabled((_a2 = settings.countdownTimer) != null ? _a2 : true);
        setIsMirrored((_b2 = settings.mirrored) != null ? _b2 : true);
      });
    }, []);
    const { state, dispatch } = (0, import_react50.useContext)(VideoRecorderContext_default);
    const [videoReviewed, setVideoReviewed] = (0, import_react50.useState)(false);
    const isExternalVideo = state.isExternalVideo;
    const recorder = state.recorder;
    const stream = state.mediaStream;
    const metadata = state.metadata;
    const isIdleState = (0, import_react50.useMemo)(
      () => [RecorderState_default.Idle, RecorderState_default.Loading].includes(recorderState),
      [recorderState]
    );
    const handlersActions = (0, import_react50.useMemo)(() => {
      const actions = (0, import_pick2.default)(Actions_exports, [
        "setMediaStream",
        "setMetadata",
        "setBlob",
        "addBlob",
        "setStartTime",
        "setEndTime",
        "setRecorder",
        "init",
        "createBlob",
        "setDeviceErrorStatus"
      ]);
      return (0, import_toolkit4.bindActionCreators)(
        actions,
        // eslint-disable-next-line
        dispatch
      );
    }, [dispatch]);
    const { data: videoDevice, isLoading: videoDeviceLoading } = useVideoDevice();
    const { data: audioDevice, isLoading: audioDeviceLoading } = useAudioDevice();
    const isDevicesLoading = (0, import_react50.useMemo)(
      () => videoDeviceLoading || audioDeviceLoading,
      [videoDeviceLoading, audioDeviceLoading]
    );
    const recordingQualityQuery = useRecordingQuality();
    const recordingQuality = recordingQualityQuery.recordingQuality;
    (0, import_react50.useEffect)(() => {
      if (!onInit || recordingQualityQuery.isLoading) {
        return;
      }
      onInit(recordingQuality);
    }, [onInit, recordingQualityQuery.isLoading]);
    const videoConstraints = (0, import_react50.useMemo)(
      () => getVideoConstraints(videoDevice, recordingQuality),
      [videoDevice, recordingQuality]
    );
    const audioConstraints = (0, import_react50.useMemo)(() => {
      if (audioDevice == null ? void 0 : audioDevice.deviceId) {
        const { deviceId, groupId } = audioDevice;
        return __spreadProps(__spreadValues({}, defaultUserMediaConstraints.audio), {
          deviceId,
          groupId
        });
      }
      return defaultUserMediaConstraints.audio;
    }, [audioDevice]);
    const userMediaConstraints = (0, import_react50.useMemo)(() => {
      if (isDevicesLoading || recordingQualityQuery.isLoading) {
        return void 0;
      }
      return __spreadProps(__spreadValues({}, defaultUserMediaConstraints), {
        video: videoConstraints,
        audio: audioConstraints
      });
    }, [
      videoConstraints,
      audioDevice,
      isDevicesLoading,
      recordingQualityQuery.isLoading
    ]);
    (0, import_react50.useEffect)(() => {
      if (recorderState === RecorderState_default.Idle || userMediaConstraints == null) {
        setRecorderState2(RecorderState_default.Init);
      }
    }, [videoDevice == null ? void 0 : videoDevice.deviceId, audioDevice == null ? void 0 : audioDevice.deviceId, recordingQuality]);
    const mimeType = (0, import_react50.useMemo)(
      () => getPreferredMimeType(recordingQuality),
      [recordingQuality]
    );
    const options = (0, import_react50.useMemo)(
      () => __spreadProps(__spreadValues({
        video: videoRef,
        canvas,
        recorder: recorder != null ? recorder : void 0,
        stream: stream != null ? stream : void 0,
        isExternalVideo,
        userMediaConstraints,
        quality: recordingQuality,
        metadata,
        setRecorderState: setRecorderState2,
        setSelectedTabIndex,
        setVideoReviewed
      }, handlersActions), {
        addThumbnail: (0, import_toolkit4.bindActionCreators)(
          addThumbnail,
          // eslint-disable-next-line
          dispatch
        ),
        isDevicesLoading,
        mimeType,
        countdownTimer,
        isCountdownEnabled
      }),
      [
        videoRef.current,
        recorder,
        stream,
        isExternalVideo,
        setRecorderState2,
        setSelectedTabIndex,
        setVideoReviewed,
        handlersActions,
        dispatch,
        isDevicesLoading,
        userMediaConstraints,
        recorderState,
        mimeType,
        recordingQuality,
        countdownTimer,
        isCountdownEnabled
      ]
    );
    const _a = useHandlers(options), { currentHandler } = _a, handlers = __objRest(_a, ["currentHandler"]);
    const { handleStartClick, handleStopClick, onEnter } = (0, import_react50.useMemo)(
      () => {
        var _a2;
        return (_a2 = handlers[recorderState]) != null ? _a2 : {};
      },
      [recorderState]
    );
    const toggleMirror = () => {
      const newIsMirrored = !isMirrored;
      void rememberSettings({
        mirrored: newIsMirrored
      });
      setIsMirrored(newIsMirrored);
    };
    const toggleCountdownTimer = () => {
      const newIsCoundownEnabled = !isCountdownEnabled;
      void rememberSettings({
        countdownTimer: newIsCoundownEnabled
      });
      setIsCountdownEnabled(newIsCoundownEnabled);
    };
    (0, import_react50.useEffect)(() => {
      if (!isCountdownEnabled)
        return;
      if (recorderState == RecorderState_default.Counting) {
        setIntervalId(
          setInterval(() => {
            setCountdownTimer(countdownTimer - 1);
            void (onEnter == null ? void 0 : onEnter(options));
            if (countdownTimer == 1) {
              clearInterval(intervalId);
              setCountdownTimer(3);
            }
          }, 1e3)
        );
      }
      return () => intervalId && clearInterval(intervalId);
    }, [recorderState, countdownTimer]);
    (0, import_react50.useEffect)(() => {
      void (onEnter == null ? void 0 : onEnter(options));
    }, [recorderState]);
    function handleResetClick() {
      onResetClick == null ? void 0 : onResetClick();
      setRecorderState2(RecorderState_default.Init);
    }
    (0, import_react50.useEffect)(() => {
      return () => {
        if (stream) {
          (0, import_stop_media_stream3.default)(stream);
        }
      };
    }, [stream]);
    function handlePageVisibilityChange(isVisible) {
      if (stream && isIdleState) {
        if (isVisible) {
          const newRecorderState = recorderState === RecorderState_default.Loading ? RecorderState_default.Idle : RecorderState_default.Loading;
          setRecorderState2(newRecorderState);
        } else {
          (0, import_stop_media_stream3.default)(stream);
        }
      }
    }
    (0, import_react50.useEffect)(() => {
      if (isExternalVideo) {
        setRecorderState2(RecorderState_default.GenerateThumbnails);
      }
    }, [isExternalVideo]);
    const startRecording = (0, import_react50.useCallback)(
      () => void (handleStartClick == null ? void 0 : handleStartClick(options)),
      [handleStartClick, options]
    );
    const stopRecording = (0, import_react50.useCallback)(
      () => void (handleStopClick == null ? void 0 : handleStopClick(options)),
      [handleStopClick, options]
    );
    const recorderControl = (0, import_react50.useMemo)(
      () => ({
        startRecording,
        stopRecording
      }),
      [startRecording, stopRecording]
    );
    (0, import_react50.useEffect)(() => {
      if (!ref) {
        return;
      }
      if (typeof ref === "function") {
        ref(recorderControl);
      } else {
        ref.current = recorderControl;
      }
    }, [ref, recorderControl]);
    return /* @__PURE__ */ import_react50.default.createElement(import_react50.default.Fragment, null, /* @__PURE__ */ import_react50.default.createElement(import_react_page_visibility.default, { onChange: handlePageVisibilityChange }), /* @__PURE__ */ import_react50.default.createElement(
      VideoPane,
      {
        videoRef,
        videoProps: getVideoComponentProps(state),
        currentHandler,
        className: videoPaneClassName,
        recorderState,
        videoReviewed,
        onResetClick: handleResetClick,
        onStartClick: startRecording,
        onStopClick: stopRecording,
        onSettingsClick,
        onSettingsClose,
        hideVideoButtons,
        resetButton,
        alignResetButtonToRight,
        startTime: (_b = state.startTime) != null ? _b : void 0,
        endTime: (_c = state.endTime) != null ? _c : void 0,
        debug,
        isCountdownEnabled,
        countdown: countdownTimer,
        onToggleCountdownTimer: toggleCountdownTimer,
        mirrored: isMirrored,
        onToggleMirror: toggleMirror,
        canvasRef: canvas,
        hideCountdownTimer,
        hideAudioIndicator,
        hideMirror,
        mirrorClassName,
        countdownTimerClassName,
        audioIndicatorClassName
      }
    ));
  }
);
VideoRecorder.displayName = "VideoRecorder";
var VideoRecorder_default = VideoRecorder;

// src/components/VideoRecorder/Loading.tsx
var import_beautiful_react_hooks = __toESM(require_cjs());
var import_react54 = __toESM(require("react"));

// node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var faCameraWeb = {
  prefix: "fas",
  iconName: "camera-web",
  icon: [448, 512, ["webcam"], "f832", "M344.2 413.1C406.6 373.3 448 303.5 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 79.5 41.4 149.3 103.8 189.1L45.6 453.8c-11.4 8-16.4 22.5-12.2 35.8S50 512 64 512H384c14 0 26.3-9.1 30.5-22.4s-.7-27.8-12.2-35.8l-58.2-40.7zM224 352c70.7 0 128-57.3 128-128s-57.3-128-128-128S96 153.3 96 224s57.3 128 128 128zm0 32c-88.4 0-160-71.6-160-160s71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160zM176 224c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48z"]
};
var faWebcam = faCameraWeb;
var faMicrophone = {
  prefix: "fas",
  iconName: "microphone",
  icon: [384, 512, [], "f130", "M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z"]
};

// src/components/VideoRecorder/LoadingError.tsx
var import_react51 = __toESM(require("react"));
var import_classnames26 = __toESM(require("classnames"));
var import_react_i18next5 = require("react-i18next");
var DeviceErrorMessages = {
  permissionError: {
    titleKey: "videoRecorder:loadingError.permission.title",
    bodyKey: "videoRecorder:loadingError.permission.body"
  },
  notReadable: {
    titleKey: "videoRecorder:loadingError.notReadable.title",
    bodyKey: "videoRecorder:loadingError.notReadable.body"
  }
};
function LoadingError(_a) {
  var _b = _a, {
    errorType = "permissionError" /* PermissionError */,
    className
  } = _b, otherProps = __objRest(_b, [
    "errorType",
    "className"
  ]);
  const { t } = (0, import_react_i18next5.useTranslation)();
  const { titleKey, bodyKey } = DeviceErrorMessages[errorType];
  if (errorType == "notReadable" /* NotReadable */) {
    return /* @__PURE__ */ import_react51.default.createElement(
      "div",
      __spreadValues({
        className: (0, import_classnames26.default)(
          className,
          "v2-h-full v2-w-full v2-flex v2-flex-col v2-justify-center v2-items-center"
        )
      }, otherProps),
      /* @__PURE__ */ import_react51.default.createElement("div", null, /* @__PURE__ */ import_react51.default.createElement("span", { className: "v2-text-base v2-text-neutral-600 v2-flex v2-flex-col" }, t(titleKey), " ", t(bodyKey)), /* @__PURE__ */ import_react51.default.createElement(
        Settings,
        {
          positionClassName: "v2-relative",
          backgroundColorClassName: "v2-bg-white",
          textColorClassName: "v2-text-neutral-600",
          paddingClassName: "v2-pt-2.5",
          hideSave: true,
          hideTitle: true
        }
      ))
    );
  }
  return /* @__PURE__ */ import_react51.default.createElement(
    "div",
    __spreadValues({
      className: (0, import_classnames26.default)(
        className,
        "v2-h-full v2-w-full v2-flex v2-flex-col v2-items-center v2-justify-center"
      )
    }, otherProps),
    /* @__PURE__ */ import_react51.default.createElement(
      "img",
      {
        className: "v2-w-44 v2-h-44",
        src: assetUrl("video-recorder/allow-access.gif")
      }
    ),
    /* @__PURE__ */ import_react51.default.createElement("div", { className: "v2-text-center" }, /* @__PURE__ */ import_react51.default.createElement("div", { className: "v2-text-xl v2-text-neutral-600 v2-font-medium" }, t(titleKey)), /* @__PURE__ */ import_react51.default.createElement("span", { className: "v2-text-sm v2-text-neutral-500" }, t(bodyKey)))
  );
}
var createCustomLoadingError = (onBackClick) => ({ errorType }) => {
  const { t } = (0, import_react_i18next5.useTranslation)();
  return /* @__PURE__ */ import_react51.default.createElement("div", { className: "v2-p-5 v2-h-full v2-w-full v2-relative" }, /* @__PURE__ */ import_react51.default.createElement(
    ActionButton,
    {
      className: "v2-absolute",
      icon: faArrowLeft,
      label: t("videoRecorder:buttons.back"),
      onClick: onBackClick
    }
  ), /* @__PURE__ */ import_react51.default.createElement(
    LoadingError,
    {
      className: "v2-flex v2-flex-col v2-items-center v2-justify-center v2-h-full v2-text-center v2-gap-y-4",
      errorType
    }
  ));
};

// src/components/VideoRecorder/hooks/use-get-user-media-event-listener.ts
function useGetUserMediaEventListener({
  onSuccess,
  onError
}) {
  useEvent_default(
    EVENT_GET_USER_MEDIA_SUCCESS,
    onSuccess,
    window
  );
  useEvent_default(
    EVENT_GET_USER_MEDIA_ERROR,
    onError,
    window
  );
}

// src/components/VideoRecorder/hooks/use-media-stream-error-handler.ts
var import_react52 = require("react");
function useMediaStreamErrorHandler() {
  const { dispatch } = (0, import_react52.useContext)(VideoRecorderContext_default);
  useGetUserMediaEventListener({
    onError: (evt) => {
      if (isMediaStreamError(evt.error)) {
        dispatch(setDeviceErrorStatus("notReadable" /* NotReadable */));
      } else if (evt.error.name === "NotAllowedError") {
        dispatch(setDeviceErrorStatus("permissionError" /* PermissionError */));
      } else if (confirm("Something went wrong. Please reload the page.")) {
        window.location.reload();
      }
    },
    onSuccess: () => {
      dispatch(setDeviceErrorStatus(void 0));
    }
  });
}

// src/components/VideoRecorder/Loading.tsx
var import_react_i18next6 = require("react-i18next");

// src/components/VideoRecorder/LoadingDevice.tsx
var import_react53 = __toESM(require("react"));
var import_classnames27 = __toESM(require("classnames"));
var import_react_fontawesome4 = require("@fortawesome/react-fontawesome");
function LoadingDevice({
  name,
  faIcon,
  className,
  status = "loading" /* Loading */
}) {
  const icon = (0, import_react53.useMemo)(() => {
    switch (status) {
      case "loading" /* Loading */:
        return faSpinner;
      case "success" /* Success */:
        return faCheck;
      case "error" /* Error */:
      default:
        return faTimes;
    }
  }, [status]);
  return /* @__PURE__ */ import_react53.default.createElement("div", { className: (0, import_classnames27.default)("v2-flex v2-flex-col v2-items-center", className) }, /* @__PURE__ */ import_react53.default.createElement("div", { className: "v2-h-30 v2-w-30 v2-bg-neutral-100 v2-rounded-full v2-p-5 v2-relative v2-flex v2-flex-col v2-items-center" }, /* @__PURE__ */ import_react53.default.createElement(
    import_react_fontawesome4.FontAwesomeIcon,
    {
      icon: faIcon,
      className: (0, import_classnames27.default)("v2-text-[5em]", {
        "v2-animate-pulse v2-text-neutral-300": status === "loading" /* Loading */,
        "v2-text-red": status === "error" /* Error */,
        "v2-text-green-400": status === "success" /* Success */
      })
    }
  ), /* @__PURE__ */ import_react53.default.createElement(
    import_react_fontawesome4.FontAwesomeIcon,
    {
      className: (0, import_classnames27.default)(
        "v2-absolute v2-top-2 v2-right-[-15px] v2-text-[3em] v2-text-shadow",
        {
          "v2-animate-spin v2-text-neutral-500": status === "loading" /* Loading */,
          "v2-text-red": status === "error" /* Error */,
          "v2-text-green-400": status === "success" /* Success */
        }
      ),
      icon
    }
  )), /* @__PURE__ */ import_react53.default.createElement("div", { className: "v2-p-2.5" }, name));
}

// src/components/VideoRecorder/Loading.tsx
var import_partial2 = __toESM(require_partial());
var import_classnames28 = __toESM(require("classnames"));
function getLoadingDeviceStatus(status, devices) {
  if (status === "success") {
    return devices.length > 0 ? "success" /* Success */ : "error" /* Error */;
  }
  return "loading" /* Loading */;
}
function Loading(_a) {
  var _b = _a, {
    children,
    className,
    loadingError: LoadingError2 = LoadingError,
    onPermissionError,
    deviceErrorStatus
  } = _b, otherProps = __objRest(_b, [
    "children",
    "className",
    "loadingError",
    "onPermissionError",
    "deviceErrorStatus"
  ]);
  const { t } = (0, import_react_i18next6.useTranslation)();
  const [isUserMediaLoaded, setIsUserMediaLoaded] = (0, import_react54.useState)(false);
  const {
    isSuccess: hasFinished,
    refetch: refetchDevices,
    status
  } = useDevices();
  const { data: audioDevices } = useAudioDevices();
  const audioStatus = (0, import_react54.useMemo)(
    (0, import_partial2.default)(getLoadingDeviceStatus, status, audioDevices != null ? audioDevices : []),
    [status, audioDevices]
  );
  const { data: videoDevices } = useVideoDevices();
  const videoStatus = (0, import_react54.useMemo)(
    (0, import_partial2.default)(getLoadingDeviceStatus, status, videoDevices != null ? videoDevices : []),
    [status, videoDevices]
  );
  const deviceError = (0, import_react54.useMemo)(
    () => [videoStatus, audioStatus].includes("error" /* Error */),
    [videoStatus, audioStatus]
  );
  (0, import_react54.useEffect)(() => {
    const initGetUserMedia = () => __async(this, null, function* () {
      const hasPermission = yield hasUserMediaPermission();
      setIsUserMediaLoaded(hasPermission);
      if (!hasPermission) {
        onPermissionError == null ? void 0 : onPermissionError();
      }
    });
    void initGetUserMedia();
  }, []);
  useMediaStreamErrorHandler();
  (0, import_react54.useEffect)(() => {
    void refetchDevices();
  }, [isUserMediaLoaded]);
  const [, clearInterval2] = (0, import_beautiful_react_hooks.useInterval)(refetchDevices, 3e3);
  (0, import_react54.useEffect)(() => {
    if (hasFinished || deviceError) {
      clearInterval2();
    }
  }, [hasFinished, videoStatus, audioStatus]);
  if (hasFinished && deviceError || deviceErrorStatus) {
    return /* @__PURE__ */ import_react54.default.createElement(LoadingError2, __spreadProps(__spreadValues({}, otherProps), { errorType: deviceErrorStatus }));
  }
  if (hasFinished && !deviceError && isUserMediaLoaded) {
    return /* @__PURE__ */ import_react54.default.createElement(import_react54.default.Fragment, null, children);
  }
  return /* @__PURE__ */ import_react54.default.createElement(
    "div",
    {
      className: (0, import_classnames28.default)(
        className,
        "v2-flex v2-flex-col v2-items-center v2-justify-center",
        "v2-bg-white v2-h-full v2-space-y-4"
      )
    },
    /* @__PURE__ */ import_react54.default.createElement("h3", { className: "v2-text-center" }, t("videoRecorder:loadingState.header")),
    /* @__PURE__ */ import_react54.default.createElement("div", { className: "v2-flex v2-space-x-8" }, /* @__PURE__ */ import_react54.default.createElement(
      LoadingDevice,
      {
        name: t("videoRecorder:loadingState.audio"),
        faIcon: faMicrophone,
        status: audioStatus
      }
    ), /* @__PURE__ */ import_react54.default.createElement(
      LoadingDevice,
      {
        name: t("videoRecorder:loadingState.video"),
        faIcon: faWebcam,
        status: videoStatus
      }
    ))
  );
}

// src/components/VideoRecorder/Recorder.tsx
var import_react_i18next7 = require("react-i18next");
var rootDimensionsClassNames = [
  "v2-min-h-[min(100vw,100vh)] v2-min-w-[min(100vw,100vh)]",
  "md:v2-min-h-0 md:v2-min-w-0"
];
var Recorder = import_react55.default.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      manualUpload,
      showBonjoroBadge = false,
      onBackClick,
      onResetClick,
      onSettingsClick,
      onSettingsClose,
      onReplayClick,
      onRecordingComplete,
      onRecorderStateChange,
      debug = false,
      height = 450,
      width = 450,
      className,
      containerClassName,
      loadingClassName,
      videoPaneClassName,
      onInit,
      hideMirror = false,
      hideCountdownTimer = false,
      hideAudioIndicator = false,
      mirrorClassName,
      countdownTimerClassName,
      audioIndicatorClassName
    } = _b, props = __objRest(_b, [
      "manualUpload",
      "showBonjoroBadge",
      "onBackClick",
      "onResetClick",
      "onSettingsClick",
      "onSettingsClose",
      "onReplayClick",
      "onRecordingComplete",
      "onRecorderStateChange",
      "debug",
      "height",
      "width",
      "className",
      "containerClassName",
      "loadingClassName",
      "videoPaneClassName",
      "onInit",
      "hideMirror",
      "hideCountdownTimer",
      "hideAudioIndicator",
      "mirrorClassName",
      "countdownTimerClassName",
      "audioIndicatorClassName"
    ]);
    const [isRecorderSettingsOpen, setIsRecorderSettingsOpen] = (0, import_react55.useState)(false);
    const { dispatch, state } = (0, import_react55.useContext)(VideoRecorderContext_default);
    const deviceErrorStatus = (0, import_react55.useMemo)(
      () => getDeviceErrorStatus(state),
      [state.deviceErrorStatus]
    );
    const recorderState = (0, import_react55.useMemo)(
      () => state.recorderState,
      [state.recorderState]
    );
    const setRecorderState2 = (0, import_react55.useCallback)(
      (recorderState2) => dispatch(setRecorderState(recorderState2)),
      [dispatch]
    );
    const [externalVideo, setExternalVideo] = (0, import_react55.useState)();
    (0, import_react55.useEffect)(() => {
      setExternalVideo(manualUpload);
    }, [manualUpload]);
    (0, import_react55.useEffect)(() => {
      if (externalVideo) {
        dispatch(loadExternalVideo(externalVideo));
        setExternalVideo(void 0);
      }
    }, [externalVideo, recorderState]);
    const { data: audioDevice } = useAudioDevice();
    const { data: videoDevice } = useVideoDevice();
    const videoRef = (0, import_react55.useRef)();
    (0, import_react55.useEffect)(() => {
      if (props.videoRef) {
        props.videoRef.current = videoRef.current;
      }
    }, [videoRef.current]);
    (0, import_react55.useEffect)(() => {
      var _a2;
      onRecorderStateChange == null ? void 0 : onRecorderStateChange(recorderState);
      if (recorderState === RecorderState_default.Complete && onRecordingComplete) {
        const data = getBlob(state);
        const thumbnails = getThumbnails(state);
        let metadata = getMetadata(state);
        metadata = __spreadProps(__spreadValues({}, metadata), {
          type: data.type,
          sizeInBytes: data.size
        });
        const duration = (_a2 = videoRef.current) == null ? void 0 : _a2.duration;
        if (duration && isFinite(duration)) {
          metadata.duration = duration;
        }
        dispatch(setMetadata(metadata));
        onRecordingComplete(data, thumbnails, metadata);
      }
    }, [recorderState]);
    const handleOnResetClick = (0, import_react55.useCallback)(() => {
      dispatch(init());
      if (manualUpload) {
        onBackClick == null ? void 0 : onBackClick();
      }
      onResetClick == null ? void 0 : onResetClick();
    }, [onBackClick, onResetClick]);
    const handleBackClick = (0, import_react55.useCallback)(() => {
      onBackClick == null ? void 0 : onBackClick();
      dispatch(removeLoadedVideo());
    }, [onBackClick]);
    const handleSettingsClick = (0, import_react55.useCallback)(() => {
      setIsRecorderSettingsOpen(true);
      onSettingsClick == null ? void 0 : onSettingsClick();
    }, [onSettingsClick]);
    const handleSettingsClose = (0, import_react55.useCallback)(
      (videoDevice2, audioDevice2) => {
        setIsRecorderSettingsOpen(false);
        onSettingsClose == null ? void 0 : onSettingsClose(videoDevice2 != null ? videoDevice2 : void 0, audioDevice2 != null ? audioDevice2 : void 0);
      },
      [videoDevice, audioDevice]
    );
    (0, import_react55.useEffect)(() => {
      if (recorderState === RecorderState_default.Playing) {
        onReplayClick == null ? void 0 : onReplayClick();
      }
    }, [recorderState]);
    const LoadingError2 = onBackClick ? (0, import_react55.useCallback)(createCustomLoadingError(handleBackClick), []) : void 0;
    const showActionButton = recorderState !== RecorderState_default.GenerateThumbnails && !isRecorderSettingsOpen;
    const showDeleteButton = recorderState === RecorderState_default.Playing || recorderState === RecorderState_default.Complete;
    const { t } = (0, import_react_i18next7.useTranslation)();
    const childrenRecorder = (0, import_react55.useMemo)(() => {
      return /* @__PURE__ */ import_react55.default.createElement(
        "div",
        {
          className: (0, import_classnames29.default)(
            containerClassName,
            "v2-relative v2-h-full v2-w-full v2-overflow-hidden"
          )
        },
        showActionButton && onBackClick && /* @__PURE__ */ import_react55.default.createElement(
          ActionButton,
          {
            className: "v2-absolute v2-top-5 v2-left-5 v2-z-50",
            icon: showDeleteButton ? faTrash : faArrowLeft,
            label: showDeleteButton ? t("videoRecorder:buttons.delete") : t("videoRecorder:buttons.back"),
            onClick: handleBackClick
          }
        ),
        showBonjoroBadge && RecorderState_default.Complete !== recorderState && /* @__PURE__ */ import_react55.default.createElement("a", { href: "/", target: "_blank", rel: "noopener noreferrer" }, /* @__PURE__ */ import_react55.default.createElement(
          "img",
          {
            className: "v2-block v2-absolute v2-z-50 v2-right-0 v2-w-28",
            src: assetUrl("video-recorder/poweredby-bonjoro-dark.svg")
          }
        )),
        /* @__PURE__ */ import_react55.default.createElement("div", { className: "recorder-container !v2-w-full !v2-h-full !v2-pb-0 !v2-rounded-none" }, /* @__PURE__ */ import_react55.default.createElement(
          VideoRecorder_default,
          {
            ref,
            videoRef,
            setRecorderState: setRecorderState2,
            recorderState,
            resetButton: /* @__PURE__ */ import_react55.default.createElement(
              ActionButton,
              {
                className: "v2-ml-auto",
                icon: faUndo,
                label: t("videoRecorder:buttons.redo"),
                onClick: handleOnResetClick
              }
            ),
            videoPaneClassName: (0, import_classnames29.default)(
              videoPaneClassName,
              "v2-w-full !v2-rounded-none"
            ),
            alignResetButtonToRight: true,
            hideVideoButtons: recorderState === RecorderState_default.GenerateThumbnails,
            onSettingsClick: handleSettingsClick,
            onSettingsClose: handleSettingsClose,
            debug,
            onInit,
            hideMirror,
            hideCountdownTimer,
            hideAudioIndicator,
            mirrorClassName,
            countdownTimerClassName,
            audioIndicatorClassName
          }
        ))
      );
    }, [
      recorderState,
      setRecorderState2,
      manualUpload,
      showActionButton,
      showDeleteButton,
      showBonjoroBadge,
      handleBackClick,
      handleOnResetClick,
      handleSettingsClick,
      handleSettingsClose,
      debug,
      ref
    ]);
    return /* @__PURE__ */ import_react55.default.createElement(
      "div",
      {
        className: (0, import_classnames29.default)(
          "v2-bg-white v2-left-0 v2-top-0 v2-z-40 v2-w-full md:v2-h-full md:v2-relative md:v2-rounded-none v2-overflow-hidden",
          rootDimensionsClassNames,
          className
        ),
        style: { height, width }
      },
      manualUpload ? childrenRecorder : /* @__PURE__ */ import_react55.default.createElement(
        Loading,
        {
          loadingError: LoadingError2,
          deviceErrorStatus,
          className: loadingClassName
        },
        childrenRecorder
      )
    );
  }
);
Recorder.displayName = "Recorder";
var Recorder_default = Recorder;

// src/components/VideoRecorder/MaybeQueryClientProvider.tsx
var import_react56 = __toESM(require("react"));
var import_react_query3 = require("react-query");
function MaybeQueryClientProvider({
  createQueryClient = false,
  children
}) {
  const queryClientRef = (0, import_react56.useRef)(
    createQueryClient ? new import_react_query3.QueryClient() : void 0
  );
  if (queryClientRef.current) {
    return /* @__PURE__ */ import_react56.default.createElement(import_react_query3.QueryClientProvider, { client: queryClientRef.current }, children);
  }
  return /* @__PURE__ */ import_react56.default.createElement(import_react56.default.Fragment, null, children);
}

// src/components/VideoRecorder/i18n.ts
var import_i18next = __toESM(require("i18next"));
var import_react_i18next8 = require("react-i18next");
var import_i18next_browser_languagedetector = __toESM(require("i18next-browser-languagedetector"));

// src/locales/en/videoRecorder.json
var videoRecorder_default = {
  buttons: {
    back: "Back",
    delete: "Delete",
    redo: "Redo"
  },
  settings: {
    header: "Recorder Settings",
    save: "Save",
    camera: "Camera",
    audio: "Audio",
    select: "Select...",
    quality: {
      high: "High (1080p) (Quality)",
      medium: "Medium (720p) (Recommended)",
      low: "Low (480p) (Performance)"
    }
  },
  loadingState: {
    header: "Loading your devices...",
    video: "Video",
    audio: "Audio"
  },
  loadingError: {
    permission: {
      title: "Camera and microphone permissions are not allowed.",
      body: "Go to your browser settings and allow camera and microphone, then refresh."
    },
    notReadable: {
      title: "Your camera or microphone is being used or blocked by another application.",
      body: "Please close the application and try again or you may select your device below."
    }
  },
  manualUpload: {
    buttonText: "Upload a video",
    errors: {
      fileTypeError: "Invalid Video File. Please select a valid video file.",
      fileSizeError: "File too large. Please only upload files under {{maxFileSize}}MB."
    }
  },
  errors: {
    unsupportedVideoFormat: "Warning!\n\nThe video file you have selected is not supported by your browser. You may continue to upload this video, but you will not be able to review it or select a thumbnail before sending.\n\nTo avoid this warning in the future, please encode your video in a format that is supported by your browser. If you are not sure, reach out to support for help."
  }
};

// src/components/VideoRecorder/i18n.ts
void import_i18next.default.use(import_i18next_browser_languagedetector.default).use(import_react_i18next8.initReactI18next).init({
  debug: true,
  fallbackLng: "en",
  defaultNS: "videoRecorder",
  resources: {
    en: {
      videoRecorder: videoRecorder_default
    }
  }
});
var i18n_default = import_i18next.default;

// src/components/VideoRecorder/VideoRecorderWrapper.tsx
var VideoRecorderWrapper = import_react57.default.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      noCreateQueryClientProvider = false,
      recordingQuality
    } = _b, props = __objRest(_b, [
      "noCreateQueryClientProvider",
      "recordingQuality"
    ]);
    const [state, dispatch] = useRecorderReducer();
    const context = (0, import_react57.useMemo)(() => {
      return {
        state,
        dispatch,
        options: {
          recordingQuality
        }
      };
    }, [state, dispatch]);
    return /* @__PURE__ */ import_react57.default.createElement(import_react_i18next9.I18nextProvider, { i18n: i18n_default }, /* @__PURE__ */ import_react57.default.createElement(VideoRecorderContext_default.Provider, { value: context }, /* @__PURE__ */ import_react57.default.createElement(
      MaybeQueryClientProvider,
      {
        createQueryClient: !noCreateQueryClientProvider
      },
      /* @__PURE__ */ import_react57.default.createElement(Recorder_default, __spreadValues({ ref }, props))
    )));
  }
);
VideoRecorderWrapper.displayName = "VideoRecorder";

// src/components/VideoRecorder/ManualUploadButton.tsx
var import_classnames30 = __toESM(require("classnames"));
var import_react58 = __toESM(require("react"));

// src/utils/isVideoFile.ts
var isVideoFile = (f) => f != null && f.type.match(/^(video|application\/octet-stream)\/.*$/g);
var isVideoFile_default = isVideoFile;

// src/components/VideoRecorder/ManualUploadButton.tsx
function getAcceptedFormats() {
  if (detectBrowser() === "safari") {
    return [
      "video/mp4",
      "video/quicktime",
      "video/3gpp",
      "video/mpeg",
      "video/mpeg2",
      "video/m4v"
    ];
  }
  return ["video/*"];
}
function ManualUploadButton(_a) {
  var _b = _a, {
    children,
    onFileSelected,
    className,
    variant = "icon" /* Icon */,
    disabled = false,
    maxFileSize = 100,
    onFileTypeError,
    onFileSizeError
  } = _b, props = __objRest(_b, [
    "children",
    "onFileSelected",
    "className",
    "variant",
    "disabled",
    "maxFileSize",
    "onFileTypeError",
    "onFileSizeError"
  ]);
  const inputRef = (0, import_react58.useRef)(null);
  const maxFileSizeBytes = (0, import_react58.useMemo)(
    () => maxFileSize * Math.pow(10, 6),
    [maxFileSize]
  );
  const accept = (0, import_react58.useMemo)(() => {
    var _a2;
    if (typeof props.accept === "string") {
      return props.accept;
    }
    return ((_a2 = props.accept) != null ? _a2 : getAcceptedFormats()).join(",");
  }, [props.accept]);
  function handleClick() {
    if (disabled)
      return;
    inputRef.current.value = "";
    inputRef.current.click();
  }
  function handleInputChange(evt) {
    var _a2;
    const file = (_a2 = evt.currentTarget.files) == null ? void 0 : _a2[0];
    if (file == null) {
      return;
    }
    if (!isVideoFile_default(file)) {
      (onFileTypeError != null ? onFileTypeError : alert)(
        i18n_default.t("videoRecorder:manualUpload.errors.fileTypeError")
      );
      return;
    }
    if (file.size > maxFileSizeBytes) {
      (onFileSizeError != null ? onFileSizeError : alert)(
        i18n_default.t("videoRecorder:manualUpload.errors.fileSizeError", {
          maxFileSize
        })
      );
      return;
    }
    onFileSelected(file);
  }
  return /* @__PURE__ */ import_react58.default.createElement(import_react58.default.Fragment, null, /* @__PURE__ */ import_react58.default.createElement(
    "input",
    {
      style: {
        display: "none"
      },
      ref: inputRef,
      accept,
      onChange: handleInputChange,
      type: "file"
    }
  ), /* @__PURE__ */ import_react58.default.createElement(
    Button,
    __spreadProps(__spreadValues({}, props), {
      variant,
      onClick: handleClick,
      className: (0, import_classnames30.default)(className, "v2-font-bold"),
      disabled
    }),
    children != null ? children : i18n_default.t("videoRecorder:manualUpload.buttonText")
  ));
}
/*! Bundled license information:

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)
*/
